webpackJsonp([15],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = render;
	
	var _language = __webpack_require__(17);
	
	var _Content = __webpack_require__(38);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _ContextWrapper = __webpack_require__(33);
	
	var _ContextWrapper2 = _interopRequireDefault(_ContextWrapper);
	
	var _htmlEntities = __webpack_require__(37);
	
	var _getApplication = __webpack_require__(39);
	
	var _getApplication2 = _interopRequireDefault(_getApplication);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* globals __resourceQuery:false */
	// To be used only with webpack. Give path to the component to render as query
	// ie: require("./simple?../js/entry/home")
	var components = __webpack_require__(928); /**
	                                                      * Copyright 2013-present, Novivia, Inc.
	                                                      * All rights reserved.
	                                                      */
	
	var Application = (0, _getApplication2.default)(components.Application);
	
	// Function to render in the frontend.
	function render() {
	  var decodedAuctionEx = (0, _htmlEntities.decode)(AuctionEx);
	
	  _reactDom2.default.render(_react2.default.createElement(
	    _ContextWrapper2.default,
	    { __: _language.__ },
	    _react2.default.createElement(
	      Application,
	      decodedAuctionEx,
	      _react2.default.createElement(_Content2.default, { auctionEx: decodedAuctionEx, components: components })
	    )
	  ), document.getElementById("page-body"));
	}
	
	render();
	module.exports = exports["default"];

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _freeze = __webpack_require__(112);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright 2013-present, Novivia, Inc.
	 * All rights reserved.
	 */
	
	/**
	 * Enumeration of values. Often used to describle possible values of a state
	 * variable.
	 */
	var Enum = function () {
	  function Enum(values /*: string[]*/) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, Enum);
	
	    this._values = values;
	    this.length = this._values.length;
	    this._values.forEach(function (value, index) {
	      return _this[value] = index;
	    });
	
	    (0, _freeze2.default)(this);
	  }
	
	  /**
	   * Returns the maximum possible value for the Enum.
	   * @return Biggest value in the Enum. (Last one)
	   */
	
	
	  (0, _createClass3.default)(Enum, [{
	    key: "getMax",
	    value: function getMax() /*: number*/ {
	      return this.length - 1;
	    }
	
	    /**
	     * Get the strings that constitute the Enum.
	     * @return The original Array provided to create the Enum.
	     */
	
	  }, {
	    key: "getList",
	    value: function getList() /*: string[]*/ {
	      return this._values;
	    }
	
	    /**
	     * Returns the mapping between the original Array provided to create the Enum
	     * and the associated numerical value.
	     * @return A map from strings to numbers.
	     */
	
	  }, {
	    key: "getMapping",
	    value: function getMapping() /*: {[id:string]: number}*/ {
	      var _this2 = this;
	
	      return this._values.reduce(function (values, value) {
	        values[value] = _this2[value];
	
	        return values;
	      }, {});
	    }
	  }, {
	    key: "getValues",
	
	
	    /**
	     * Returns the list of possible numerical values for the Enum.
	     * @return All possible numerical value for the Enum.
	     */
	    value: function getValues() /*: number[]*/ {
	      var _this3 = this;
	
	      return this._values.map(function (value) {
	        return _this3[value];
	      });
	    }
	  }]);
	  return Enum;
	}();
	
	exports.default = Enum;
	module.exports = exports["default"];

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Novivia, Inc.
	 * All rights reserved.
	 */
	
	/**
	 * A module aggregating configurations for all modules and Node services.
	 * @module configurations
	 */
	
	"use strict";
	
	/** @requires configurations/common */
	
	var common = __webpack_require__(75);
	
	if (true) {
	  module.exports = common;
	} else {
	  module.exports = {
	    common: common
	  };
	}

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3.default)(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3.default)(this, PageHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Levels of subscriptions for organizations
	// AE_ORGANIZATION_SUBSCRIPTION_LEVEL
	exports.default = new _Enum2.default(["BASIC", "PREMIUM"]); /**
	                                                             * Copyright 2013-present, Novivia, Inc.
	                                                             * All rights reserved.
	                                                             */
	
	module.exports = exports["default"];

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(34);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(35);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes2.default.string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2.default.func
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3.default)(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3.default)(this, FormControl);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        bsSize = _props.bsSize,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({ bsClass: 'input' }, size)] = true;
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2.default.Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2.default;
	FormControl.Static = _FormControlStatic2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(16);
	
	var _ValidComponentChildren = __webpack_require__(87);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes2.default.string,
	  validationState: _propTypes2.default.oneOf(['success', 'warning', 'error', null])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _propTypes2.default.object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3.default)(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3.default)(this, FormGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2.default.some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2.default.Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Glyphicon = __webpack_require__(95);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3.default)(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3.default)(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2.default.createElement(_Glyphicon2.default, (0, _extends3.default)({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2.default.Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3.default)(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3.default)(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2.default.Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  horizontal: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3.default)(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3.default)(this, Form);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2.default.Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Bid mode of an Auction.
	// See https://confluence.novivia.com/display/AUEX/Entities#Entities-Auctions
	// AE_AUCTION_BID_MODE
	exports.default = new _Enum2.default(["NONE", "STANDARD", "SILENT"]); /**
	                                                                       * Copyright 2013-present, Novivia, Inc.
	                                                                       * All rights reserved.
	                                                                       */
	
	module.exports = exports["default"];

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Types of user actions in a live auction.
	// AE_AUCTION_LIVE_ACTION_TYPE
	exports.default = new _Enum2.default(["AUCTION_CANCEL", "AUCTION_FINALIZE", "AUCTION_JOIN", "AUCTION_LOAD", "AUCTION_PAUSE", "AUCTION_RESUME", "AUCTION_START", "LOT_ASK_AMOUNT", "LOT_CANCEL", "LOT_CLOSE", "LOT_JUMP", "LOT_MAKE_BID", "LOT_OPEN", "LOT_SELL", "LOT_START_CLOSING", "LOT_UNDO_BID", "MESSAGE", "REPLACE_WITH_FLOOR_BID"]); /**
	                                                                                                                                                                                                                                                                                                                                              * Copyright 2013-present, Novivia, Inc.
	                                                                                                                                                                                                                                                                                                                                              * All rights reserved.
	                                                                                                                                                                                                                                                                                                                                              */
	
	module.exports = exports["default"];

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Source of a bid in a live auction.
	// AE_AUCTION_LIVE_BID_SOURCE
	exports.default = new _Enum2.default(["PREBID", "MAXIMUM", "USER", "FLOOR"]); /**
	                                                                               * Copyright 2013-present, Novivia, Inc.
	                                                                               * All rights reserved.
	                                                                               */
	
	module.exports = exports["default"];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Status of the current lot in a live auction.
	// AE_AUCTION_LIVE_BID_STATUS
	exports.default = new _Enum2.default(["NOT_STARTED", "ONGOING", "CLOSING", "CLOSED", "SOLD", "CANCELLED"]); /**
	                                                                                                             * Copyright 2013-present, Novivia, Inc.
	                                                                                                             * All rights reserved.
	                                                                                                             */
	
	module.exports = exports["default"];

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Types of backend events in a live auction.
	// AE_AUCTION_LIVE_EVENT_TYPE
	exports.default = new _Enum2.default(["AUCTION_LOADED", "AUCTION_STARTED", "AUCTION_PAUSED", "AUCTION_RESUMED", "AUCTION_ENDED", "AUCTION_CANCELLED", "LOT_CANCELLED", "LOT_SKIPPED", "LOT_CHANGED", "LOT_ASKED", "LOT_OPENED", "LOT_BID_RECEIVED", "LOT_BID_UNDONE", "LOT_CLOSING", "LOT_CLOSED", "LOT_REOPENED", "LOT_SOLD", "MESSAGE", "LOT_BID_REPLACED"]); /**
	                                                                                                                                                                                                                                                                                                                                                                 * Copyright 2013-present, Novivia, Inc.
	                                                                                                                                                                                                                                                                                                                                                                 * All rights reserved.
	                                                                                                                                                                                                                                                                                                                                                                 */
	
	module.exports = exports["default"];

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Types of log entries in a live auction report.
	// AE_AUCTION_LIVE_LOG_ENTRY_TYPE
	exports.default = new _Enum2.default(["ACTION", "EVENT"]); /**
	                                                            * Copyright 2013-present, Novivia, Inc.
	                                                            * All rights reserved.
	                                                            */
	
	module.exports = exports["default"];

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Available user roles for a live auction.
	// AE_AUCTION_LIVE_ROLE
	exports.default = new _Enum2.default(["MONITOR", "USER", "AUCTIONEER", "ADMINISTRATOR"]); /**
	                                                                                           * Copyright 2013-present, Novivia, Inc.
	                                                                                           * All rights reserved.
	                                                                                           */
	
	module.exports = exports["default"];

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Auction status of a live auction.
	// AE_AUCTION_LIVE_STATUS
	exports.default = new _Enum2.default(["WAITING", "ONGOING", "PAUSED", "FINISHED", "CANCELLED"]); /**
	                                                                                                  * Copyright 2013-present, Novivia, Inc.
	                                                                                                  * All rights reserved.
	                                                                                                  */
	
	module.exports = exports["default"];

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Available actions to transition the auction status of a live auction.
	// AE_AUCTION_LIVE_STATUS_CHANGE
	exports.default = new _Enum2.default(["START", "PAUSE", "RESUME", "CANCEL", "FINALIZE"]); /**
	                                                                                           * Copyright 2013-present, Novivia, Inc.
	                                                                                           * All rights reserved.
	                                                                                           */
	
	module.exports = exports["default"];

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Live type of an Auction.
	// See https://confluence.novivia.com/display/AUEX/Entities#Entities-Auctions
	// AE_AUCTION_LIVE_TYPE
	exports.default = new _Enum2.default(["NONE", "CONTROLLED", "AUTOMATIC"]); /**
	                                                                            * Copyright 2013-present, Novivia, Inc.
	                                                                            * All rights reserved.
	                                                                            */
	
	module.exports = exports["default"];

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Types of updates a live auction can receive.
	// AE_AUCTION_LIVE_UPDATE_TYPE
	exports.default = new _Enum2.default(["EVENT_UPDATE"]); /**
	                                                         * Copyright 2013-present, Novivia, Inc.
	                                                         * All rights reserved.
	                                                         */
	
	module.exports = exports["default"];

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Status of an Auction.
	// See https://confluence.novivia.com/display/AUEX/Entities#Entities-Auctions
	// AE_AUCTION_STATUS
	exports.default = new _Enum2.default(["UNPUBLISHED", "PUBLISHED", "BIDDING", "BIDDING_OVER", "ONGOING", "FINISHED", "CANCELLED"]); /**
	                                                                                                                                    * Copyright 2013-present, Novivia, Inc.
	                                                                                                                                    * All rights reserved.
	                                                                                                                                    */
	
	module.exports = exports["default"];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Type of an Auction.
	// See https://confluence.novivia.com/display/AUEX/Entities#Entities-Auctions
	// AE_AUCTION_TYPE
	exports.default = new _Enum2.default(["EVENT", "STRETCH"]); /**
	                                                             * Copyright 2013-present, Novivia, Inc.
	                                                             * All rights reserved.
	                                                             */
	
	module.exports = exports["default"];

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Sources of Bid.
	// AE_BID_SOURCES
	exports.default = new _Enum2.default(["USER", "USER_LIVE", "MAXIMUM", "CONTROLLER"]); /**
	                                                                                       * Copyright 2013-present, Novivia, Inc.
	                                                                                       * All rights reserved.
	                                                                                       */
	
	module.exports = exports["default"];

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Types of Bid.
	// AE_BID_TYPES
	exports.default = new _Enum2.default(["STANDARD", "MAXIMUM"]); /**
	                                                                * Copyright 2013-present, Novivia, Inc.
	                                                                * All rights reserved.
	                                                                */
	
	module.exports = exports["default"];

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * Copyright 2013-present, Novivia, Inc.
	 * All rights reserved.
	 */
	
	// Main business address of Novivia / Auctionex HQ
	// AE_BUSINESS_CONTACT
	exports.default = {
	    address: ["1982 Beaubien E"],
	    city: "Montréal",
	    region: "Québec",
	    postalCode: "H2G 1M1",
	    country: "Canada",
	    telephone: "+1-514-700-2050",
	    tollFree: "1-855-465-0525"
	};
	module.exports = exports["default"];

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(18);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _canadianSalesTax = __webpack_require__(79);
	
	var _canadianSalesTax2 = _interopRequireDefault(_canadianSalesTax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Canadian sales taxes
	// AE_CANADIAN_TAXES
	/**
	 * Copyright 2013-present, Novivia, Inc.
	 * All rights reserved.
	 */
	
	exports.default = _lodash2.default.transform(_canadianSalesTax2.default, function (result, region, key) {
	  result[key] = {
	    name: region.name,
	    taxes: _lodash2.default.map(region.taxes, function (tax) {
	      return {
	        code: tax.code,
	        tax: tax.tax,
	        // Sales taxes in Canada are always a percentage.
	        percentage: true
	      };
	    })
	  };
	});
	module.exports = exports["default"];

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Possible statuses for a remote connection.
	// AE_CONNECTION_STATUS
	exports.default = new _Enum2.default(["NOT_CONNECTED", "CONNECTING", "TIMED_OUT", "CONNECTED", "DISCONNECTED", "RECONNECTING", "RECONNECTED", "TERMINATED"]); /**
	                                                                                                                                                               * Copyright 2013-present, Novivia, Inc.
	                                                                                                                                                               * All rights reserved.
	                                                                                                                                                               */
	
	module.exports = exports["default"];

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Types of contact inquiry
	// AE_CONTACT_INQUIRY_TYPE
	exports.default = new _Enum2.default(["SALES", "SUPPORT", "BILLING", "MARKETING"]); /**
	                                                                                     * Copyright 2013-present, Novivia, Inc.
	                                                                                     * All rights reserved.
	                                                                                     */
	
	module.exports = exports["default"];

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Source of an event.
	// AE_EVENT_SOURCE
	exports.default = new _Enum2.default(["BACKEND", "FRONTEND"]); /**
	                                                                * Copyright 2013-present, Novivia, Inc.
	                                                                * All rights reserved.
	                                                                */
	
	module.exports = exports["default"];

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Type of a front-end event.
	// AE_FRONTEND_EVENT_TYPE
	exports.default = new _Enum2.default(["INFO", "WARNING", "ERROR"]); /**
	                                                                     * Copyright 2013-present, Novivia, Inc.
	                                                                     * All rights reserved.
	                                                                     */
	
	module.exports = exports["default"];

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Status of an invoice item.
	// AE_INVOICE_ITEM_STATUS
	exports.default = new _Enum2.default(["BILLABLE", "CANCELLED"]); /**
	                                                                  * Copyright 2013-present, Novivia, Inc.
	                                                                  * All rights reserved.
	                                                                  */
	
	module.exports = exports["default"];

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Status of an invoice.
	// AE_INVOICE_STATUS
	exports.default = new _Enum2.default(["DRAFT", "DUE", "OVERDUE", "CANCELLED", "PAID"]); /**
	                                                                                         * Copyright 2013-present, Novivia, Inc.
	                                                                                         * All rights reserved.
	                                                                                         */
	
	module.exports = exports["default"];

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Status of a Lot.
	// AE_LOT_STATUS
	exports.default = new _Enum2.default(["OPEN", "CANCELLED", "SOLD"]); /**
	                                                                      * Copyright 2013-present, Novivia, Inc.
	                                                                      * All rights reserved.
	                                                                      */
	
	module.exports = exports["default"];

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AE_ORGANIZATION_SUBSCRIPTION_LEVEL = __webpack_require__(26);
	
	var _AE_ORGANIZATION_SUBSCRIPTION_LEVEL2 = _interopRequireDefault(_AE_ORGANIZATION_SUBSCRIPTION_LEVEL);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Plans
	// AE_ORGANIZATION_SUBSCRIPTION_PLANS
	exports.default = [{
	  level: _AE_ORGANIZATION_SUBSCRIPTION_LEVEL2.default.BASIC,
	
	  // Monthly cost per currency.
	  price: {
	    USD: 0,
	    CAD: 0
	  },
	
	  // Usage limits.
	  limits: {
	    // Maximum amount of lots per auction.
	    maxLotsPerAuction: 50,
	
	    // Maximum amount of pictures per lot.
	    maxPicturesPerLot: 1
	  }
	}, {
	  level: _AE_ORGANIZATION_SUBSCRIPTION_LEVEL2.default.PREMIUM,
	  price: {
	    USD: 48,
	    CAD: 48
	  },
	  limits: {
	    maxLotsPerAuction: 2500,
	    maxPicturesPerLot: 20
	  }
	}]; /**
	     * Copyright 2013-present, Novivia, Inc.
	     * All rights reserved.
	     */
	
	module.exports = exports["default"];

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Sources of a payments.
	// AE_PAYMENT_SOURCES
	exports.default = new _Enum2.default(["ONSITE", "STRIPE", "PAYPAL"]); /**
	                                                                       * Copyright 2013-present, Novivia, Inc.
	                                                                       * All rights reserved.
	                                                                       */
	
	module.exports = exports["default"];

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Status of a payment.
	// AE_PAYMENT_STATUS
	exports.default = new _Enum2.default(["PENDING", "RECEIVED", "CANCELLED"]); /**
	                                                                             * Copyright 2013-present, Novivia, Inc.
	                                                                             * All rights reserved.
	                                                                             */
	
	module.exports = exports["default"];

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Sources of a payments.
	// AE_PAYMENT_TYPES
	exports.default = new _Enum2.default(["SPECIE", "TRANSFER", "CHEQUE", // A Mari Usque Ad Mare
	"BANKDRAFT", "CERTIFIED_CHEQUE", "MASTERCARD", "VISA", "AMEX"]); /**
	                                                                  * Copyright 2013-present, Novivia, Inc.
	                                                                  * All rights reserved.
	                                                                  */
	
	module.exports = exports["default"];

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Periodicity
	// AE_PERIODICITY
	exports.default = new _Enum2.default(["HOURLY", "DAILY", "WEEKLY", "BIWEEKLY", "MONTHLY", "BIMONTHLY", "QUARTERLY", "YEARLY"]); /**
	                                                                                                                                 * Copyright 2013-present, Novivia, Inc.
	                                                                                                                                 * All rights reserved.
	                                                                                                                                 */
	
	module.exports = exports["default"];

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Scope of a state or information: user level or organization level.
	// AE_SCOPE
	exports.default = new _Enum2.default(["ALL", "USER", "ORGANIZATION"]); /**
	                                                                        * Copyright 2013-present, Novivia, Inc.
	                                                                        * All rights reserved.
	                                                                        */
	
	module.exports = exports["default"];

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Enum = __webpack_require__(5);
	
	var _Enum2 = _interopRequireDefault(_Enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Type of an AuctionEx service.
	// AE_SERVICE_TYPE
	exports.default = new _Enum2.default(["AUCTION_HANDLER"]); /**
	                                                            * Copyright 2013-present, Novivia, Inc.
	                                                            * All rights reserved.
	                                                            */
	
	module.exports = exports["default"];

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright 2013-present, Novivia, Inc.
	 * All rights reserved.
	 */
	
	// Tax numbers of Novivia
	// AE_TAX_NUMBERS
	exports.default = {
	  gst: "828438978 RT 0001",
	  qst: "1221254666 TQ 0001"
	};
	module.exports = exports["default"];

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright 2013-present, Novivia, Inc.
	 * All rights reserved.
	 */
	
	// ISO 4217 currency codes accepted.
	// acceptedCurrencies
	exports.default = ["AUD", "CAD", "EUR", "GBP", "INR", "JPY", "USD"];
	module.exports = exports["default"];

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (country) {
	  return currencyMap[country.toUpperCase()] || currencyMap.USA;
	};
	
	/**
	 * Copyright 2013-present, Novivia, Inc.
	 * All rights reserved.
	 */
	
	// Return the ISO 4217 currency code that AuctionEx uses in a country.
	// You must provide a ISO 3166-1 alpha-3 code.
	// countryCurrency
	
	var currencyMap = {
	  CAN: "CAD",
	  USA: "USD"
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reservedFriendlyIds = exports.paymentCurrencies = exports.acceptedCurrencies = exports.AE_TAX_NUMBERS = exports.AE_SERVICE_TYPE = exports.AE_SCOPE = exports.AE_PERIODICITY = exports.AE_PAYMENT_TYPES = exports.AE_PAYMENT_STATUS = exports.AE_PAYMENT_SOURCES = exports.AE_ORGANIZATION_SUBSCRIPTION_PLANS = exports.AE_ORGANIZATION_SUBSCRIPTION_LEVEL = exports.AE_LOT_STATUS = exports.AE_INVOICE_STATUS = exports.AE_INVOICE_ITEM_STATUS = exports.AE_FRONTEND_EVENT_TYPE = exports.AE_EVENT_SOURCE = exports.AE_CONTACT_INQUIRY_TYPE = exports.AE_CONNECTION_STATUS = exports.AE_CANADIAN_TAXES = exports.AE_BUSINESS_CONTACT = exports.AE_BID_TYPES = exports.AE_BID_SOURCES = exports.AE_AUCTION_TYPE = exports.AE_AUCTION_STATUS = exports.AE_AUCTION_LIVE_UPDATE_TYPE = exports.AE_AUCTION_LIVE_TYPE = exports.AE_AUCTION_LIVE_STATUS_CHANGE = exports.AE_AUCTION_LIVE_STATUS = exports.AE_AUCTION_LIVE_ROLE = exports.AE_AUCTION_LIVE_LOG_ENTRY_TYPE = exports.AE_AUCTION_LIVE_EVENT_TYPE = exports.AE_AUCTION_LIVE_BID_STATUS = exports.AE_AUCTION_LIVE_BID_SOURCE = exports.AE_AUCTION_LIVE_ACTION_TYPE = exports.AE_AUCTION_BID_MODE = exports.countryCurrency = undefined;
	exports.isAuctionOver = isAuctionOver;
	exports.isAuctionReadOnly = isAuctionReadOnly;
	
	var _AE_AUCTION_STATUS2 = __webpack_require__(52);
	
	var _AE_AUCTION_STATUS3 = _interopRequireDefault(_AE_AUCTION_STATUS2);
	
	var _countryCurrency2 = __webpack_require__(74);
	
	var _countryCurrency3 = _interopRequireDefault(_countryCurrency2);
	
	var _AE_AUCTION_BID_MODE2 = __webpack_require__(41);
	
	var _AE_AUCTION_BID_MODE3 = _interopRequireDefault(_AE_AUCTION_BID_MODE2);
	
	var _AE_AUCTION_LIVE_ACTION_TYPE2 = __webpack_require__(42);
	
	var _AE_AUCTION_LIVE_ACTION_TYPE3 = _interopRequireDefault(_AE_AUCTION_LIVE_ACTION_TYPE2);
	
	var _AE_AUCTION_LIVE_BID_SOURCE2 = __webpack_require__(43);
	
	var _AE_AUCTION_LIVE_BID_SOURCE3 = _interopRequireDefault(_AE_AUCTION_LIVE_BID_SOURCE2);
	
	var _AE_AUCTION_LIVE_BID_STATUS2 = __webpack_require__(44);
	
	var _AE_AUCTION_LIVE_BID_STATUS3 = _interopRequireDefault(_AE_AUCTION_LIVE_BID_STATUS2);
	
	var _AE_AUCTION_LIVE_EVENT_TYPE2 = __webpack_require__(45);
	
	var _AE_AUCTION_LIVE_EVENT_TYPE3 = _interopRequireDefault(_AE_AUCTION_LIVE_EVENT_TYPE2);
	
	var _AE_AUCTION_LIVE_LOG_ENTRY_TYPE2 = __webpack_require__(46);
	
	var _AE_AUCTION_LIVE_LOG_ENTRY_TYPE3 = _interopRequireDefault(_AE_AUCTION_LIVE_LOG_ENTRY_TYPE2);
	
	var _AE_AUCTION_LIVE_ROLE2 = __webpack_require__(47);
	
	var _AE_AUCTION_LIVE_ROLE3 = _interopRequireDefault(_AE_AUCTION_LIVE_ROLE2);
	
	var _AE_AUCTION_LIVE_STATUS2 = __webpack_require__(48);
	
	var _AE_AUCTION_LIVE_STATUS3 = _interopRequireDefault(_AE_AUCTION_LIVE_STATUS2);
	
	var _AE_AUCTION_LIVE_STATUS_CHANGE2 = __webpack_require__(49);
	
	var _AE_AUCTION_LIVE_STATUS_CHANGE3 = _interopRequireDefault(_AE_AUCTION_LIVE_STATUS_CHANGE2);
	
	var _AE_AUCTION_LIVE_TYPE2 = __webpack_require__(50);
	
	var _AE_AUCTION_LIVE_TYPE3 = _interopRequireDefault(_AE_AUCTION_LIVE_TYPE2);
	
	var _AE_AUCTION_LIVE_UPDATE_TYPE2 = __webpack_require__(51);
	
	var _AE_AUCTION_LIVE_UPDATE_TYPE3 = _interopRequireDefault(_AE_AUCTION_LIVE_UPDATE_TYPE2);
	
	var _AE_AUCTION_TYPE2 = __webpack_require__(53);
	
	var _AE_AUCTION_TYPE3 = _interopRequireDefault(_AE_AUCTION_TYPE2);
	
	var _AE_BID_SOURCES2 = __webpack_require__(54);
	
	var _AE_BID_SOURCES3 = _interopRequireDefault(_AE_BID_SOURCES2);
	
	var _AE_BID_TYPES2 = __webpack_require__(55);
	
	var _AE_BID_TYPES3 = _interopRequireDefault(_AE_BID_TYPES2);
	
	var _AE_BUSINESS_CONTACT2 = __webpack_require__(56);
	
	var _AE_BUSINESS_CONTACT3 = _interopRequireDefault(_AE_BUSINESS_CONTACT2);
	
	var _AE_CANADIAN_TAXES2 = __webpack_require__(57);
	
	var _AE_CANADIAN_TAXES3 = _interopRequireDefault(_AE_CANADIAN_TAXES2);
	
	var _AE_CONNECTION_STATUS2 = __webpack_require__(58);
	
	var _AE_CONNECTION_STATUS3 = _interopRequireDefault(_AE_CONNECTION_STATUS2);
	
	var _AE_CONTACT_INQUIRY_TYPE2 = __webpack_require__(59);
	
	var _AE_CONTACT_INQUIRY_TYPE3 = _interopRequireDefault(_AE_CONTACT_INQUIRY_TYPE2);
	
	var _AE_EVENT_SOURCE2 = __webpack_require__(60);
	
	var _AE_EVENT_SOURCE3 = _interopRequireDefault(_AE_EVENT_SOURCE2);
	
	var _AE_FRONTEND_EVENT_TYPE2 = __webpack_require__(61);
	
	var _AE_FRONTEND_EVENT_TYPE3 = _interopRequireDefault(_AE_FRONTEND_EVENT_TYPE2);
	
	var _AE_INVOICE_ITEM_STATUS2 = __webpack_require__(62);
	
	var _AE_INVOICE_ITEM_STATUS3 = _interopRequireDefault(_AE_INVOICE_ITEM_STATUS2);
	
	var _AE_INVOICE_STATUS2 = __webpack_require__(63);
	
	var _AE_INVOICE_STATUS3 = _interopRequireDefault(_AE_INVOICE_STATUS2);
	
	var _AE_LOT_STATUS2 = __webpack_require__(64);
	
	var _AE_LOT_STATUS3 = _interopRequireDefault(_AE_LOT_STATUS2);
	
	var _AE_ORGANIZATION_SUBSCRIPTION_LEVEL2 = __webpack_require__(26);
	
	var _AE_ORGANIZATION_SUBSCRIPTION_LEVEL3 = _interopRequireDefault(_AE_ORGANIZATION_SUBSCRIPTION_LEVEL2);
	
	var _AE_ORGANIZATION_SUBSCRIPTION_PLANS2 = __webpack_require__(65);
	
	var _AE_ORGANIZATION_SUBSCRIPTION_PLANS3 = _interopRequireDefault(_AE_ORGANIZATION_SUBSCRIPTION_PLANS2);
	
	var _AE_PAYMENT_SOURCES2 = __webpack_require__(66);
	
	var _AE_PAYMENT_SOURCES3 = _interopRequireDefault(_AE_PAYMENT_SOURCES2);
	
	var _AE_PAYMENT_STATUS2 = __webpack_require__(67);
	
	var _AE_PAYMENT_STATUS3 = _interopRequireDefault(_AE_PAYMENT_STATUS2);
	
	var _AE_PAYMENT_TYPES2 = __webpack_require__(68);
	
	var _AE_PAYMENT_TYPES3 = _interopRequireDefault(_AE_PAYMENT_TYPES2);
	
	var _AE_PERIODICITY2 = __webpack_require__(69);
	
	var _AE_PERIODICITY3 = _interopRequireDefault(_AE_PERIODICITY2);
	
	var _AE_SCOPE2 = __webpack_require__(70);
	
	var _AE_SCOPE3 = _interopRequireDefault(_AE_SCOPE2);
	
	var _AE_SERVICE_TYPE2 = __webpack_require__(71);
	
	var _AE_SERVICE_TYPE3 = _interopRequireDefault(_AE_SERVICE_TYPE2);
	
	var _AE_TAX_NUMBERS2 = __webpack_require__(72);
	
	var _AE_TAX_NUMBERS3 = _interopRequireDefault(_AE_TAX_NUMBERS2);
	
	var _acceptedCurrencies2 = __webpack_require__(73);
	
	var _acceptedCurrencies3 = _interopRequireDefault(_acceptedCurrencies2);
	
	var _paymentCurrencies2 = __webpack_require__(76);
	
	var _paymentCurrencies3 = _interopRequireDefault(_paymentCurrencies2);
	
	var _reservedFriendlyIds2 = __webpack_require__(77);
	
	var _reservedFriendlyIds3 = _interopRequireDefault(_reservedFriendlyIds2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAuctionOver(auction) {
	  if (!auction || !auction.hasOwnProperty("status")) {
	    throw new Error("You need to provide an auction object with a 'status' property.");
	  }
	
	  return auction.status === _AE_AUCTION_STATUS3.default.FINISHED || auction.status === _AE_AUCTION_STATUS3.default.CANCELLED;
	} /**
	   * Copyright 2013-present, Novivia, Inc.
	   * All rights reserved.
	   */
	
	/**
	 * Combinations
	 */
	
	function isAuctionReadOnly(auction) {
	  if (!auction || !auction.hasOwnProperty("status")) {
	    throw new Error("You need to provide an auction object with a 'status' property.");
	  }
	
	  return auction.status === _AE_AUCTION_STATUS3.default.ONGOING || isAuctionOver(auction);
	}
	
	exports.countryCurrency = _countryCurrency3.default;
	
	/**
	 * Exports
	 */
	
	// Enums.
	
	exports.AE_AUCTION_BID_MODE = _AE_AUCTION_BID_MODE3.default;
	exports.AE_AUCTION_LIVE_ACTION_TYPE = _AE_AUCTION_LIVE_ACTION_TYPE3.default;
	exports.AE_AUCTION_LIVE_BID_SOURCE = _AE_AUCTION_LIVE_BID_SOURCE3.default;
	exports.AE_AUCTION_LIVE_BID_STATUS = _AE_AUCTION_LIVE_BID_STATUS3.default;
	exports.AE_AUCTION_LIVE_EVENT_TYPE = _AE_AUCTION_LIVE_EVENT_TYPE3.default;
	exports.AE_AUCTION_LIVE_LOG_ENTRY_TYPE = _AE_AUCTION_LIVE_LOG_ENTRY_TYPE3.default;
	exports.AE_AUCTION_LIVE_ROLE = _AE_AUCTION_LIVE_ROLE3.default;
	exports.AE_AUCTION_LIVE_STATUS = _AE_AUCTION_LIVE_STATUS3.default;
	exports.AE_AUCTION_LIVE_STATUS_CHANGE = _AE_AUCTION_LIVE_STATUS_CHANGE3.default;
	exports.AE_AUCTION_LIVE_TYPE = _AE_AUCTION_LIVE_TYPE3.default;
	exports.AE_AUCTION_LIVE_UPDATE_TYPE = _AE_AUCTION_LIVE_UPDATE_TYPE3.default;
	exports.AE_AUCTION_STATUS = _AE_AUCTION_STATUS3.default;
	exports.AE_AUCTION_TYPE = _AE_AUCTION_TYPE3.default;
	exports.AE_BID_SOURCES = _AE_BID_SOURCES3.default;
	exports.AE_BID_TYPES = _AE_BID_TYPES3.default;
	exports.AE_BUSINESS_CONTACT = _AE_BUSINESS_CONTACT3.default;
	exports.AE_CANADIAN_TAXES = _AE_CANADIAN_TAXES3.default;
	exports.AE_CONNECTION_STATUS = _AE_CONNECTION_STATUS3.default;
	exports.AE_CONTACT_INQUIRY_TYPE = _AE_CONTACT_INQUIRY_TYPE3.default;
	exports.AE_EVENT_SOURCE = _AE_EVENT_SOURCE3.default;
	exports.AE_FRONTEND_EVENT_TYPE = _AE_FRONTEND_EVENT_TYPE3.default;
	exports.AE_INVOICE_ITEM_STATUS = _AE_INVOICE_ITEM_STATUS3.default;
	exports.AE_INVOICE_STATUS = _AE_INVOICE_STATUS3.default;
	exports.AE_LOT_STATUS = _AE_LOT_STATUS3.default;
	exports.AE_ORGANIZATION_SUBSCRIPTION_LEVEL = _AE_ORGANIZATION_SUBSCRIPTION_LEVEL3.default;
	exports.AE_ORGANIZATION_SUBSCRIPTION_PLANS = _AE_ORGANIZATION_SUBSCRIPTION_PLANS3.default;
	exports.AE_PAYMENT_SOURCES = _AE_PAYMENT_SOURCES3.default;
	exports.AE_PAYMENT_STATUS = _AE_PAYMENT_STATUS3.default;
	exports.AE_PAYMENT_TYPES = _AE_PAYMENT_TYPES3.default;
	exports.AE_PERIODICITY = _AE_PERIODICITY3.default;
	exports.AE_SCOPE = _AE_SCOPE3.default;
	exports.AE_SERVICE_TYPE = _AE_SERVICE_TYPE3.default;
	exports.AE_TAX_NUMBERS = _AE_TAX_NUMBERS3.default;
	
	// Lists.
	
	exports.acceptedCurrencies = _acceptedCurrencies3.default;
	exports.paymentCurrencies = _paymentCurrencies3.default;
	exports.reservedFriendlyIds = _reservedFriendlyIds3.default;

/***/ }),

/***/ 76:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright 2013-present, Novivia, Inc.
	 * All rights reserved.
	 */
	
	// ISO 4217 currency codes that AuctionEx accepts to receive payments.
	exports.default = ["CAD", "USD"];
	module.exports = exports["default"];

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(18);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Reserved friendlyIds
	var auctionexReserved = ["auction", "auctionex", "auctions", "live", "liveauctions"];
	
	// Inspired from: http://git.io/vsAX9
	/**
	 * Copyright 2013-present, Novivia, Inc.
	 * All rights reserved.
	 */
	
	var generalReserved = ["about", "aboutus", "abuse", "acme", "ad", "admanager", "admin", "admindashboard", "administrator", "adminpanel", "ads", "adsense", "adult", "adwords", "affiliate", "affiliatepage", "affiliates", "afp", "analytics", "android", "answer", "answers", "ap", "api", "apis", "app", "appengine", "application", "appnews", "apps", "asdf", "asset", "assets", "backup", "bank", "base", "beginners", "beta", "billing", "binaries", "binary", "biz", "blackberry", "blog", "blogs", "blogsearch", "book", "books", "buy", "buzz", "cache", "calendar", "cart", "catalog", "catalogs", "chart", "charts", "chat", "checkout", "ci", "client", "clients", "cname", "cnarne", "code", "community", "confirm", "confirmation", "contact-us", "contact", "contacts", "contactus", "content", "controlpanel", "core", "corp", "countries", "country", "cpanel", "css", "cvs", "dashboard", "data", "demo", "deploy", "deployment", "desktop", "dev", "devel", "developer", "developers", "developers", "development", "dir", "directory", "discussions", "dl", "doc", "docs", "documents", "donate", "download", "downloads", "e", "earth", "email", "enable", "encrypted", "engine", "error", "errorlog", "errors", "features", "features", "feed", "feedburner", "feedproxy", "feeds", "file", "files", "finance", "folder", "folders", "forgotpassword", "forum", "forums", "friend", "friends", "ftp", "ftp", "fuck", "fun", "fusion", "gadget", "gears", "geographic", "gettingstarted", "git", "gmail", "go", "goto", "gov", "graph", "graphs", "group", "groups", "help", "home", "html", "htrnl", "http", "https", "i", "image", "images", "img", "investor", "investors", "invoice", "invoices", "ios", "ipad", "iphone", "irnages", "irng", "items", "job", "jobs", "join", "js", "lab", "labs", "legal", "list", "lists", "local", "locale", "locales", "localhost", "location", "log", "login", "logs", "m", "mail", "manage", "manager", "map", "maps", "marketing", "media", "message", "messages", "misc", "mms", "mobile", "model", "models", "money", "movie", "movies", "my", "mystore", "net", "network", "networks", "new", "news", "newsite", "ns", "ns1", "ns2", "ns3", "ns4", "ns5", "online", "order", "org", "other", "p0rn", "pack", "page", "pages", "panel", "partner", "partnerpage", "partners", "password", "payment", "payments", "people", "person", "places", "podcasts", "pop", "pop3", "popular", "porn", "pr0n", "pricing", "print", "private", "prod", "production", "products", "profile", "profiles", "promo", "promotions", "proxies", "proxy", "public", "purchase", "queries", "radio", "random", "reader", "recover", "redirect", "register", "registration", "release", "reports", "research", "resolve", "resolver", "rnail", "rnicrosoft", "rss", "sale", "sandbox", "scholar", "search", "secure", "seminars", "server", "servers", "service", "service", "services", "shop", "shopping", "shortcut", "shortcuts", "signin", "signup", "sitemap", "sitenews", "sites", "sketchup", "sky", "slash", "slashinvoice", "slut", "sms", "smtp", "soap", "software", "sorry", "spreadsheet", "spreadsheets", "srntp", "ssh", "ssl", "stage", "staging", "staging", "static", "statistics", "stats", "status", "store", "suggest", "suggestqueries", "support", "survey", "surveys", "surveytool", "svn", "sync", "sysadmins", "talk", "talkgadget", "test", "testers", "testing", "text", "tool", "toolbar", "toolbars", "tools", "trac", "translate", "translation", "translator", "trends", "txt", "ul", "upload", "uploads", "uploads", "validation", "validation", "validations", "video-stats", "video", "videos", "videos", "voice", "w", "wave", "webdisk", "webmail", "webmail", "webmaster", "webmaster", "webrnail", "whm", "whois", "wifi", "wiki", "ww", "www", "www1", "www2", "wwww", "xhtml", "xhtrnl", "xml", "xxx"];
	
	exports.default = _lodash2.default.union(generalReserved, auctionexReserved);
	module.exports = exports["default"];

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(80);

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

	module.exports = {"AB":{"name":"Alberta","taxes":[{"code":"GST","name":"Goods and Services Tax","type":"federal","tax":0.05}]},"BC":{"name":"British Columbia","taxes":[{"code":"GST","name":"Goods and Services Tax","type":"federal","tax":0.05},{"code":"PST","name":"Provincial sales tax","type":"provincial","tax":0.07}]},"MB":{"name":"Manitoba","taxes":[{"code":"GST","name":"Goods and Services Tax","type":"federal","tax":0.05},{"code":"PST","name":"Provincial sales tax","type":"provincial","tax":0.08}]},"NB":{"name":"New Brunswick","taxes":[{"code":"HST","name":"Harmonized Sales Tax","type":"harmonized","tax":0.15}]},"NL":{"name":"Newfoundland and Labrador","taxes":[{"code":"HST","name":"Harmonized Sales Tax","type":"harmonized","tax":0.15}]},"NS":{"name":"Nova Scotia","taxes":[{"code":"HST","name":"Harmonized Sales Tax","type":"harmonized","tax":0.15}]},"NT":{"name":"Northwest Territories","taxes":[{"code":"GST","name":"Goods and Services Tax","type":"federal","tax":0.05}]},"NU":{"name":"Nunavut","taxes":[{"code":"GST","name":"Goods and Services Tax","type":"federal","tax":0.05}]},"ON":{"name":"Ontario","taxes":[{"code":"HST","name":"Harmonized Sales Tax","type":"harmonized","tax":0.13}]},"PE":{"name":"Prince Edward Island","taxes":[{"code":"HST","name":"Harmonized Sales Tax","type":"harmonized","tax":0.15}]},"QC":{"name":"Québec","taxes":[{"code":"GST","name":"Goods and Services Tax","type":"federal","tax":0.05},{"code":"QST","name":"Québec Sales Tax","type":"provincial","tax":0.09975}]},"SK":{"name":"Saskatchewan","taxes":[{"code":"GST","name":"Goods and Services Tax","type":"federal","tax":0.05},{"code":"PST","name":"Provincial sales tax","type":"provincial","tax":0.05}]},"YT":{"name":"Yukon","taxes":[{"code":"GST","name":"Goods and Services Tax","type":"federal","tax":0.05}]}}

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(216);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);
	module.exports = exports['default'];

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  striped: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  condensed: _propTypes2.default.bool,
	  hover: _propTypes2.default.bool,
	  responsive: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3.default)(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3.default)(this, Table);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2.default.createElement('table', (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2.default.Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  label: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  label: 'Close'
	};
	
	var CloseButton = function (_React$Component) {
	  (0, _inherits3.default)(CloseButton, _React$Component);
	
	  function CloseButton() {
	    (0, _classCallCheck3.default)(this, CloseButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  CloseButton.prototype.render = function render() {
	    var _props = this.props,
	        label = _props.label,
	        onClick = _props.onClick;
	
	    return _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onClick
	      },
	      _react2.default.createElement(
	        'span',
	        { 'aria-hidden': 'true' },
	        '\xD7'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      )
	    );
	  };
	
	  return CloseButton;
	}(_react2.default.Component);
	
	CloseButton.propTypes = propTypes;
	CloseButton.defaultProps = defaultProps;
	
	exports.default = CloseButton;
	module.exports = exports['default'];

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(85);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3.default)(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3.default)(this, Label);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2.default.Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2.default.createElement(
	      'span',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ }),

/***/ 100:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWindow;
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	module.exports = exports["default"];

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(223);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2.default.func
	};
	
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3.default)(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3.default)(this, Fade);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2.default.createElement(_Transition2.default, (0, _extends3.default)({}, this.props, {
	      className: (0, _classnames2.default)(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2.default.Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports.default = Fade;
	module.exports = exports['default'];

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM2.default) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};
	
	var _inDOM = __webpack_require__(94);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = void 0;
	
	module.exports = exports['default'];

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(100);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(109);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAlternateCurrencies = getAlternateCurrencies;
	exports.getAccountingSettings = getAccountingSettings;
	exports.formatMoney = formatMoney;
	
	var _lodash = __webpack_require__(18);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _language = __webpack_require__(17);
	
	var _utilities = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var number = _utilities.formats.number;
	
	// FIXME: Importing doesn't work because of the front-end short-circuit in that
	// module.
	/**
	 * Copyright 2013-present, Novivia, Inc.
	 * All rights reserved.
	 */
	
	var auexConfigurations = __webpack_require__(21);
	
	function getAlternateCurrencies(currentCurrency) {
	  var upperCurrentCurrency = currentCurrency.toUpperCase();
	
	  return auexConfigurations.paymentCurrencies.filter(function (currency) {
	    return currency !== upperCurrentCurrency;
	  });
	}
	
	function getAccountingSettings(currency) {
	  return _lodash2.default.merge({}, number.getAccountingSettings(currency && currency.toUpperCase()), (0, _language.__)("language::accounting"));
	}
	
	function formatMoney(amount, currency) {
	  return number.formatMoney({
	    amount: amount,
	    settings: getAccountingSettings(currency).currency
	  });
	}

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(83);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(84);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(89);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _LegacyPortal = __webpack_require__(125);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	
	      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
	    }, _this.getMountNode = function () {
	      return _this._portalContainerNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this.setContainer();
	    this.forceUpdate(this.props.onRendered);
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.container !== this.props.container) {
	      this.setContainer(nextProps);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._portalContainerNode = null;
	  };
	
	  Portal.prototype.render = function render() {
	    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(83);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(84);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(89);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
	      if (!_this._overlayTarget) {
	        _this._overlayTarget = document.createElement('div');
	        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
	        _this._portalContainerNode.appendChild(_this._overlayTarget);
	      }
	    }, _this._unmountOverlayTarget = function () {
	      if (_this._overlayTarget) {
	        _this._portalContainerNode.removeChild(_this._overlayTarget);
	        _this._overlayTarget = null;
	      }
	      _this._portalContainerNode = null;
	    }, _this._renderOverlay = function () {
	      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);
	
	      // Save reference for future access.
	      if (overlay !== null) {
	        _this._mountOverlayTarget();
	
	        var initialRender = !_this._overlayInstance;
	
	        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
	          if (initialRender && _this.props.onRendered) {
	            _this.props.onRendered();
	          }
	        });
	      } else {
	        // Unrender if the component is null for transitions to null
	        _this._unrenderOverlay();
	        _this._unmountOverlayTarget();
	      }
	    }, _this._unrenderOverlay = function () {
	      if (_this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
	        _this._overlayInstance = null;
	      }
	    }, _this.getMountNode = function () {
	      return _this._overlayTarget;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  };
	
	  Portal.prototype.render = function render() {
	    return null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = Portal;
	module.exports = exports['default'];

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(137);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(138);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3.default)(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3.default)(this, InputGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2.default.Component);
	
	InputGroup.Addon = _InputGroupAddon2.default;
	InputGroup.Button = _InputGroupButton2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3.default)(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3.default)(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3.default)(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3.default)(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(85);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(248);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _propTypes2.default.bool,
	  onSelect: _propTypes2.default.func,
	  header: _propTypes2.default.node,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  footer: _propTypes2.default.node,
	  defaultExpanded: _propTypes2.default.bool,
	  expanded: _propTypes2.default.bool,
	  eventKey: _propTypes2.default.any,
	  headerRole: _propTypes2.default.string,
	  panelRole: _propTypes2.default.string,
	
	  // From Collapse.
	  onEnter: _propTypes2.default.func,
	  onEntering: _propTypes2.default.func,
	  onEntered: _propTypes2.default.func,
	  onExit: _propTypes2.default.func,
	  onExiting: _propTypes2.default.func,
	  onExited: _propTypes2.default.func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3.default)(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3.default)(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2.default.createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2.default.createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2.default.Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2.default.isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2.default.createElement(
	      _Collapse2.default,
	      (0, _extends3.default)({ 'in': expanded }, animationHooks),
	      _react2.default.createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2.default.isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2.default)(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2.default.isValidElement(header)) {
	      return _react2.default.createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2.default)(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3.default)(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2.default.Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(159), __esModule: true };

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3.default)(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3.default)(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn-toolbar', ButtonToolbar);
	module.exports = exports['default'];

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(226);
	__webpack_require__(219);
	module.exports = __webpack_require__(160);


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(194);
	var get = __webpack_require__(260);
	module.exports = __webpack_require__(108).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(117);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	module.exports = exports['default'];

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasClass = exports.removeClass = exports.addClass = undefined;
	
	var _addClass = __webpack_require__(161);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(163);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _hasClass = __webpack_require__(117);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.addClass = _addClass2.default;
	exports.removeClass = _removeClass2.default;
	exports.hasClass = _hasClass2.default;
	exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filterEvents;
	
	var _contains = __webpack_require__(110);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _querySelectorAll = __webpack_require__(167);
	
	var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll2.default)(top, selector);
	
	    if (matches.some(function (match) {
	      return (0, _contains2.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	module.exports = exports['default'];

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.listen = exports.filter = exports.off = exports.on = undefined;
	
	var _on = __webpack_require__(144);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(147);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _filter = __webpack_require__(164);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _listen = __webpack_require__(166);
	
	var _listen2 = _interopRequireDefault(_listen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.on = _on2.default;
	exports.off = _off2.default;
	exports.filter = _filter2.default;
	exports.listen = _listen2.default;
	exports.default = { on: _on2.default, off: _off2.default, filter: _filter2.default, listen: _listen2.default };

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(94);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _on = __webpack_require__(144);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(147);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listen = function listen() {};
	
	if (_inDOM2.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on2.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off2.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	exports.default = listen;
	module.exports = exports['default'];

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	module.exports = exports['default'];

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */
	
	module.exports = exports['default'];

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(165);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(109);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(94);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(118);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(175);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(120);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(107);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(170);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(171);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(172);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(173);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(174);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(101);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(249);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Modal2.default.propTypes, _ModalDialog2.default.propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes2.default.oneOf(['static', true, false]),
	
	  /**
	   * Add an optional extra class name to .modal-backdrop
	   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes2.default.bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2.default,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * @private
	   */
	  container: _Modal2.default.propTypes.container
	});
	
	var defaultProps = (0, _extends3.default)({}, _Modal2.default.defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2.default
	});
	
	var childContextTypes = {
	  $bs_modal: _propTypes2.default.shape({
	    onHide: _propTypes2.default.func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3.default)(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3.default)(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	    _this.setModalRef = _this.setModalRef.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.setModalRef = function setModalRef(ref) {
	    this._modal = ref;
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2.default.on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2.default.off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2.default) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2.default)(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2.default)(_reactDom2.default.findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2.default)() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2.default)() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        backdropClassName = _props.backdropClassName,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3.default)(_props, ['backdrop', 'backdropClassName', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Modal2.default),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      (0, _extends3.default)({}, baseModalProps, {
	        ref: this.setModalRef,
	        show: show,
	        onEntering: (0, _createChainedFunction2.default)(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2.default)(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2.default)((0, _bootstrapUtils.prefix)(props, 'backdrop'), backdropClassName, inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2.default : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2.default.createElement(
	        Dialog,
	        (0, _extends3.default)({}, dialogProps, {
	          style: (0, _extends3.default)({}, this.state.style, style),
	          className: (0, _classnames2.default)(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2.default;
	Modal.Header = _ModalHeader2.default;
	Modal.Title = _ModalTitle2.default;
	Modal.Footer = _ModalFooter2.default;
	
	Modal.Dialog = _ModalDialog2.default;
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3.default)(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3.default)(this, ModalBody);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes2.default.string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3.default)(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3.default)(this, ModalDialog);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4.default)({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2.default)(className, bsClassName)
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(dialogClassName, dialogClasses) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2.default.Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3.default)(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3.default)(this, ModalFooter);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2.default.Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(101);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _CloseButton = __webpack_require__(96);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * Provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  closeLabel: _propTypes2.default.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes2.default.func
	};
	
	var defaultProps = {
	  closeLabel: 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _propTypes2.default.shape({
	    onHide: _propTypes2.default.func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3.default)(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3.default)(this, ModalHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        closeLabel = _props.closeLabel,
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      closeButton && _react2.default.createElement(_CloseButton2.default, {
	        label: closeLabel,
	        onClick: (0, _createChainedFunction2.default)(modal && modal.onHide, onHide)
	      }),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2.default.Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3.default)(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3.default)(this, ModalTitle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2.default.Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _activeElement = __webpack_require__(328);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(110);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _inDOM = __webpack_require__(94);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(83);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _deprecated = __webpack_require__(168);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ModalManager = __webpack_require__(176);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _Portal = __webpack_require__(124);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _RefHolder = __webpack_require__(177);
	
	var _RefHolder2 = _interopRequireDefault(_RefHolder);
	
	var _addEventListener = __webpack_require__(332);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(178);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _getContainer = __webpack_require__(84);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(89);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Modal.prototype.omitProps = function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container,
	        onRendered: this.onPortalRendered
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: this.setModalNodeRef,
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        _react2.default.createElement(
	          _RefHolder2.default,
	          { ref: this.setDialogRef },
	          dialog
	        )
	      )
	    );
	  };
	
	  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  };
	
	  Modal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _props2 = this.props,
	        show = _props2.show,
	        transition = _props2.transition;
	
	
	    this._isMounted = false;
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  };
	
	  Modal.prototype.autoFocus = function autoFocus() {
	    if (!this.props.autoFocus) {
	      return;
	    }
	
	    var dialogElement = this.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      this.lastFocus = currentActiveElement;
	
	      if (!dialogElement.hasAttribute('tabIndex')) {
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');
	
	        dialogElement.setAttribute('tabIndex', -1);
	      }
	
	      dialogElement.focus();
	    }
	  };
	
	  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  };
	
	  Modal.prototype.getDialogElement = function getDialogElement() {
	    return _reactDom2.default.findDOMNode(this.dialog);
	  };
	
	  Modal.prototype.isTopModal = function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = _extends({}, _Portal2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Modal
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	   *
	   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	   * page content can be placed behind a virtual backdrop as well as a visual one.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * A callback fired when the Modal is opening.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	   *
	   * The `onHide` callback only signals intent from the Modal,
	   * you must actually set the `show` prop to `false` for the Modal to close.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Include a backdrop component.
	   */
	  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),
	
	  /**
	   * A function that returns a backdrop component. Useful for custom
	   * backdrop rendering.
	   *
	   * ```js
	   *  renderBackdrop={props => <MyBackdrop {...props} />}
	   * ```
	   */
	  renderBackdrop: _propTypes2.default.func,
	
	  /**
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   */
	  onEscapeKeyDown: _propTypes2.default.func,
	
	  /**
	   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   * @deprecated
	   */
	  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),
	
	  /**
	   * A callback fired when the backdrop, if specified, is clicked.
	   */
	  onBackdropClick: _propTypes2.default.func,
	
	  /**
	   * A style object for the backdrop component.
	   */
	  backdropStyle: _propTypes2.default.object,
	
	  /**
	   * A css class or classes for the backdrop component.
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * A css class or set of classes applied to the modal container when the modal is open,
	   * and removed when it is closed.
	   */
	  containerClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * A `<Transition/>` component to use for the dialog and backdrop components.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * The `timeout` of the dialog transition if specified. This number is used to ensure that
	   * transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  dialogTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * The `timeout` of the backdrop transition if specified. This number is used to
	   * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  backdropTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes. This also
	   * works correctly with any Modal children that have the `autoFocus` prop.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while open.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * A ModalManager instance used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container
	   */
	  manager: _propTypes2.default.object.isRequired
	});
	Modal.defaultProps = {
	  show: false,
	  backdrop: true,
	  keyboard: true,
	  autoFocus: true,
	  enforceFocus: true,
	  restoreFocus: true,
	  onHide: function onHide() {},
	  manager: modalManager,
	  renderBackdrop: function renderBackdrop(props) {
	    return _react2.default.createElement('div', props);
	  }
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = { exited: !this.props.show };
	
	  this.renderBackdrop = function () {
	    var _props3 = _this2.props,
	        backdropStyle = _props3.backdropStyle,
	        backdropClassName = _props3.backdropClassName,
	        renderBackdrop = _props3.renderBackdrop,
	        Transition = _props3.transition,
	        backdropTransitionTimeout = _props3.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this2.backdrop = ref;
	    };
	
	    var backdrop = renderBackdrop({
	      ref: backdropRef,
	      style: backdropStyle,
	      className: backdropClassName,
	      onClick: _this2.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': _this2.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        backdrop
	      );
	    }
	
	    return backdrop;
	  };
	
	  this.onPortalRendered = function () {
	    _this2.autoFocus();
	
	    if (_this2.props.onShow) {
	      _this2.props.onShow();
	    }
	  };
	
	  this.onShow = function () {
	    var doc = (0, _ownerDocument2.default)(_this2);
	    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);
	
	    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);
	
	    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);
	
	    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);
	
	    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
	  };
	
	  this.onHide = function () {
	    _this2.props.manager.remove(_this2);
	
	    _this2._onDocumentKeydownListener.remove();
	
	    _this2._onDocumentKeyupListener.remove();
	
	    _this2._onFocusinListener.remove();
	
	    if (_this2.props.restoreFocus) {
	      _this2.restoreLastFocus();
	    }
	  };
	
	  this.setMountNode = function (ref) {
	    _this2.mountNode = ref ? ref.getMountNode() : ref;
	  };
	
	  this.setModalNodeRef = function (ref) {
	    _this2.modalNode = ref;
	  };
	
	  this.setDialogRef = function (ref) {
	    _this2.dialog = ref;
	  };
	
	  this.handleHidden = function () {
	    _this2.setState({ exited: true });
	    _this2.onHide();
	
	    if (_this2.props.onExited) {
	      var _props4;
	
	      (_props4 = _this2.props).onExited.apply(_props4, arguments);
	    }
	  };
	
	  this.handleBackdropClick = function (e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (_this2.props.onBackdropClick) {
	      _this2.props.onBackdropClick(e);
	    }
	
	    if (_this2.props.backdrop === true) {
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyDown = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyDown) {
	        _this2.props.onEscapeKeyDown(e);
	      }
	
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyUp = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyUp) {
	        _this2.props.onEscapeKeyUp(e);
	      }
	    }
	  };
	
	  this.checkForFocus = function () {
	    if (_inDOM2.default) {
	      _this2.lastFocus = (0, _activeElement2.default)();
	    }
	  };
	
	  this.enforceFocus = function () {
	    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
	      return;
	    }
	
	    var dialogElement = _this2.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      dialogElement.focus();
	    }
	  };
	};
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class = __webpack_require__(162);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _style = __webpack_require__(152);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _scrollbarSize = __webpack_require__(118);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(120);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function ModalManager() {
	  var _this = this;
	
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	      _ref2$handleContainer = _ref2.handleContainerOverflow,
	      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	  _classCallCheck(this, ModalManager);
	
	  this.add = function (modal, container, className) {
	    var modalIdx = _this.modals.indexOf(modal);
	    var containerIdx = _this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = _this.modals.length;
	    _this.modals.push(modal);
	
	    if (_this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	    }
	
	    if (containerIdx !== -1) {
	      _this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      //right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	
	      overflowing: (0, _isOverflowing2.default)(container)
	    };
	
	    if (_this.handleContainerOverflow) {
	      setContainerStyle(data, container);
	    }
	
	    data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	    _this.containers.push(container);
	    _this.data.push(data);
	
	    return modalIdx;
	  };
	
	  this.remove = function (modal) {
	    var modalIdx = _this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = findContainer(_this.data, modal);
	    var data = _this.data[containerIdx];
	    var container = _this.containers[containerIdx];
	
	    data.modals.splice(data.modals.indexOf(modal), 1);
	
	    _this.modals.splice(modalIdx, 1);
	
	    // if that was the last modal in a container,
	    // clean up the container
	    if (data.modals.length === 0) {
	      data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	      if (_this.handleContainerOverflow) {
	        removeContainerStyle(data, container);
	      }
	
	      if (_this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	      }
	      _this.containers.splice(containerIdx, 1);
	      _this.data.splice(containerIdx, 1);
	    } else if (_this.hideSiblingNodes) {
	      //otherwise make sure the next top modal is visible to a SR
	      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	    }
	  };
	
	  this.isTopModal = function (modal) {
	    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
	  };
	
	  this.hideSiblingNodes = hideSiblingNodes;
	  this.handleContainerOverflow = handleContainerOverflow;
	  this.modals = [];
	  this.containers = [];
	  this.data = [];
	};
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.node
	};
	
	/**
	 * Internal helper component to allow attaching a non-conflicting ref to a
	 * child element that may not accept refs.
	 */
	
	var RefHolder = function (_React$Component) {
	  _inherits(RefHolder, _React$Component);
	
	  function RefHolder() {
	    _classCallCheck(this, RefHolder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RefHolder.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RefHolder;
	}(_react2.default.Component);
	
	RefHolder.propTypes = propTypes;
	
	exports.default = RefHolder;
	module.exports = exports['default'];

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /**
	                    * Copyright 2013-present, Novivia, Inc.
	                    * All rights reserved.
	                    */
	
	var _SocialLoginButton = __webpack_require__(225);
	
	var _SocialLoginButton2 = _interopRequireDefault(_SocialLoginButton);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Social logins.
	 * @class
	 */
	var SocialLogins = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(SocialLogins, _Component);
	
	  function SocialLogins() {
	    (0, _classCallCheck3.default)(this, SocialLogins);
	    return (0, _possibleConstructorReturn3.default)(this, (SocialLogins.__proto__ || (0, _getPrototypeOf2.default)(SocialLogins)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SocialLogins, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.props.socialLogin.map(function (social, index) {
	          return _react2.default.createElement(_SocialLoginButton2.default, {
	            key: index,
	            socialLogin: social,
	            urlToken: _this2.props.urlToken
	          });
	        })
	      );
	    }
	  }]);
	  return SocialLogins;
	}(_react.Component), _class.propTypes = {
	  // Organizations of the social login buttons.
	  socialLogin: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(["google", "facebook", "linkedin"])).isRequired,
	
	  // Token in url query string.
	  urlToken: _propTypes2.default.string
	}, _class.defaultProps = {
	  socialLogin: ["google", "facebook", "linkedin"]
	}, _temp);
	exports.default = SocialLogins;
	module.exports = exports["default"];

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /**
	                    * Copyright 2013-present, Novivia, Inc.
	                    * All rights reserved.
	                    */
	
	var _SocialLogins = __webpack_require__(212);
	
	var _SocialLogins2 = _interopRequireDefault(_SocialLogins);
	
	var _utilities = __webpack_require__(90);
	
	var _utilities2 = _interopRequireDefault(_utilities);
	
	var _Button = __webpack_require__(24);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Form = __webpack_require__(40);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormControl = __webpack_require__(28);
	
	var _FormControl2 = _interopRequireDefault(_FormControl);
	
	var _FormGroup = __webpack_require__(32);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stringToReact = _utilities2.default.formats.stringToReact;
	
	/**
	 * Login form
	 * @class
	 */
	var LoginForm = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(LoginForm, _Component);
	
	  function LoginForm() {
	    (0, _classCallCheck3.default)(this, LoginForm);
	    return (0, _possibleConstructorReturn3.default)(this, (LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoginForm, [{
	    key: "render",
	    value: function render() {
	      var __ = this.context.__;
	
	
	      var queryString = "";
	
	      if (this.props.urlToken) {
	        queryString = "?t=" + this.props.urlToken;
	      }
	
	      return _react2.default.createElement(
	        _Form2.default,
	        {
	          action: "/users/session" + queryString,
	          className: "signin",
	          method: "post",
	          role: "form"
	        },
	        _react2.default.createElement("input", {
	          name: "_csrf",
	          type: "hidden",
	          value: this.props.csrfToken
	        }),
	        _react2.default.createElement(
	          _FormGroup2.default,
	          null,
	          _react2.default.createElement(_FormControl2.default, {
	            "aria-label": __("contact::email"),
	            name: "email",
	            placeholder: __("contact::email"),
	            type: "email",
	            autoFocus: true,
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          _FormGroup2.default,
	          null,
	          _react2.default.createElement(_FormControl2.default, {
	            "aria-label": __("password::password"),
	            name: "password",
	            placeholder: __("password::password"),
	            type: "password",
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            bsSize: "large",
	            bsStyle: "primary",
	            type: "submit",
	            block: true
	          },
	          __("login::header")
	        ),
	        _react2.default.createElement(
	          "label",
	          { className: "forgotpw" },
	          _react2.default.createElement(
	            "a",
	            { href: "/" + __("routes::forgotpw") },
	            __("password::forgotPw.header")
	          )
	        ),
	        _react2.default.createElement(_SocialLogins2.default, {
	          socialLogin: this.props.socialLogin,
	          urlToken: this.props.urlToken
	        }),
	        this.props.registerLink ? _react2.default.createElement(
	          "p",
	          { className: "text-center" },
	          stringToReact(__("login::noAccountRegister"), { registerLink: function registerLink(linkText) {
	              return _react2.default.createElement(
	                "a",
	                { href: "/" + __("routes::signup") },
	                linkText
	              );
	            } })
	        ) : null
	      );
	    }
	  }]);
	  return LoginForm;
	}(_react.Component), _class.propTypes = {
	  // CSRF Token
	  csrfToken: _propTypes2.default.string.isRequired,
	
	  // Display the registration link at bottom of the form.
	  registerLink: _propTypes2.default.bool,
	
	  // Social login buttons to display
	  socialLogin: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(["google", "facebook", "linkedin"])),
	
	  // Token in url query string.
	  urlToken: _propTypes2.default.string
	}, _class.defaultProps = {
	  socialLogin: ["google", "facebook", "linkedin"]
	}, _class.contextTypes = {
	  // Translation utility.
	  __: _propTypes2.default.func.isRequired
	}, _temp);
	exports.default = LoginForm;
	module.exports = exports["default"];

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /**
	                    * Copyright 2013-present, Novivia, Inc.
	                    * All rights reserved.
	                    */
	
	var _Button = __webpack_require__(24);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(30);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Sharing platforms dictionary.
	var socialLogins = {
	  facebook: {
	    style: "facebook",
	    url: "facebook"
	  },
	  google: {
	    style: "google",
	    url: "google"
	  },
	  linkedin: {
	    style: "linkedin",
	    url: "linkedin"
	  }
	};
	
	/**
	 * Social login button
	 * @class
	 */
	var SocialLoginButton = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(SocialLoginButton, _Component);
	
	  function SocialLoginButton() {
	    (0, _classCallCheck3.default)(this, SocialLoginButton);
	    return (0, _possibleConstructorReturn3.default)(this, (SocialLoginButton.__proto__ || (0, _getPrototypeOf2.default)(SocialLoginButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SocialLoginButton, [{
	    key: "render",
	    value: function render() {
	      var __ = this.context.__;
	
	
	      var style = socialLogins[this.props.socialLogin].style;
	      var url = socialLogins[this.props.socialLogin].url;
	
	      var queryString = "";
	
	      if (this.props.urlToken) {
	        queryString = "?t=" + this.props.urlToken;
	      }
	
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          "aria-label": __("login::" + url),
	          bsSize: "large",
	          bsStyle: "primary",
	          className: "btn-social btn-" + style,
	          href: "/auth/" + url + queryString,
	          block: true
	        },
	        _react2.default.createElement(_Icon2.default, { name: style }),
	        " ",
	        __("login::" + url)
	      );
	    }
	  }]);
	  return SocialLoginButton;
	}(_react.Component), _class.propTypes = {
	  // Organization of the social login button.
	  socialLogin: _propTypes2.default.oneOf(["google", "facebook", "linkedin"]).isRequired,
	
	  // Token in url query string.
	  urlToken: _propTypes2.default.string
	}, _class.defaultProps = {
	  socialLogin: ["google"]
	}, _class.contextTypes = {
	  // Translation utility.
	  __: _propTypes2.default.func.isRequired
	}, _temp);
	exports.default = SocialLoginButton;
	module.exports = exports["default"];

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["react-flags"] = factory(require("react"));
		else
			root["react-flags"] = factory(root["React"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1);
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _flagsJson5 = __webpack_require__(3);
	
		var _flagsJson52 = _interopRequireDefault(_flagsJson5);
	
		var _lodashCollectionFind = __webpack_require__(4);
	
		var _lodashCollectionFind2 = _interopRequireDefault(_lodashCollectionFind);
	
		var _filterLoaderCca2Cca3WorldCountriesCountriesJson = __webpack_require__(53);
	
		var _filterLoaderCca2Cca3WorldCountriesCountriesJson2 = _interopRequireDefault(_filterLoaderCca2Cca3WorldCountriesCountriesJson);
	
		exports["default"] = _react2["default"].createClass({
		  displayName: "Flag",
	
		  /**
		   * React properties
		   */
	
		  propTypes: {
		    // Alternative text of the flag <img> HTML tag.
		    alt: _react.PropTypes.string,
	
		    // Base path to the content of /vendor
		    basePath: _react.PropTypes.string,
	
		    // Country or region for this flag. (Legacy)
		    country: _react.PropTypes.string,
	
		    // File format of the flag.
		    format: _react.PropTypes.oneOf(["png", "icns", "ico"]),
	
		    // Height of the flag <img> HTML tag.
		    height: _react.PropTypes.number,
	
		    // Name of country or region for this flag. (Legacy)
		    name: _react.PropTypes.string,
	
		    // Size of the PNG country flag
		    pngSize: _react.PropTypes.oneOf([16, 24, 32, 48, 64]),
	
		    // Shiny or Flat
		    shiny: _react.PropTypes.bool,
	
		    // Width of the flag <img> HTML tag.
		    width: _react.PropTypes.number
		  },
	
		  /**
		   * React lifecycle
		   */
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      basePath: "/img/flags",
	
		      country: "_unknown",
	
		      name: null,
	
		      format: "png",
	
		      pngSize: 32,
	
		      shiny: false,
	
		      width: null,
	
		      height: null,
	
		      alt: null
		    };
		  },
	
		  // Get information about a country using the alpha-3 ISO code.
		  cca3To2: function cca3To2(cca3) {
		    var country = (0, _lodashCollectionFind2["default"])(_filterLoaderCca2Cca3WorldCountriesCountriesJson2["default"], { "cca3": cca3 });
		    return country ? country.cca2 : "_unknown";
		  },
	
		  /**
		   * React render
		   */
	
		  render: function render() {
		    var country = this.props.name ? this.props.name : this.props.country;
	
		    country = country.length === 3 ? this.cca3To2(country) : country;
	
		    var type = this.props.shiny ? "shiny" : "flat";
	
		    var folder = this.props.format === "icns" || this.props.format === "ico" ? this.props.format : this.props.pngSize;
	
		    var altText = this.props.alt ? this.props.alt : country;
	
		    var file = country.charAt(0) === "_" ? country : country.toUpperCase();
	
		    var flag = ~_flagsJson52["default"].flags.indexOf(file) ? file : "_unknown";
	
		    return _react2["default"].createElement("img", {
		      alt: altText,
		      src: this.props.basePath + "/flags-iso/" + type + "/" + folder + "/" + flag + "." + this.props.format,
		      width: this.props.width,
		      height: this.props.height
		    });
		  }
		});
		module.exports = exports["default"];
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = {
			"flags": [
				"_abkhazia",
				"_basque-country",
				"_british-antarctic-territory",
				"_commonwealth",
				"_england",
				"_gosquared",
				"_kosovo",
				"_mars",
				"_nagorno-karabakh",
				"_nato",
				"_northern-cyprus",
				"_olympics",
				"_red-cross",
				"_scotland",
				"_somaliland",
				"_south-ossetia",
				"_united-nations",
				"_unknown",
				"_wales",
				"AD",
				"AE",
				"AF",
				"AG",
				"AI",
				"AL",
				"AM",
				"AN",
				"AO",
				"AQ",
				"AR",
				"AS",
				"AT",
				"AU",
				"AW",
				"AX",
				"AZ",
				"BA",
				"BB",
				"BD",
				"BE",
				"BF",
				"BG",
				"BH",
				"BI",
				"BJ",
				"BL",
				"BM",
				"BN",
				"BO",
				"BR",
				"BS",
				"BT",
				"BW",
				"BY",
				"BZ",
				"CA",
				"CC",
				"CD",
				"CF",
				"CG",
				"CH",
				"CI",
				"CK",
				"CL",
				"CM",
				"CN",
				"CO",
				"CR",
				"CU",
				"CV",
				"CW",
				"CX",
				"CY",
				"CZ",
				"DE",
				"DJ",
				"DK",
				"DM",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"EH",
				"ER",
				"ES",
				"ET",
				"EU",
				"FI",
				"FJ",
				"FK",
				"FM",
				"FO",
				"FR",
				"GA",
				"GB",
				"GD",
				"GE",
				"GG",
				"GH",
				"GI",
				"GL",
				"GM",
				"GN",
				"GQ",
				"GR",
				"GS",
				"GT",
				"GU",
				"GW",
				"GY",
				"HK",
				"HN",
				"HR",
				"HT",
				"HU",
				"IC",
				"ID",
				"IE",
				"IL",
				"IM",
				"IN",
				"IQ",
				"IR",
				"IS",
				"IT",
				"JE",
				"JM",
				"JO",
				"JP",
				"KE",
				"KG",
				"KH",
				"KI",
				"KM",
				"KN",
				"KP",
				"KR",
				"KW",
				"KY",
				"KZ",
				"LA",
				"LB",
				"LC",
				"LI",
				"LK",
				"LR",
				"LS",
				"LT",
				"LU",
				"LV",
				"LY",
				"MA",
				"MC",
				"MD",
				"ME",
				"MF",
				"MG",
				"MH",
				"MK",
				"ML",
				"MM",
				"MN",
				"MO",
				"MP",
				"MQ",
				"MR",
				"MS",
				"MT",
				"MU",
				"MV",
				"MW",
				"MX",
				"MY",
				"MZ",
				"NA",
				"NC",
				"NE",
				"NF",
				"NG",
				"NI",
				"NL",
				"NO",
				"NP",
				"NR",
				"NU",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PF",
				"PG",
				"PH",
				"PK",
				"PL",
				"PN",
				"PR",
				"PS",
				"PT",
				"PW",
				"PY",
				"QA",
				"RO",
				"RS",
				"RU",
				"RW",
				"SA",
				"SB",
				"SC",
				"SD",
				"SE",
				"SG",
				"SH",
				"SI",
				"SK",
				"SL",
				"SM",
				"SN",
				"SO",
				"SR",
				"SS",
				"ST",
				"SV",
				"SY",
				"SZ",
				"TC",
				"TD",
				"TF",
				"TG",
				"TH",
				"TJ",
				"TK",
				"TL",
				"TM",
				"TN",
				"TO",
				"TR",
				"TT",
				"TV",
				"TW",
				"TZ",
				"UA",
				"UG",
				"US",
				"UY",
				"UZ",
				"VA",
				"VC",
				"VE",
				"VG",
				"VI",
				"VN",
				"VU",
				"WF",
				"WS",
				"YE",
				"YT",
				"ZA",
				"ZM",
				"ZW"
			]
		}
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseEach = __webpack_require__(5),
		    createFind = __webpack_require__(26);
	
		/**
		 * Iterates over elements of `collection`, returning the first element
		 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
		 * invoked with three arguments: (value, index|key, collection).
		 *
		 * If a property name is provided for `predicate` the created `_.property`
		 * style callback returns the property value of the given element.
		 *
		 * If a value is also provided for `thisArg` the created `_.matchesProperty`
		 * style callback returns `true` for elements that have a matching property
		 * value, else `false`.
		 *
		 * If an object is provided for `predicate` the created `_.matches` style
		 * callback returns `true` for elements that have the properties of the given
		 * object, else `false`.
		 *
		 * @static
		 * @memberOf _
		 * @alias detect
		 * @category Collection
		 * @param {Array|Object|string} collection The collection to search.
		 * @param {Function|Object|string} [predicate=_.identity] The function invoked
		 *  per iteration.
		 * @param {*} [thisArg] The `this` binding of `predicate`.
		 * @returns {*} Returns the matched element, else `undefined`.
		 * @example
		 *
		 * var users = [
		 *   { 'user': 'barney',  'age': 36, 'active': true },
		 *   { 'user': 'fred',    'age': 40, 'active': false },
		 *   { 'user': 'pebbles', 'age': 1,  'active': true }
		 * ];
		 *
		 * _.result(_.find(users, function(chr) {
		 *   return chr.age < 40;
		 * }), 'user');
		 * // => 'barney'
		 *
		 * // using the `_.matches` callback shorthand
		 * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
		 * // => 'pebbles'
		 *
		 * // using the `_.matchesProperty` callback shorthand
		 * _.result(_.find(users, 'active', false), 'user');
		 * // => 'fred'
		 *
		 * // using the `_.property` callback shorthand
		 * _.result(_.find(users, 'active'), 'user');
		 * // => 'barney'
		 */
		var find = createFind(baseEach);
	
		module.exports = find;
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseForOwn = __webpack_require__(6),
		    createBaseEach = __webpack_require__(25);
	
		/**
		 * The base implementation of `_.forEach` without support for callback
		 * shorthands and `this` binding.
		 *
		 * @private
		 * @param {Array|Object|string} collection The collection to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array|Object|string} Returns `collection`.
		 */
		var baseEach = createBaseEach(baseForOwn);
	
		module.exports = baseEach;
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseFor = __webpack_require__(7),
		    keys = __webpack_require__(11);
	
		/**
		 * The base implementation of `_.forOwn` without support for callback
		 * shorthands and `this` binding.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Object} Returns `object`.
		 */
		function baseForOwn(object, iteratee) {
		  return baseFor(object, iteratee, keys);
		}
	
		module.exports = baseForOwn;
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		var createBaseFor = __webpack_require__(8);
	
		/**
		 * The base implementation of `baseForIn` and `baseForOwn` which iterates
		 * over `object` properties returned by `keysFunc` invoking `iteratee` for
		 * each property. Iteratee functions may exit iteration early by explicitly
		 * returning `false`.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @returns {Object} Returns `object`.
		 */
		var baseFor = createBaseFor();
	
		module.exports = baseFor;
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toObject = __webpack_require__(9);
	
		/**
		 * Creates a base function for `_.forIn` or `_.forInRight`.
		 *
		 * @private
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */
		function createBaseFor(fromRight) {
		  return function(object, iteratee, keysFunc) {
		    var iterable = toObject(object),
		        props = keysFunc(object),
		        length = props.length,
		        index = fromRight ? length : -1;
	
		    while ((fromRight ? index-- : ++index < length)) {
		      var key = props[index];
		      if (iteratee(iterable[key], key, iterable) === false) {
		        break;
		      }
		    }
		    return object;
		  };
		}
	
		module.exports = createBaseFor;
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(10);
	
		/**
		 * Converts `value` to an object if it's not one.
		 *
		 * @private
		 * @param {*} value The value to process.
		 * @returns {Object} Returns the object.
		 */
		function toObject(value) {
		  return isObject(value) ? value : Object(value);
		}
	
		module.exports = toObject;
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
		 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(1);
		 * // => false
		 */
		function isObject(value) {
		  // Avoid a V8 JIT bug in Chrome 19-20.
		  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
		  var type = typeof value;
		  return !!value && (type == 'object' || type == 'function');
		}
	
		module.exports = isObject;
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(12),
		    isArrayLike = __webpack_require__(16),
		    isObject = __webpack_require__(10),
		    shimKeys = __webpack_require__(20);
	
		/* Native method references for those with the same name as other `lodash` methods. */
		var nativeKeys = getNative(Object, 'keys');
	
		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		var keys = !nativeKeys ? shimKeys : function(object) {
		  var Ctor = object == null ? undefined : object.constructor;
		  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
		      (typeof object != 'function' && isArrayLike(object))) {
		    return shimKeys(object);
		  }
		  return isObject(object) ? nativeKeys(object) : [];
		};
	
		module.exports = keys;
	
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isNative = __webpack_require__(13);
	
		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = object == null ? undefined : object[key];
		  return isNative(value) ? value : undefined;
		}
	
		module.exports = getNative;
	
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isFunction = __webpack_require__(14),
		    isObjectLike = __webpack_require__(15);
	
		/** Used to detect host constructors (Safari > 5). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
		/** Used for native method references. */
		var objectProto = Object.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var fnToString = Function.prototype.toString;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);
	
		/**
		 * Checks if `value` is a native function.
		 *
		 * @static
		 * @memberOf _
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
		 * @example
		 *
		 * _.isNative(Array.prototype.push);
		 * // => true
		 *
		 * _.isNative(_);
		 * // => false
		 */
		function isNative(value) {
		  if (value == null) {
		    return false;
		  }
		  if (isFunction(value)) {
		    return reIsNative.test(fnToString.call(value));
		  }
		  return isObjectLike(value) && reIsHostCtor.test(value);
		}
	
		module.exports = isNative;
	
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(10);
	
		/** `Object#toString` result references. */
		var funcTag = '[object Function]';
	
		/** Used for native method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objToString = objectProto.toString;
	
		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in older versions of Chrome and Safari which return 'function' for regexes
		  // and Safari 8 which returns 'object' for typed array constructors.
		  return isObject(value) && objToString.call(value) == funcTag;
		}
	
		module.exports = isFunction;
	
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is object-like.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 */
		function isObjectLike(value) {
		  return !!value && typeof value == 'object';
		}
	
		module.exports = isObjectLike;
	
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getLength = __webpack_require__(17),
		    isLength = __webpack_require__(19);
	
		/**
		 * Checks if `value` is array-like.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 */
		function isArrayLike(value) {
		  return value != null && isLength(getLength(value));
		}
	
		module.exports = isArrayLike;
	
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseProperty = __webpack_require__(18);
	
		/**
		 * Gets the "length" property value of `object`.
		 *
		 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
		 * that affects Safari on at least iOS 8.1-8.3 ARM64.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {*} Returns the "length" value.
		 */
		var getLength = baseProperty('length');
	
		module.exports = getLength;
	
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.property` without support for deep paths.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @returns {Function} Returns the new function.
		 */
		function baseProperty(key) {
		  return function(object) {
		    return object == null ? undefined : object[key];
		  };
		}
	
		module.exports = baseProperty;
	
	
	/***/ },
	/* 19 */
	/***/ function(module, exports) {
	
		/**
		 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
		 * of an array-like value.
		 */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 */
		function isLength(value) {
		  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}
	
		module.exports = isLength;
	
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArguments = __webpack_require__(21),
		    isArray = __webpack_require__(22),
		    isIndex = __webpack_require__(23),
		    isLength = __webpack_require__(19),
		    keysIn = __webpack_require__(24);
	
		/** Used for native method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * A fallback implementation of `Object.keys` which creates an array of the
		 * own enumerable property names of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function shimKeys(object) {
		  var props = keysIn(object),
		      propsLength = props.length,
		      length = propsLength && object.length;
	
		  var allowIndexes = !!length && isLength(length) &&
		    (isArray(object) || isArguments(object));
	
		  var index = -1,
		      result = [];
	
		  while (++index < propsLength) {
		    var key = props[index];
		    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = shimKeys;
	
	
	/***/ },
	/* 21 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArrayLike = __webpack_require__(16),
		    isObjectLike = __webpack_require__(15);
	
		/** Used for native method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Native method references. */
		var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
		/**
		 * Checks if `value` is classified as an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		function isArguments(value) {
		  return isObjectLike(value) && isArrayLike(value) &&
		    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
		}
	
		module.exports = isArguments;
	
	
	/***/ },
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(12),
		    isLength = __webpack_require__(19),
		    isObjectLike = __webpack_require__(15);
	
		/** `Object#toString` result references. */
		var arrayTag = '[object Array]';
	
		/** Used for native method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objToString = objectProto.toString;
	
		/* Native method references for those with the same name as other `lodash` methods. */
		var nativeIsArray = getNative(Array, 'isArray');
	
		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(function() { return arguments; }());
		 * // => false
		 */
		var isArray = nativeIsArray || function(value) {
		  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
		};
	
		module.exports = isArray;
	
	
	/***/ },
	/* 23 */
	/***/ function(module, exports) {
	
		/** Used to detect unsigned integer values. */
		var reIsUint = /^\d+$/;
	
		/**
		 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
		 * of an array-like value.
		 */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return value > -1 && value % 1 == 0 && value < length;
		}
	
		module.exports = isIndex;
	
	
	/***/ },
	/* 24 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArguments = __webpack_require__(21),
		    isArray = __webpack_require__(22),
		    isIndex = __webpack_require__(23),
		    isLength = __webpack_require__(19),
		    isObject = __webpack_require__(10);
	
		/** Used for native method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Creates an array of the own and inherited enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects.
		 *
		 * @static
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keysIn(new Foo);
		 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
		 */
		function keysIn(object) {
		  if (object == null) {
		    return [];
		  }
		  if (!isObject(object)) {
		    object = Object(object);
		  }
		  var length = object.length;
		  length = (length && isLength(length) &&
		    (isArray(object) || isArguments(object)) && length) || 0;
	
		  var Ctor = object.constructor,
		      index = -1,
		      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
		      result = Array(length),
		      skipIndexes = length > 0;
	
		  while (++index < length) {
		    result[index] = (index + '');
		  }
		  for (var key in object) {
		    if (!(skipIndexes && isIndex(key, length)) &&
		        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = keysIn;
	
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getLength = __webpack_require__(17),
		    isLength = __webpack_require__(19),
		    toObject = __webpack_require__(9);
	
		/**
		 * Creates a `baseEach` or `baseEachRight` function.
		 *
		 * @private
		 * @param {Function} eachFunc The function to iterate over a collection.
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */
		function createBaseEach(eachFunc, fromRight) {
		  return function(collection, iteratee) {
		    var length = collection ? getLength(collection) : 0;
		    if (!isLength(length)) {
		      return eachFunc(collection, iteratee);
		    }
		    var index = fromRight ? length : -1,
		        iterable = toObject(collection);
	
		    while ((fromRight ? index-- : ++index < length)) {
		      if (iteratee(iterable[index], index, iterable) === false) {
		        break;
		      }
		    }
		    return collection;
		  };
		}
	
		module.exports = createBaseEach;
	
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseCallback = __webpack_require__(27),
		    baseFind = __webpack_require__(51),
		    baseFindIndex = __webpack_require__(52),
		    isArray = __webpack_require__(22);
	
		/**
		 * Creates a `_.find` or `_.findLast` function.
		 *
		 * @private
		 * @param {Function} eachFunc The function to iterate over a collection.
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new find function.
		 */
		function createFind(eachFunc, fromRight) {
		  return function(collection, predicate, thisArg) {
		    predicate = baseCallback(predicate, thisArg, 3);
		    if (isArray(collection)) {
		      var index = baseFindIndex(collection, predicate, fromRight);
		      return index > -1 ? collection[index] : undefined;
		    }
		    return baseFind(collection, predicate, eachFunc);
		  };
		}
	
		module.exports = createFind;
	
	
	/***/ },
	/* 27 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseMatches = __webpack_require__(28),
		    baseMatchesProperty = __webpack_require__(40),
		    bindCallback = __webpack_require__(47),
		    identity = __webpack_require__(48),
		    property = __webpack_require__(49);
	
		/**
		 * The base implementation of `_.callback` which supports specifying the
		 * number of arguments to provide to `func`.
		 *
		 * @private
		 * @param {*} [func=_.identity] The value to convert to a callback.
		 * @param {*} [thisArg] The `this` binding of `func`.
		 * @param {number} [argCount] The number of arguments to provide to `func`.
		 * @returns {Function} Returns the callback.
		 */
		function baseCallback(func, thisArg, argCount) {
		  var type = typeof func;
		  if (type == 'function') {
		    return thisArg === undefined
		      ? func
		      : bindCallback(func, thisArg, argCount);
		  }
		  if (func == null) {
		    return identity;
		  }
		  if (type == 'object') {
		    return baseMatches(func);
		  }
		  return thisArg === undefined
		    ? property(func)
		    : baseMatchesProperty(func, thisArg);
		}
	
		module.exports = baseCallback;
	
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseIsMatch = __webpack_require__(29),
		    getMatchData = __webpack_require__(37),
		    toObject = __webpack_require__(9);
	
		/**
		 * The base implementation of `_.matches` which does not clone `source`.
		 *
		 * @private
		 * @param {Object} source The object of property values to match.
		 * @returns {Function} Returns the new function.
		 */
		function baseMatches(source) {
		  var matchData = getMatchData(source);
		  if (matchData.length == 1 && matchData[0][2]) {
		    var key = matchData[0][0],
		        value = matchData[0][1];
	
		    return function(object) {
		      if (object == null) {
		        return false;
		      }
		      return object[key] === value && (value !== undefined || (key in toObject(object)));
		    };
		  }
		  return function(object) {
		    return baseIsMatch(object, matchData);
		  };
		}
	
		module.exports = baseMatches;
	
	
	/***/ },
	/* 29 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseIsEqual = __webpack_require__(30),
		    toObject = __webpack_require__(9);
	
		/**
		 * The base implementation of `_.isMatch` without support for callback
		 * shorthands and `this` binding.
		 *
		 * @private
		 * @param {Object} object The object to inspect.
		 * @param {Array} matchData The propery names, values, and compare flags to match.
		 * @param {Function} [customizer] The function to customize comparing objects.
		 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
		 */
		function baseIsMatch(object, matchData, customizer) {
		  var index = matchData.length,
		      length = index,
		      noCustomizer = !customizer;
	
		  if (object == null) {
		    return !length;
		  }
		  object = toObject(object);
		  while (index--) {
		    var data = matchData[index];
		    if ((noCustomizer && data[2])
		          ? data[1] !== object[data[0]]
		          : !(data[0] in object)
		        ) {
		      return false;
		    }
		  }
		  while (++index < length) {
		    data = matchData[index];
		    var key = data[0],
		        objValue = object[key],
		        srcValue = data[1];
	
		    if (noCustomizer && data[2]) {
		      if (objValue === undefined && !(key in object)) {
		        return false;
		      }
		    } else {
		      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
		      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
		        return false;
		      }
		    }
		  }
		  return true;
		}
	
		module.exports = baseIsMatch;
	
	
	/***/ },
	/* 30 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseIsEqualDeep = __webpack_require__(31),
		    isObject = __webpack_require__(10),
		    isObjectLike = __webpack_require__(15);
	
		/**
		 * The base implementation of `_.isEqual` without support for `this` binding
		 * `customizer` functions.
		 *
		 * @private
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @param {Function} [customizer] The function to customize comparing values.
		 * @param {boolean} [isLoose] Specify performing partial comparisons.
		 * @param {Array} [stackA] Tracks traversed `value` objects.
		 * @param {Array} [stackB] Tracks traversed `other` objects.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 */
		function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
		  if (value === other) {
		    return true;
		  }
		  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
		    return value !== value && other !== other;
		  }
		  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
		}
	
		module.exports = baseIsEqual;
	
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		var equalArrays = __webpack_require__(32),
		    equalByTag = __webpack_require__(34),
		    equalObjects = __webpack_require__(35),
		    isArray = __webpack_require__(22),
		    isTypedArray = __webpack_require__(36);
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    objectTag = '[object Object]';
	
		/** Used for native method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objToString = objectProto.toString;
	
		/**
		 * A specialized version of `baseIsEqual` for arrays and objects which performs
		 * deep comparisons and tracks traversed objects enabling objects with circular
		 * references to be compared.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} [customizer] The function to customize comparing objects.
		 * @param {boolean} [isLoose] Specify performing partial comparisons.
		 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
		 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
		  var objIsArr = isArray(object),
		      othIsArr = isArray(other),
		      objTag = arrayTag,
		      othTag = arrayTag;
	
		  if (!objIsArr) {
		    objTag = objToString.call(object);
		    if (objTag == argsTag) {
		      objTag = objectTag;
		    } else if (objTag != objectTag) {
		      objIsArr = isTypedArray(object);
		    }
		  }
		  if (!othIsArr) {
		    othTag = objToString.call(other);
		    if (othTag == argsTag) {
		      othTag = objectTag;
		    } else if (othTag != objectTag) {
		      othIsArr = isTypedArray(other);
		    }
		  }
		  var objIsObj = objTag == objectTag,
		      othIsObj = othTag == objectTag,
		      isSameTag = objTag == othTag;
	
		  if (isSameTag && !(objIsArr || objIsObj)) {
		    return equalByTag(object, other, objTag);
		  }
		  if (!isLoose) {
		    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
		        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
		    if (objIsWrapped || othIsWrapped) {
		      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
		    }
		  }
		  if (!isSameTag) {
		    return false;
		  }
		  // Assume cyclic values are equal.
		  // For more information on detecting circular references see https://es5.github.io/#JO.
		  stackA || (stackA = []);
		  stackB || (stackB = []);
	
		  var length = stackA.length;
		  while (length--) {
		    if (stackA[length] == object) {
		      return stackB[length] == other;
		    }
		  }
		  // Add `object` and `other` to the stack of traversed objects.
		  stackA.push(object);
		  stackB.push(other);
	
		  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
		  stackA.pop();
		  stackB.pop();
	
		  return result;
		}
	
		module.exports = baseIsEqualDeep;
	
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arraySome = __webpack_require__(33);
	
		/**
		 * A specialized version of `baseIsEqualDeep` for arrays with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Array} array The array to compare.
		 * @param {Array} other The other array to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} [customizer] The function to customize comparing arrays.
		 * @param {boolean} [isLoose] Specify performing partial comparisons.
		 * @param {Array} [stackA] Tracks traversed `value` objects.
		 * @param {Array} [stackB] Tracks traversed `other` objects.
		 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
		 */
		function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
		  var index = -1,
		      arrLength = array.length,
		      othLength = other.length;
	
		  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
		    return false;
		  }
		  // Ignore non-index properties.
		  while (++index < arrLength) {
		    var arrValue = array[index],
		        othValue = other[index],
		        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
		    if (result !== undefined) {
		      if (result) {
		        continue;
		      }
		      return false;
		    }
		    // Recursively compare arrays (susceptible to call stack limits).
		    if (isLoose) {
		      if (!arraySome(other, function(othValue) {
		            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
		          })) {
		        return false;
		      }
		    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
		      return false;
		    }
		  }
		  return true;
		}
	
		module.exports = equalArrays;
	
	
	/***/ },
	/* 33 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `_.some` for arrays without support for callback
		 * shorthands and `this` binding.
		 *
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {boolean} Returns `true` if any element passes the predicate check,
		 *  else `false`.
		 */
		function arraySome(array, predicate) {
		  var index = -1,
		      length = array.length;
	
		  while (++index < length) {
		    if (predicate(array[index], index, array)) {
		      return true;
		    }
		  }
		  return false;
		}
	
		module.exports = arraySome;
	
	
	/***/ },
	/* 34 */
	/***/ function(module, exports) {
	
		/** `Object#toString` result references. */
		var boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    numberTag = '[object Number]',
		    regexpTag = '[object RegExp]',
		    stringTag = '[object String]';
	
		/**
		 * A specialized version of `baseIsEqualDeep` for comparing objects of
		 * the same `toStringTag`.
		 *
		 * **Note:** This function only supports comparing values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {string} tag The `toStringTag` of the objects to compare.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalByTag(object, other, tag) {
		  switch (tag) {
		    case boolTag:
		    case dateTag:
		      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
		      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
		      return +object == +other;
	
		    case errorTag:
		      return object.name == other.name && object.message == other.message;
	
		    case numberTag:
		      // Treat `NaN` vs. `NaN` as equal.
		      return (object != +object)
		        ? other != +other
		        : object == +other;
	
		    case regexpTag:
		    case stringTag:
		      // Coerce regexes to strings and treat strings primitives and string
		      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
		      return object == (other + '');
		  }
		  return false;
		}
	
		module.exports = equalByTag;
	
	
	/***/ },
	/* 35 */
	/***/ function(module, exports, __webpack_require__) {
	
		var keys = __webpack_require__(11);
	
		/** Used for native method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * A specialized version of `baseIsEqualDeep` for objects with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} [customizer] The function to customize comparing values.
		 * @param {boolean} [isLoose] Specify performing partial comparisons.
		 * @param {Array} [stackA] Tracks traversed `value` objects.
		 * @param {Array} [stackB] Tracks traversed `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
		  var objProps = keys(object),
		      objLength = objProps.length,
		      othProps = keys(other),
		      othLength = othProps.length;
	
		  if (objLength != othLength && !isLoose) {
		    return false;
		  }
		  var index = objLength;
		  while (index--) {
		    var key = objProps[index];
		    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
		      return false;
		    }
		  }
		  var skipCtor = isLoose;
		  while (++index < objLength) {
		    key = objProps[index];
		    var objValue = object[key],
		        othValue = other[key],
		        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
		    // Recursively compare objects (susceptible to call stack limits).
		    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
		      return false;
		    }
		    skipCtor || (skipCtor = key == 'constructor');
		  }
		  if (!skipCtor) {
		    var objCtor = object.constructor,
		        othCtor = other.constructor;
	
		    // Non `Object` object instances with different constructors are not equal.
		    if (objCtor != othCtor &&
		        ('constructor' in object && 'constructor' in other) &&
		        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
		          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
		      return false;
		    }
		  }
		  return true;
		}
	
		module.exports = equalObjects;
	
	
	/***/ },
	/* 36 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isLength = __webpack_require__(19),
		    isObjectLike = __webpack_require__(15);
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    objectTag = '[object Object]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    weakMapTag = '[object WeakMap]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';
	
		/** Used to identify `toStringTag` values of typed arrays. */
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
		typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
		typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
		typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
		typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
		typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
		typedArrayTags[dateTag] = typedArrayTags[errorTag] =
		typedArrayTags[funcTag] = typedArrayTags[mapTag] =
		typedArrayTags[numberTag] = typedArrayTags[objectTag] =
		typedArrayTags[regexpTag] = typedArrayTags[setTag] =
		typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
		/** Used for native method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objToString = objectProto.toString;
	
		/**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */
		function isTypedArray(value) {
		  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
		}
	
		module.exports = isTypedArray;
	
	
	/***/ },
	/* 37 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isStrictComparable = __webpack_require__(38),
		    pairs = __webpack_require__(39);
	
		/**
		 * Gets the propery names, values, and compare flags of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the match data of `object`.
		 */
		function getMatchData(object) {
		  var result = pairs(object),
		      length = result.length;
	
		  while (length--) {
		    result[length][2] = isStrictComparable(result[length][1]);
		  }
		  return result;
		}
	
		module.exports = getMatchData;
	
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(10);
	
		/**
		 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` if suitable for strict
		 *  equality comparisons, else `false`.
		 */
		function isStrictComparable(value) {
		  return value === value && !isObject(value);
		}
	
		module.exports = isStrictComparable;
	
	
	/***/ },
	/* 39 */
	/***/ function(module, exports, __webpack_require__) {
	
		var keys = __webpack_require__(11),
		    toObject = __webpack_require__(9);
	
		/**
		 * Creates a two dimensional array of the key-value pairs for `object`,
		 * e.g. `[[key1, value1], [key2, value2]]`.
		 *
		 * @static
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the new array of key-value pairs.
		 * @example
		 *
		 * _.pairs({ 'barney': 36, 'fred': 40 });
		 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
		 */
		function pairs(object) {
		  object = toObject(object);
	
		  var index = -1,
		      props = keys(object),
		      length = props.length,
		      result = Array(length);
	
		  while (++index < length) {
		    var key = props[index];
		    result[index] = [key, object[key]];
		  }
		  return result;
		}
	
		module.exports = pairs;
	
	
	/***/ },
	/* 40 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseGet = __webpack_require__(41),
		    baseIsEqual = __webpack_require__(30),
		    baseSlice = __webpack_require__(42),
		    isArray = __webpack_require__(22),
		    isKey = __webpack_require__(43),
		    isStrictComparable = __webpack_require__(38),
		    last = __webpack_require__(44),
		    toObject = __webpack_require__(9),
		    toPath = __webpack_require__(45);
	
		/**
		 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
		 *
		 * @private
		 * @param {string} path The path of the property to get.
		 * @param {*} srcValue The value to compare.
		 * @returns {Function} Returns the new function.
		 */
		function baseMatchesProperty(path, srcValue) {
		  var isArr = isArray(path),
		      isCommon = isKey(path) && isStrictComparable(srcValue),
		      pathKey = (path + '');
	
		  path = toPath(path);
		  return function(object) {
		    if (object == null) {
		      return false;
		    }
		    var key = pathKey;
		    object = toObject(object);
		    if ((isArr || !isCommon) && !(key in object)) {
		      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
		      if (object == null) {
		        return false;
		      }
		      key = last(path);
		      object = toObject(object);
		    }
		    return object[key] === srcValue
		      ? (srcValue !== undefined || (key in object))
		      : baseIsEqual(srcValue, object[key], undefined, true);
		  };
		}
	
		module.exports = baseMatchesProperty;
	
	
	/***/ },
	/* 41 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toObject = __webpack_require__(9);
	
		/**
		 * The base implementation of `get` without support for string paths
		 * and default values.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array} path The path of the property to get.
		 * @param {string} [pathKey] The key representation of path.
		 * @returns {*} Returns the resolved value.
		 */
		function baseGet(object, path, pathKey) {
		  if (object == null) {
		    return;
		  }
		  if (pathKey !== undefined && pathKey in toObject(object)) {
		    path = [pathKey];
		  }
		  var index = 0,
		      length = path.length;
	
		  while (object != null && index < length) {
		    object = object[path[index++]];
		  }
		  return (index && index == length) ? object : undefined;
		}
	
		module.exports = baseGet;
	
	
	/***/ },
	/* 42 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.slice` without an iteratee call guard.
		 *
		 * @private
		 * @param {Array} array The array to slice.
		 * @param {number} [start=0] The start position.
		 * @param {number} [end=array.length] The end position.
		 * @returns {Array} Returns the slice of `array`.
		 */
		function baseSlice(array, start, end) {
		  var index = -1,
		      length = array.length;
	
		  start = start == null ? 0 : (+start || 0);
		  if (start < 0) {
		    start = -start > length ? 0 : (length + start);
		  }
		  end = (end === undefined || end > length) ? length : (+end || 0);
		  if (end < 0) {
		    end += length;
		  }
		  length = start > end ? 0 : ((end - start) >>> 0);
		  start >>>= 0;
	
		  var result = Array(length);
		  while (++index < length) {
		    result[index] = array[index + start];
		  }
		  return result;
		}
	
		module.exports = baseSlice;
	
	
	/***/ },
	/* 43 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArray = __webpack_require__(22),
		    toObject = __webpack_require__(9);
	
		/** Used to match property names within property paths. */
		var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
		    reIsPlainProp = /^\w*$/;
	
		/**
		 * Checks if `value` is a property name and not a property path.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {Object} [object] The object to query keys on.
		 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
		 */
		function isKey(value, object) {
		  var type = typeof value;
		  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
		    return true;
		  }
		  if (isArray(value)) {
		    return false;
		  }
		  var result = !reIsDeepProp.test(value);
		  return result || (object != null && value in toObject(object));
		}
	
		module.exports = isKey;
	
	
	/***/ },
	/* 44 */
	/***/ function(module, exports) {
	
		/**
		 * Gets the last element of `array`.
		 *
		 * @static
		 * @memberOf _
		 * @category Array
		 * @param {Array} array The array to query.
		 * @returns {*} Returns the last element of `array`.
		 * @example
		 *
		 * _.last([1, 2, 3]);
		 * // => 3
		 */
		function last(array) {
		  var length = array ? array.length : 0;
		  return length ? array[length - 1] : undefined;
		}
	
		module.exports = last;
	
	
	/***/ },
	/* 45 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseToString = __webpack_require__(46),
		    isArray = __webpack_require__(22);
	
		/** Used to match property names within property paths. */
		var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
		/** Used to match backslashes in property paths. */
		var reEscapeChar = /\\(\\)?/g;
	
		/**
		 * Converts `value` to property path array if it's not one.
		 *
		 * @private
		 * @param {*} value The value to process.
		 * @returns {Array} Returns the property path array.
		 */
		function toPath(value) {
		  if (isArray(value)) {
		    return value;
		  }
		  var result = [];
		  baseToString(value).replace(rePropName, function(match, number, quote, string) {
		    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
		  });
		  return result;
		}
	
		module.exports = toPath;
	
	
	/***/ },
	/* 46 */
	/***/ function(module, exports) {
	
		/**
		 * Converts `value` to a string if it's not one. An empty string is returned
		 * for `null` or `undefined` values.
		 *
		 * @private
		 * @param {*} value The value to process.
		 * @returns {string} Returns the string.
		 */
		function baseToString(value) {
		  return value == null ? '' : (value + '');
		}
	
		module.exports = baseToString;
	
	
	/***/ },
	/* 47 */
	/***/ function(module, exports, __webpack_require__) {
	
		var identity = __webpack_require__(48);
	
		/**
		 * A specialized version of `baseCallback` which only supports `this` binding
		 * and specifying the number of arguments to provide to `func`.
		 *
		 * @private
		 * @param {Function} func The function to bind.
		 * @param {*} thisArg The `this` binding of `func`.
		 * @param {number} [argCount] The number of arguments to provide to `func`.
		 * @returns {Function} Returns the callback.
		 */
		function bindCallback(func, thisArg, argCount) {
		  if (typeof func != 'function') {
		    return identity;
		  }
		  if (thisArg === undefined) {
		    return func;
		  }
		  switch (argCount) {
		    case 1: return function(value) {
		      return func.call(thisArg, value);
		    };
		    case 3: return function(value, index, collection) {
		      return func.call(thisArg, value, index, collection);
		    };
		    case 4: return function(accumulator, value, index, collection) {
		      return func.call(thisArg, accumulator, value, index, collection);
		    };
		    case 5: return function(value, other, key, object, source) {
		      return func.call(thisArg, value, other, key, object, source);
		    };
		  }
		  return function() {
		    return func.apply(thisArg, arguments);
		  };
		}
	
		module.exports = bindCallback;
	
	
	/***/ },
	/* 48 */
	/***/ function(module, exports) {
	
		/**
		 * This method returns the first argument provided to it.
		 *
		 * @static
		 * @memberOf _
		 * @category Utility
		 * @param {*} value Any value.
		 * @returns {*} Returns `value`.
		 * @example
		 *
		 * var object = { 'user': 'fred' };
		 *
		 * _.identity(object) === object;
		 * // => true
		 */
		function identity(value) {
		  return value;
		}
	
		module.exports = identity;
	
	
	/***/ },
	/* 49 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseProperty = __webpack_require__(18),
		    basePropertyDeep = __webpack_require__(50),
		    isKey = __webpack_require__(43);
	
		/**
		 * Creates a function that returns the property value at `path` on a
		 * given object.
		 *
		 * @static
		 * @memberOf _
		 * @category Utility
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new function.
		 * @example
		 *
		 * var objects = [
		 *   { 'a': { 'b': { 'c': 2 } } },
		 *   { 'a': { 'b': { 'c': 1 } } }
		 * ];
		 *
		 * _.map(objects, _.property('a.b.c'));
		 * // => [2, 1]
		 *
		 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
		 * // => [1, 2]
		 */
		function property(path) {
		  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
		}
	
		module.exports = property;
	
	
	/***/ },
	/* 50 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseGet = __webpack_require__(41),
		    toPath = __webpack_require__(45);
	
		/**
		 * A specialized version of `baseProperty` which supports deep paths.
		 *
		 * @private
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new function.
		 */
		function basePropertyDeep(path) {
		  var pathKey = (path + '');
		  path = toPath(path);
		  return function(object) {
		    return baseGet(object, path, pathKey);
		  };
		}
	
		module.exports = basePropertyDeep;
	
	
	/***/ },
	/* 51 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
		 * without support for callback shorthands and `this` binding, which iterates
		 * over `collection` using the provided `eachFunc`.
		 *
		 * @private
		 * @param {Array|Object|string} collection The collection to search.
		 * @param {Function} predicate The function invoked per iteration.
		 * @param {Function} eachFunc The function to iterate over `collection`.
		 * @param {boolean} [retKey] Specify returning the key of the found element
		 *  instead of the element itself.
		 * @returns {*} Returns the found element or its key, else `undefined`.
		 */
		function baseFind(collection, predicate, eachFunc, retKey) {
		  var result;
		  eachFunc(collection, function(value, key, collection) {
		    if (predicate(value, key, collection)) {
		      result = retKey ? key : value;
		      return false;
		    }
		  });
		  return result;
		}
	
		module.exports = baseFind;
	
	
	/***/ },
	/* 52 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.findIndex` and `_.findLastIndex` without
		 * support for callback shorthands and `this` binding.
		 *
		 * @private
		 * @param {Array} array The array to search.
		 * @param {Function} predicate The function invoked per iteration.
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function baseFindIndex(array, predicate, fromRight) {
		  var length = array.length,
		      index = fromRight ? length : -1;
	
		  while ((fromRight ? index-- : ++index < length)) {
		    if (predicate(array[index], index, array)) {
		      return index;
		    }
		  }
		  return -1;
		}
	
		module.exports = baseFindIndex;
	
	
	/***/ },
	/* 53 */
	/***/ function(module, exports) {
	
		module.exports = [{"cca2":"AW","cca3":"ABW"},{"cca2":"AF","cca3":"AFG"},{"cca2":"AO","cca3":"AGO"},{"cca2":"AI","cca3":"AIA"},{"cca2":"AX","cca3":"ALA"},{"cca2":"AL","cca3":"ALB"},{"cca2":"AD","cca3":"AND"},{"cca2":"AE","cca3":"ARE"},{"cca2":"AR","cca3":"ARG"},{"cca2":"AM","cca3":"ARM"},{"cca2":"AS","cca3":"ASM"},{"cca2":"AQ","cca3":"ATA"},{"cca2":"TF","cca3":"ATF"},{"cca2":"AG","cca3":"ATG"},{"cca2":"AU","cca3":"AUS"},{"cca2":"AT","cca3":"AUT"},{"cca2":"AZ","cca3":"AZE"},{"cca2":"BI","cca3":"BDI"},{"cca2":"BE","cca3":"BEL"},{"cca2":"BJ","cca3":"BEN"},{"cca2":"BF","cca3":"BFA"},{"cca2":"BD","cca3":"BGD"},{"cca2":"BG","cca3":"BGR"},{"cca2":"BH","cca3":"BHR"},{"cca2":"BS","cca3":"BHS"},{"cca2":"BA","cca3":"BIH"},{"cca2":"BL","cca3":"BLM"},{"cca2":"BY","cca3":"BLR"},{"cca2":"BZ","cca3":"BLZ"},{"cca2":"BM","cca3":"BMU"},{"cca2":"BO","cca3":"BOL"},{"cca2":"BR","cca3":"BRA"},{"cca2":"BB","cca3":"BRB"},{"cca2":"BN","cca3":"BRN"},{"cca2":"BT","cca3":"BTN"},{"cca2":"BV","cca3":"BVT"},{"cca2":"BW","cca3":"BWA"},{"cca2":"CF","cca3":"CAF"},{"cca2":"CA","cca3":"CAN"},{"cca2":"CC","cca3":"CCK"},{"cca2":"CH","cca3":"CHE"},{"cca2":"CL","cca3":"CHL"},{"cca2":"CN","cca3":"CHN"},{"cca2":"CI","cca3":"CIV"},{"cca2":"CM","cca3":"CMR"},{"cca2":"CD","cca3":"COD"},{"cca2":"CG","cca3":"COG"},{"cca2":"CK","cca3":"COK"},{"cca2":"CO","cca3":"COL"},{"cca2":"KM","cca3":"COM"},{"cca2":"CV","cca3":"CPV"},{"cca2":"CR","cca3":"CRI"},{"cca2":"CU","cca3":"CUB"},{"cca2":"CW","cca3":"CUW"},{"cca2":"CX","cca3":"CXR"},{"cca2":"KY","cca3":"CYM"},{"cca2":"CY","cca3":"CYP"},{"cca2":"CZ","cca3":"CZE"},{"cca2":"DE","cca3":"DEU"},{"cca2":"DJ","cca3":"DJI"},{"cca2":"DM","cca3":"DMA"},{"cca2":"DK","cca3":"DNK"},{"cca2":"DO","cca3":"DOM"},{"cca2":"DZ","cca3":"DZA"},{"cca2":"EC","cca3":"ECU"},{"cca2":"EG","cca3":"EGY"},{"cca2":"ER","cca3":"ERI"},{"cca2":"EH","cca3":"ESH"},{"cca2":"ES","cca3":"ESP"},{"cca2":"EE","cca3":"EST"},{"cca2":"ET","cca3":"ETH"},{"cca2":"FI","cca3":"FIN"},{"cca2":"FJ","cca3":"FJI"},{"cca2":"FK","cca3":"FLK"},{"cca2":"FR","cca3":"FRA"},{"cca2":"FO","cca3":"FRO"},{"cca2":"FM","cca3":"FSM"},{"cca2":"GA","cca3":"GAB"},{"cca2":"GB","cca3":"GBR"},{"cca2":"GE","cca3":"GEO"},{"cca2":"GG","cca3":"GGY"},{"cca2":"GH","cca3":"GHA"},{"cca2":"GI","cca3":"GIB"},{"cca2":"GN","cca3":"GIN"},{"cca2":"GP","cca3":"GLP"},{"cca2":"GM","cca3":"GMB"},{"cca2":"GW","cca3":"GNB"},{"cca2":"GQ","cca3":"GNQ"},{"cca2":"GR","cca3":"GRC"},{"cca2":"GD","cca3":"GRD"},{"cca2":"GL","cca3":"GRL"},{"cca2":"GT","cca3":"GTM"},{"cca2":"GF","cca3":"GUF"},{"cca2":"GU","cca3":"GUM"},{"cca2":"GY","cca3":"GUY"},{"cca2":"HK","cca3":"HKG"},{"cca2":"HM","cca3":"HMD"},{"cca2":"HN","cca3":"HND"},{"cca2":"HR","cca3":"HRV"},{"cca2":"HT","cca3":"HTI"},{"cca2":"HU","cca3":"HUN"},{"cca2":"ID","cca3":"IDN"},{"cca2":"IM","cca3":"IMN"},{"cca2":"IN","cca3":"IND"},{"cca2":"IO","cca3":"IOT"},{"cca2":"IE","cca3":"IRL"},{"cca2":"IR","cca3":"IRN"},{"cca2":"IQ","cca3":"IRQ"},{"cca2":"IS","cca3":"ISL"},{"cca2":"IL","cca3":"ISR"},{"cca2":"IT","cca3":"ITA"},{"cca2":"JM","cca3":"JAM"},{"cca2":"JE","cca3":"JEY"},{"cca2":"JO","cca3":"JOR"},{"cca2":"JP","cca3":"JPN"},{"cca2":"KZ","cca3":"KAZ"},{"cca2":"KE","cca3":"KEN"},{"cca2":"KG","cca3":"KGZ"},{"cca2":"KH","cca3":"KHM"},{"cca2":"KI","cca3":"KIR"},{"cca2":"KN","cca3":"KNA"},{"cca2":"KR","cca3":"KOR"},{"cca2":"XK","cca3":"UNK"},{"cca2":"KW","cca3":"KWT"},{"cca2":"LA","cca3":"LAO"},{"cca2":"LB","cca3":"LBN"},{"cca2":"LR","cca3":"LBR"},{"cca2":"LY","cca3":"LBY"},{"cca2":"LC","cca3":"LCA"},{"cca2":"LI","cca3":"LIE"},{"cca2":"LK","cca3":"LKA"},{"cca2":"LS","cca3":"LSO"},{"cca2":"LT","cca3":"LTU"},{"cca2":"LU","cca3":"LUX"},{"cca2":"LV","cca3":"LVA"},{"cca2":"MO","cca3":"MAC"},{"cca2":"MF","cca3":"MAF"},{"cca2":"MA","cca3":"MAR"},{"cca2":"MC","cca3":"MCO"},{"cca2":"MD","cca3":"MDA"},{"cca2":"MG","cca3":"MDG"},{"cca2":"MV","cca3":"MDV"},{"cca2":"MX","cca3":"MEX"},{"cca2":"MH","cca3":"MHL"},{"cca2":"MK","cca3":"MKD"},{"cca2":"ML","cca3":"MLI"},{"cca2":"MT","cca3":"MLT"},{"cca2":"MM","cca3":"MMR"},{"cca2":"ME","cca3":"MNE"},{"cca2":"MN","cca3":"MNG"},{"cca2":"MP","cca3":"MNP"},{"cca2":"MZ","cca3":"MOZ"},{"cca2":"MR","cca3":"MRT"},{"cca2":"MS","cca3":"MSR"},{"cca2":"MQ","cca3":"MTQ"},{"cca2":"MU","cca3":"MUS"},{"cca2":"MW","cca3":"MWI"},{"cca2":"MY","cca3":"MYS"},{"cca2":"YT","cca3":"MYT"},{"cca2":"NA","cca3":"NAM"},{"cca2":"NC","cca3":"NCL"},{"cca2":"NE","cca3":"NER"},{"cca2":"NF","cca3":"NFK"},{"cca2":"NG","cca3":"NGA"},{"cca2":"NI","cca3":"NIC"},{"cca2":"NU","cca3":"NIU"},{"cca2":"NL","cca3":"NLD"},{"cca2":"NO","cca3":"NOR"},{"cca2":"NP","cca3":"NPL"},{"cca2":"NR","cca3":"NRU"},{"cca2":"NZ","cca3":"NZL"},{"cca2":"OM","cca3":"OMN"},{"cca2":"PK","cca3":"PAK"},{"cca2":"PA","cca3":"PAN"},{"cca2":"PN","cca3":"PCN"},{"cca2":"PE","cca3":"PER"},{"cca2":"PH","cca3":"PHL"},{"cca2":"PW","cca3":"PLW"},{"cca2":"PG","cca3":"PNG"},{"cca2":"PL","cca3":"POL"},{"cca2":"PR","cca3":"PRI"},{"cca2":"KP","cca3":"PRK"},{"cca2":"PT","cca3":"PRT"},{"cca2":"PY","cca3":"PRY"},{"cca2":"PS","cca3":"PSE"},{"cca2":"PF","cca3":"PYF"},{"cca2":"QA","cca3":"QAT"},{"cca2":"RE","cca3":"REU"},{"cca2":"RO","cca3":"ROU"},{"cca2":"RU","cca3":"RUS"},{"cca2":"RW","cca3":"RWA"},{"cca2":"SA","cca3":"SAU"},{"cca2":"SD","cca3":"SDN"},{"cca2":"SN","cca3":"SEN"},{"cca2":"SG","cca3":"SGP"},{"cca2":"GS","cca3":"SGS"},{"cca2":"SJ","cca3":"SJM"},{"cca2":"SB","cca3":"SLB"},{"cca2":"SL","cca3":"SLE"},{"cca2":"SV","cca3":"SLV"},{"cca2":"SM","cca3":"SMR"},{"cca2":"SO","cca3":"SOM"},{"cca2":"PM","cca3":"SPM"},{"cca2":"RS","cca3":"SRB"},{"cca2":"SS","cca3":"SSD"},{"cca2":"ST","cca3":"STP"},{"cca2":"SR","cca3":"SUR"},{"cca2":"SK","cca3":"SVK"},{"cca2":"SI","cca3":"SVN"},{"cca2":"SE","cca3":"SWE"},{"cca2":"SZ","cca3":"SWZ"},{"cca2":"SX","cca3":"SXM"},{"cca2":"SC","cca3":"SYC"},{"cca2":"SY","cca3":"SYR"},{"cca2":"TC","cca3":"TCA"},{"cca2":"TD","cca3":"TCD"},{"cca2":"TG","cca3":"TGO"},{"cca2":"TH","cca3":"THA"},{"cca2":"TJ","cca3":"TJK"},{"cca2":"TK","cca3":"TKL"},{"cca2":"TM","cca3":"TKM"},{"cca2":"TL","cca3":"TLS"},{"cca2":"TO","cca3":"TON"},{"cca2":"TT","cca3":"TTO"},{"cca2":"TN","cca3":"TUN"},{"cca2":"TR","cca3":"TUR"},{"cca2":"TV","cca3":"TUV"},{"cca2":"TW","cca3":"TWN"},{"cca2":"TZ","cca3":"TZA"},{"cca2":"UG","cca3":"UGA"},{"cca2":"UA","cca3":"UKR"},{"cca2":"UM","cca3":"UMI"},{"cca2":"UY","cca3":"URY"},{"cca2":"US","cca3":"USA"},{"cca2":"UZ","cca3":"UZB"},{"cca2":"VA","cca3":"VAT"},{"cca2":"VC","cca3":"VCT"},{"cca2":"VE","cca3":"VEN"},{"cca2":"VG","cca3":"VGB"},{"cca2":"VI","cca3":"VIR"},{"cca2":"VN","cca3":"VNM"},{"cca2":"VU","cca3":"VUT"},{"cca2":"WF","cca3":"WLF"},{"cca2":"WS","cca3":"WSM"},{"cca2":"YE","cca3":"YEM"},{"cca2":"ZA","cca3":"ZAF"},{"cca2":"ZM","cca3":"ZMB"},{"cca2":"ZW","cca3":"ZWE"}]
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hideLoginModal = undefined;
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /**
	                    * Copyright 2013-present, Novivia, Inc.
	                    * All rights reserved.
	                    */
	
	exports.isUserLoggedIn = isUserLoggedIn;
	exports.showLoginModal = showLoginModal;
	exports.passThroughIfLoggedIn = passThroughIfLoggedIn;
	exports.bindIfLoggedIn = bindIfLoggedIn;
	
	var _language = __webpack_require__(17);
	
	var _LoginForm = __webpack_require__(224);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	var _Button = __webpack_require__(24);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Modal = __webpack_require__(169);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ContextWrapper = __webpack_require__(33);
	
	var _ContextWrapper2 = _interopRequireDefault(_ContextWrapper);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isUserLoggedIn() {
	  return !!AuctionEx.userId;
	}
	
	var LoginModal = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(LoginModal, _Component);
	
	  function LoginModal() {
	    (0, _classCallCheck3.default)(this, LoginModal);
	    return (0, _possibleConstructorReturn3.default)(this, (LoginModal.__proto__ || (0, _getPrototypeOf2.default)(LoginModal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoginModal, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _Modal2.default,
	        {
	          onHide: this.props.onHide,
	          show: this.props.visible
	        },
	        _react2.default.createElement(
	          _Modal2.default.Header,
	          { closeButton: true },
	          _react2.default.createElement(
	            _Modal2.default.Title,
	            null,
	            this.props.message
	          )
	        ),
	        _react2.default.createElement(
	          _Modal2.default.Body,
	          null,
	          _react2.default.createElement(_LoginForm2.default, {
	            csrfToken: this.props.csrfToken,
	            socialLogin: this.props.features.privateTenant ? [] : undefined,
	            registerLink: true
	          })
	        ),
	        _react2.default.createElement(
	          _Modal2.default.Footer,
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.props.onHide },
	            (0, _language.__)("general::close")
	          )
	        )
	      );
	    }
	  }]);
	  return LoginModal;
	}(_react.Component), _class.propTypes = {
	  csrfToken: _propTypes2.default.string,
	  message: _propTypes2.default.string,
	  onHide: _propTypes2.default.func,
	  visible: _propTypes2.default.bool
	}, _class.defaultProps = {
	  message: (0, _language.__)("general::pleaseLogInToContinue"),
	  onHide: function onHide() {}
	}, _temp);
	var hideLoginModal = exports.hideLoginModal = void 0;
	function renderLoginModal(isVisible, message, csrfToken) {
	  _reactDom2.default.render(_react2.default.createElement(
	    _ContextWrapper2.default,
	    { __: _language.__ },
	    _react2.default.createElement(LoginModal, {
	      features: AuctionEx.features,
	      message: message,
	      onHide: hideLoginModal,
	      visible: isVisible,
	      csrfToken: csrfToken
	    })
	  ), document.getElementById("login-modal"));
	}
	
	function showLoginModal(message, csrfToken) {
	  renderLoginModal(true, message, csrfToken);
	}
	
	exports.hideLoginModal = hideLoginModal = function hideLoginModal() {
	  renderLoginModal(false);
	};
	
	function passThroughIfLoggedIn(message, csrfToken, callback) {
	  if (!callback) {
	    callback = csrfToken;
	    csrfToken = message;
	    message = undefined;
	  }
	
	  if (isUserLoggedIn()) {
	    return callback(null, AuctionEx.userId);
	  }
	
	  showLoginModal(message, csrfToken);
	}
	
	function bindIfLoggedIn(message, csrfToken, fn) {
	  if (!fn) {
	    fn = csrfToken;
	    csrfToken = message;
	    message = undefined;
	  }
	
	  if (message) {
	    return function () {
	      var _arguments = arguments;
	
	      passThroughIfLoggedIn.call(null, message, csrfToken, function () {
	        return fn.apply(null, _arguments);
	      });
	    };
	  }
	
	  return function () {
	    var _arguments2 = arguments;
	
	    passThroughIfLoggedIn.call(null, csrfToken, function () {
	      return fn.apply(null, _arguments2);
	    });
	  };
	}

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(244);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes2.default.func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2.default.any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any,
	    onSelect: _propTypes2.default.func.isRequired,
	    getTabId: _propTypes2.default.func.isRequired,
	    getPaneId: _propTypes2.default.func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3.default)(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3.default)(this, TabContainer);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2.default.cloneElement(_react2.default.Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2.default.Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports.default = (0, _uncontrollable2.default)(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	    activeKey: _propTypes2.default.any,
	    mountOnEnter: _propTypes2.default.bool,
	    unmountOnExit: _propTypes2.default.bool,
	    onPaneEnter: _propTypes2.default.func.isRequired,
	    onPaneExited: _propTypes2.default.func.isRequired,
	    exiting: _propTypes2.default.bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3.default)(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3.default)(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2.default.Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cancelLot = cancelLot;
	exports.createLot = createLot;
	exports.updateLotInfo = updateLotInfo;
	exports.makeBid = makeBid;
	exports.makeStandardBid = makeStandardBid;
	exports.makeMaximumBid = makeMaximumBid;
	exports.watch = watch;
	exports.unwatch = unwatch;
	exports.decodeEntities = decodeEntities;
	
	var _lodash = __webpack_require__(18);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _language = __webpack_require__(17);
	
	var _security = __webpack_require__(36);
	
	var _authentication = __webpack_require__(254);
	
	var _ajax = __webpack_require__(20);
	
	var _configurations = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright 2013-present, Novivia, Inc.
	 * All rights reserved.
	 */
	
	function cancelLot(params, callback) {
	  var ajaxData = {
	    auctionId: params.auctionId,
	    lotId: params.lotId,
	    orgId: params.organizationId
	  };
	
	  (0, _ajax.simpleRequest)({
	    data: ajaxData,
	    endPoint: "lot/cancel"
	  }, callback);
	}
	
	function createLot(params, callback) {
	  var ajaxData = {
	    orgId: params.organizationId,
	    auctionId: params.auctionId,
	    lotStartingBid: params.lotStartingBid,
	    itemName: params.itemName,
	    itemDescription: params.itemDescription,
	    itemDetails: params.itemDetails,
	    itemPictures: params.itemPictures,
	    underApproval: params.underApproval
	  };
	
	  (0, _ajax.simpleRequest)({
	    endPoint: "lot/create",
	    data: ajaxData
	  }, callback);
	}
	
	function updateLotInfo(params, callback) {
	  var ajaxData = {
	    orgId: params.organizationId,
	    auctionId: params.auctionId,
	    lotId: params.lotId,
	    lotStartingBid: params.lotStartingBid,
	    itemName: params.itemName,
	    itemDescription: params.itemDescription,
	    itemDetails: params.itemDetails,
	    itemPictures: params.itemPictures,
	    underApproval: params.underApproval
	  };
	
	  (0, _ajax.simpleRequest)({
	    endPoint: "lot/info",
	    data: ajaxData
	  }, callback);
	}
	
	function makeBid(params, callback) {
	  (0, _authentication.passThroughIfLoggedIn)((0, _language.__)("auction::lot.logInToBid"), AuctionEx.csrfToken, function () {
	    var ajaxData = {
	      auctionId: params.auctionId,
	      lotId: params.lotId,
	      bidType: params.bidType,
	      bidAmount: params.bidAmount
	    };
	
	    (0, _ajax.simpleRequest)({
	      endPoint: "lot/bid",
	      data: ajaxData
	    }, callback);
	  });
	}
	
	function makeStandardBid(params, callback) {
	  makeBid(_lodash2.default.merge({}, params, { bidType: _configurations.AE_BID_TYPES.STANDARD }), callback);
	}
	
	function makeMaximumBid(params, callback) {
	  makeBid(_lodash2.default.merge({}, params, { bidType: _configurations.AE_BID_TYPES.MAXIMUM }), callback);
	}
	
	function watch(params, callback) {
	  var ajaxData = {
	    lotId: params.lotId
	  };
	
	  (0, _ajax.simpleRequest)({
	    endPoint: "lot/watch",
	    data: ajaxData
	  }, callback);
	}
	
	function unwatch(params, callback) {
	  var ajaxData = {
	    lotId: params.lotId
	  };
	
	  (0, _ajax.simpleRequest)({
	    endPoint: "lot/unwatch",
	    data: ajaxData
	  }, callback);
	}
	
	function decodeEntities(lot) {
	  lot.name = (0, _security.decodeEntities)(lot.name);
	  lot.description = lot.description && (0, _security.decodeEntities)(lot.description);
	
	  return lot;
	}

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabContainer = __webpack_require__(330);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(331);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(400);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _TabPane2.default.propTypes, {
	
	  disabled: _propTypes2.default.bool,
	
	  title: _propTypes2.default.node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes2.default.string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3.default)(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3.default)(this, Tab);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3.default)({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2.default.createElement(_TabPane2.default, props);
	  };
	
	  return Tab;
	}(_react2.default.Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2.default;
	Tab.Content = _TabContent2.default;
	Tab.Pane = _TabPane2.default;
	
	exports.default = Tab;
	module.exports = exports['default'];

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(101);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(107);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes2.default.any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /** @private * */
	  id: _propTypes2.default.string,
	
	  /** @private * */
	  'aria-labelledby': _propTypes2.default.string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes2.default.string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    getTabId: _propTypes2.default.func,
	    getPaneId: _propTypes2.default.func
	  }),
	  $bs_tabContent: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	    activeKey: _propTypes2.default.any,
	    mountOnEnter: _propTypes2.default.bool,
	    unmountOnExit: _propTypes2.default.bool,
	    onPaneEnter: _propTypes2.default.func.isRequired,
	    onPaneExited: _propTypes2.default.func.isRequired,
	    exiting: _propTypes2.default.bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2.default.oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3.default)(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3.default)(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this.in = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.in) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.in) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this.in = false;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsMountOnEnter = _props.mountOnEnter,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3.default)(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2.default : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	      process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2.default.createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2.default)(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2.default)(this.handleExited, onExited),
	          mountOnEnter: mountOnEnter,
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2.default.Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(352);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(244);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(102);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(99);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(330);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(331);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _ValidComponentChildren = __webpack_require__(87);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabContainer = _TabContainer2.default.ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2.default.any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes2.default.oneOf(['tabs', 'pills']),
	
	  animation: _propTypes2.default.bool,
	
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   *   Any eventKey,
	   *   SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2.default.forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3.default)(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3.default)(this, Tabs);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      _NavItem2.default,
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3.default)(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2.default.createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Nav2.default,
	          (0, _extends3.default)({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2.default.map(children, this.renderTab)
	        ),
	        _react2.default.createElement(
	          _TabContent2.default,
	          {
	            bsClass: bsClass,
	            animation: animation,
	            mountOnEnter: mountOnEnter,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2.default.Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports.default = (0, _uncontrollable2.default)(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /**
	                    * Copyright 2013-present, Novivia, Inc.
	                    * All rights reserved.
	                    */
	
	var _configurations = __webpack_require__(21);
	
	var _Label = __webpack_require__(97);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _currency = __webpack_require__(121);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LotStatusLabel = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(LotStatusLabel, _Component);
	
	  function LotStatusLabel() {
	    (0, _classCallCheck3.default)(this, LotStatusLabel);
	    return (0, _possibleConstructorReturn3.default)(this, (LotStatusLabel.__proto__ || (0, _getPrototypeOf2.default)(LotStatusLabel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LotStatusLabel, [{
	    key: "render",
	    value: function render() {
	      var _context = this.context,
	          __ = _context.__,
	          currency = _context.currency;
	
	
	      var bsStyle = void 0;
	      var statusMessage = void 0;
	      var extraInformation = null;
	
	      switch (this.props.status) {
	        case _configurations.AE_LOT_STATUS.OPEN:
	          statusMessage = __("lot::status.open");
	          bsStyle = "primary";
	          break;
	
	        case _configurations.AE_LOT_STATUS.CANCELLED:
	          statusMessage = __("lot::status.cancelled");
	          bsStyle = "danger";
	          break;
	
	        case _configurations.AE_LOT_STATUS.SOLD:
	          statusMessage = __("lot::status.sold");
	          bsStyle = "success";
	
	          if (this.props.winningBidAmount) {
	            extraInformation = _react2.default.createElement(
	              "span",
	              null,
	              " – ",
	              (0, _currency.formatMoney)(this.props.winningBidAmount, currency)
	            );
	          }
	          break;
	
	        default:
	          bsStyle = "default";
	          statusMessage = __("general::unknown");
	      }
	
	      return _react2.default.createElement(
	        _Label2.default,
	        {
	          bsStyle: bsStyle,
	          className: "lot-status-label"
	        },
	        statusMessage.toUpperCase(),
	        extraInformation
	      );
	    }
	  }]);
	  return LotStatusLabel;
	}(_react.Component), _class.propTypes = {
	  // Status of the lot.
	  status: _propTypes2.default.oneOf(_configurations.AE_LOT_STATUS.getValues()),
	
	  // Amount the the lot was sold for.
	  winningBidAmount: _propTypes2.default.number
	}, _class.contextTypes = {
	  // Translation utility.
	  __: _propTypes2.default.func.isRequired,
	
	  // ISO code for the currency to use when displaying amounts of money.
	  currency: _propTypes2.default.string
	}, _temp);
	exports.default = LotStatusLabel;
	module.exports = exports["default"];

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2; /**
	                     * Copyright 2013-present, Novivia, Inc.
	                     * All rights reserved.
	                     */
	
	var _Button = __webpack_require__(24);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(30);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Button that allow to watch either an auction or a lot.
	 * @class
	 */
	var WatchButton = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(WatchButton, _Component);
	
	  function WatchButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, WatchButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WatchButton.__proto__ || (0, _getPrototypeOf2.default)(WatchButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      // FIXME: Trigger a modal when there's an error.
	      watchErrors: null,
	
	      watched: _this.props.watched || _this.isWatched(_this.props.type)
	    }, _this.onChange = function () {
	      if (_this.props.onChange) {
	        _this.props.onChange(_this.state.watched);
	      }
	    }, _this.handleClick = function () {
	      if (!_this.props.disabled) {
	        var setWatch = null;
	        var toSet = null;
	
	        if (_this.props.type === "auction") {
	          setWatch = _this.state.watched ? _this.props.actions.auction.unwatch : _this.props.actions.auction.watch;
	
	          toSet = {
	            auctionId: _this.props.auctionId
	          };
	        } else if (_this.props.type === "lot") {
	          setWatch = _this.state.watched ? _this.props.actions.lot.unwatch : _this.props.actions.lot.watch;
	          toSet = {
	            lotId: _this.props.lotId
	          };
	        }
	
	        if (setWatch && toSet) {
	          setWatch(toSet, function (err) {
	            if (!err) {
	              return _this.setState(function (state) {
	                return { watched: !state.watched };
	              }, _this.onChange);
	            }
	
	            _this.setState({
	              watchErrors: err || null
	            });
	          });
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(WatchButton, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.type !== this.props.type || this.props.watchedLots && nextProps.watchedLots.length !== this.props.watchedLots.length || this.props.watchedAuctions && nextProps.watchedAuctions.length !== this.props.watchedAuctions.length) {
	        this.setState({
	          watched: this.isWatched(nextProps.type)
	        });
	      }
	    }
	  }, {
	    key: "isWatched",
	    value: function isWatched(type) {
	      var listWatched = void 0;
	      var watchedId = void 0;
	      if (type === "auction") {
	        listWatched = this.props.watchedAuctions;
	        watchedId = this.props.auctionId;
	      } else {
	        listWatched = this.props.watchedLots;
	        watchedId = this.props.lotId;
	      }
	
	      return listWatched && ~listWatched.indexOf(watchedId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var __ = this.context.__;
	
	
	      var buttonText = this.props.type === "auction" ? __("auction::catalog.watchThisAuction") : __("auction::catalog.watchThisLot");
	      var buttonIcon = _react2.default.createElement(_Icon2.default, { name: "eye" });
	
	      if (this.state.watched) {
	        buttonIcon = _react2.default.createElement(_Icon2.default, { name: "eye-slash" });
	        buttonText = this.props.type === "auction" ? __("auction::catalog.unwatchThisAuction") : __("auction::catalog.unwatchThisLot");
	      }
	
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          bsSize: "xsmall",
	          bsStyle: "default",
	          disabled: this.props.disabled,
	          onClick: this.handleClick
	        },
	        buttonIcon,
	        " ",
	        buttonText
	      );
	    }
	  }]);
	  return WatchButton;
	}(_react.Component), _class.propTypes = {
	  // Auction on the lot or auction watch button.
	  actions: _propTypes2.default.object.isRequired,
	
	  // Id of the auction to watch.
	  auctionId: _propTypes2.default.string,
	
	  // The watch button is disabled.
	  disabled: _propTypes2.default.bool,
	
	  // Id of the lot to watch
	  lotId: _propTypes2.default.string,
	
	  // Amount to display.
	  type: _propTypes2.default.oneOf(["auction", "lot"]).isRequired,
	
	  // Whether the thing to watch is initially watched.
	  watched: _propTypes2.default.bool,
	
	  // List of watched auctions id of user.
	  watchedAuctions: _propTypes2.default.arrayOf(_propTypes2.default.string),
	
	  // List of watched lots id of user.
	  watchedLots: _propTypes2.default.arrayOf(_propTypes2.default.string),
	
	  // Event fired when the entity is watched/unwatched.
	  onChange: _propTypes2.default.func
	}, _class.defaultProps = {
	  disabled: false
	}, _class.contextTypes = {
	  // Translation utility.
	  __: _propTypes2.default.func.isRequired
	}, _temp2);
	exports.default = WatchButton;
	module.exports = exports["default"];

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3.default)(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3.default)(this, HelpBlock);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _taggedTemplateLiteral2 = __webpack_require__(27);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2; /**
	                     * Copyright 2013-present, Novivia, Inc.
	                     * All rights reserved.
	                     */
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n                            ", "px\n                            ", "\n                            solid\n                          "], ["\n                            ", "px\n                            ", "\n                            solid\n                          "]);
	
	var _Button = __webpack_require__(24);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FormControl = __webpack_require__(28);
	
	var _FormControl2 = _interopRequireDefault(_FormControl);
	
	var _InputGroup = __webpack_require__(136);
	
	var _InputGroup2 = _interopRequireDefault(_InputGroup);
	
	var _Table = __webpack_require__(92);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Icon = __webpack_require__(30);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _currency = __webpack_require__(121);
	
	var _commonTags = __webpack_require__(383);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Table that displays the bid increments for an auction and allows to edit
	 * them.
	 * @class
	 */
	var BidIncrementsEditor = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(BidIncrementsEditor, _Component);
	
	  function BidIncrementsEditor() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BidIncrementsEditor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BidIncrementsEditor.__proto__ || (0, _getPrototypeOf2.default)(BidIncrementsEditor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      // Current increments, initially loaded with the provided ones.
	      increments: _this.props.increments.map(function (increment) {
	        // FIXME: Remove after a deprecation cycle.
	        if (increment.hasOwnProperty("jump")) {
	          return increment;
	        }
	
	        console.warn("The use of 'increment' has been deprecated. Please favor 'jump'.");
	
	        var modifiedIncrement = (0, _extends3.default)({}, increment);
	        increment.jump = increment.increment;
	
	        return modifiedIncrement;
	      })
	    }, _this.handleIncrementsChange = function () {
	      var onIncrementsChange = _this.props.onIncrementsChange;
	      var increments = _this.state.increments;
	
	      // Send up the new increments.
	
	      onIncrementsChange && onIncrementsChange(increments);
	    }, _this.handleUpdateIncrementJump = function (index, e) {
	      var increments = _this.state.increments;
	
	
	      var newIncrementJump = parseFloat(e.target.value);
	
	      if (isNaN(newIncrementJump)) {
	        return;
	      }
	
	      increments[index].jump = newIncrementJump;
	
	      // FIXME: Remove in next breaking version.
	      increments[index].increment = increments[index].jump;
	
	      _this.setState({ increments: increments }, function () {
	        return _this.handleIncrementsChange();
	      });
	    }, _this.handleUpdateIncrementStart = function (index, e) {
	      var increments = _this.state.increments;
	
	
	      var newIncrementStart = parseFloat(e.target.value);
	
	      if (isNaN(newIncrementStart)) {
	        return;
	      }
	
	      increments[index].start = newIncrementStart;
	
	      _this.setState({ increments: increments }, function () {
	        return _this.handleIncrementsChange();
	      });
	    }, _this.handleAddIncrement = function (index) {
	      var increments = _this.state.increments;
	
	
	      var isLast = index === increments.length - 1;
	
	      increments.splice(index, 0, {
	        // FIXME: Remove in next breaking version.
	        increment: increments[index].jump,
	        jump: increments[index].jump,
	        start: isLast ? increments[index].start + 0.01 : increments[index + 1].start - 0.01
	      });
	
	      _this.setState({ increments: BidIncrementsEditor.sortIncrements(increments) }, function () {
	        return _this.handleIncrementsChange();
	      });
	    }, _this.handleRemoveIncrement = function (index) {
	      var increments = _this.state.increments;
	
	      // Technically this shouldn't happen, but better safe than sorry.
	
	      if (increments.length <= 1) {
	        return;
	      }
	
	      // If we removed the first increment, lower the second one's start point
	      // to 0.
	      if (index === 0) {
	        increments[1].start = 0;
	      }
	
	      increments.splice(index, 1);
	
	      _this.setState({ increments: increments }, function () {
	        return _this.handleIncrementsChange();
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  /**
	   * Sort the increments from the lowest "start" value to the highest.
	   * @param  {array} increments Increments to sort.
	   * @return {array}            Sorted increments.
	   */
	
	
	  (0, _createClass3.default)(BidIncrementsEditor, [{
	    key: "shouldComponentUpdate",
	
	
	    // We try to avoid a lot of useless rerenders when we are not editing the
	    // increments.
	    value: function shouldComponentUpdate(_ref2) {
	      var highlightCurrentBid = _ref2.highlightCurrentBid;
	      var _props = this.props,
	          currentHighlightCurrentBid = _props.highlightCurrentBid,
	          isReadOnly = _props.readOnly;
	
	
	      if (!isReadOnly) {
	        return true;
	      }
	
	      return highlightCurrentBid !== currentHighlightCurrentBid;
	    }
	
	    /**
	     * Event fired when the increments are modified.
	     */
	
	
	    /**
	     * Updates the properties of the new increment in the state based on the
	     * values inputed in the fields.
	     */
	
	
	    /**
	     * Updates the properties of the new increment in the state based on the
	     * values inputed in the fields.
	     */
	
	
	    /**
	     * Add a new increment at a specific index.
	     */
	
	
	    /**
	     * Remove an existing increment at a specific index.
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var __ = this.context.__;
	      var increments = this.state.increments;
	      var _props2 = this.props,
	          className = _props2.className,
	          currencyType = _props2.currencyType,
	          isReadOnly = _props2.readOnly,
	          highlightCurrentBid = _props2.highlightCurrentBid;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "bid-increments-editor" },
	        _react2.default.createElement(
	          "div",
	          { className: className },
	          _react2.default.createElement(
	            _Table2.default
	            // FIXME: We have to do this otherwise there is a decade-old nasty
	            // bug in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=332740
	            ,
	            { style: { borderCollapse: "separate" },
	              responsive: true
	            },
	            _react2.default.createElement(
	              "thead",
	              null,
	              _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                  "th",
	                  { colSpan: 3, width: "80%" },
	                  __("general::amount_plural")
	                ),
	                _react2.default.createElement(
	                  "th",
	                  { width: "20%" },
	                  __("general::increment_plural")
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "tbody",
	              null,
	              increments.reduce(function (rows, increment, index) {
	                var isFirst = index === 0;
	                var isLast = index === increments.length - 1;
	
	
	                var highlightCurrentIncrement = isReadOnly && highlightCurrentBid >= increment.start && (isLast || highlightCurrentBid < increments[index + 1].start);
	
	                rows.push.apply(rows, [_react2.default.createElement(
	                  "tr",
	                  { key: "1-" + index },
	                  _react2.default.createElement(
	                    "td",
	                    {
	                      rowSpan: 2,
	                      style: {
	                        borderTop: isFirst ? "inherit" : 0,
	                        textAlign: "right"
	                      },
	                      width: isReadOnly ? "49%" : "10%"
	                    },
	                    isFirst ? _react2.default.createElement(
	                      "strong",
	                      null,
	                      (0, _currency.formatMoney)(0, currencyType)
	                    ) : isReadOnly ? (0, _currency.formatMoney)(increment.start, currencyType) : _react2.default.createElement(_FormControl2.default, {
	                      max: !isLast ? increments[index + 1].start - 0.01 : undefined,
	                      min: isFirst ? 0.01 : increments[index - 1].start + 0.01,
	                      step: "0.01",
	                      style: { textAlign: "right" },
	                      type: "number",
	                      value: increment.start,
	                      onChange: function onChange(e) {
	                        return _this2.handleUpdateIncrementStart(index, e);
	                      }
	                    })
	                  ),
	                  _react2.default.createElement("td", {
	                    style: {
	                      borderBottom: "1px black solid",
	                      borderRight: isFirst ? 0 : "1px black solid",
	                      borderTop: isFirst ? "inherit" : 0
	                    },
	                    width: "1%"
	                  }),
	                  _react2.default.createElement("td", {
	                    rowSpan: 2,
	                    style: { borderTop: isFirst ? "inherit" : 0 },
	                    width: "1%"
	                  }),
	                  _react2.default.createElement(
	                    "td",
	                    {
	                      className: !isReadOnly ? "text-center" : "text-left",
	                      rowSpan: 2,
	                      style: {
	                        borderTop: isFirst ? "inherit" : 0,
	                        verticalAlign: "middle"
	                      },
	                      width: isReadOnly ? "49%" : undefined
	                    },
	                    !isFirst ? _react2.default.createElement(_Icon2.default, { name: "chevron-down" }) : null
	                  )
	                ), _react2.default.createElement(
	                  "tr",
	                  { key: "2-" + index },
	                  _react2.default.createElement("td", {
	                    style: {
	                      borderRight: "1px black solid",
	                      borderTop: 0
	                    }
	                  })
	                ), _react2.default.createElement(
	                  "tr",
	                  { key: "3-" + index },
	                  _react2.default.createElement(
	                    "td",
	                    {
	                      rowSpan: 2,
	                      style: {
	                        borderTop: 0,
	                        textAlign: "right",
	                        verticalAlign: "middle"
	                      }
	                    },
	                    !isReadOnly ? _react2.default.createElement(
	                      _Button2.default,
	                      {
	                        bsStyle: "success",
	                        block: true,
	                        onClick: function onClick() {
	                          return _this2.handleAddIncrement(index);
	                        }
	                      },
	                      _react2.default.createElement(_Icon2.default, { name: "plus" }),
	                      " ",
	                      __("increments::addHere")
	                    ) : null
	                  ),
	                  _react2.default.createElement("td", {
	                    rowSpan: 2,
	                    style: {
	                      borderRight: "1px black solid",
	                      borderTop: 0
	                    },
	                    width: "1%"
	                  }),
	                  _react2.default.createElement("td", {
	                    style: {
	                      borderBottom: (0, _commonTags.oneLine)(_templateObject, highlightCurrentIncrement ? "2" : "1", highlightCurrentIncrement ? "green" : "black"),
	                      borderTop: 0
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "td",
	                    { rowSpan: 2, style: { borderTop: 0 } },
	                    isReadOnly ? _react2.default.createElement(
	                      "span",
	                      {
	                        className: highlightCurrentIncrement ? "text-success" : "",
	                        style: highlightCurrentIncrement ? { fontWeight: "bold" } : undefined
	                      },
	                      (0, _currency.formatMoney)(increment.jump, currencyType),
	                      " ",
	                      highlightCurrentIncrement ? _react2.default.createElement(_Icon2.default, { name: "arrow-left" }) : null
	                    ) : _react2.default.createElement(
	                      _InputGroup2.default,
	                      null,
	                      _react2.default.createElement(_FormControl2.default, {
	                        step: "0.01",
	                        type: "number",
	                        value: increment.jump,
	                        onChange: function onChange(e) {
	                          return _this2.handleUpdateIncrementJump(index, e);
	                        }
	                      }),
	                      !(isFirst && isLast) ? _react2.default.createElement(
	                        _InputGroup2.default.Button,
	                        null,
	                        _react2.default.createElement(
	                          _Button2.default,
	                          {
	                            bsStyle: "danger",
	                            onClick: function onClick() {
	                              return _this2.handleRemoveIncrement(index);
	                            }
	                          },
	                          _react2.default.createElement(_Icon2.default, { name: "minus" }),
	                          " ",
	                          __("general::remove")
	                        )
	                      ) : null
	                    )
	                  )
	                ), _react2.default.createElement(
	                  "tr",
	                  { key: "4-" + index },
	                  _react2.default.createElement("td", { style: { borderTop: 0 } })
	                )]);
	
	                if (isLast) {
	                  rows.push.apply(rows, [_react2.default.createElement(
	                    "tr",
	                    { key: "last-1-" + index },
	                    _react2.default.createElement(
	                      "td",
	                      {
	                        rowSpan: 2,
	                        style: {
	                          borderTop: 0,
	                          textAlign: "right"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        __("general::infinity")
	                      )
	                    ),
	                    _react2.default.createElement("td", {
	                      style: {
	                        borderBottom: "1px black solid",
	                        borderRight: "1px black solid",
	                        borderTop: 0
	                      }
	                    }),
	                    _react2.default.createElement("td", {
	                      style: {
	                        borderTop: 0
	                      }
	                    }),
	                    _react2.default.createElement("td", {
	                      className: "text-center",
	                      rowSpan: 2,
	                      style: {
	                        borderTop: 0,
	                        verticalAlign: "middle"
	                      }
	                    })
	                  ), _react2.default.createElement(
	                    "tr",
	                    { key: "last-2-" + index },
	                    _react2.default.createElement("td", {
	                      style: {
	                        borderRight: 0,
	                        borderTop: 0
	                      }
	                    }),
	                    _react2.default.createElement("td", {
	                      style: {
	                        borderLeft: 0,
	                        borderTop: 0
	                      }
	                    })
	                  )]);
	                }
	
	                return rows;
	              }, [])
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return BidIncrementsEditor;
	}(_react.Component), _class.propTypes = {
	  className: _propTypes2.default.string,
	
	  // Currency in which the increments are provided.
	  currencyType: _propTypes2.default.string.isRequired,
	
	  // Amount of the current bid, provided to highlight its bracket.
	  highlightCurrentBid: _propTypes2.default.number,
	
	  // Different levels of increments.
	  increments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    // FIXME: This one really should be called jump.
	    increment: _propTypes2.default.number,
	
	    jump: _propTypes2.default.number.isRequired,
	
	    start: _propTypes2.default.number.isRequired
	  }).isRequired).isRequired,
	
	  // If set, disables all editing functionality.
	  readOnly: _propTypes2.default.bool,
	
	  // Event fired when the increments are modified.
	  onIncrementsChange: _propTypes2.default.func
	}, _class.contextTypes = {
	  // Translation utility.
	  __: _propTypes2.default.func.isRequired
	}, _class.sortIncrements = function (increments) {
	  return increments.sort(function (increment1, increment2) {
	    return increment1.start - increment2.start;
	  });
	}, _temp2);
	exports.default = BidIncrementsEditor;
	module.exports = exports["default"];

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(661);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _propTypes2.default.oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes2.default.func,
	  active: _propTypes2.default.bool,
	  animateIn: _propTypes2.default.bool,
	  animateOut: _propTypes2.default.bool,
	  index: _propTypes2.default.number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3.default)(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3.default)(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2.default.addEndEventListener(_reactDom2.default.findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, props, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2.default.Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports.default = CarouselItem;
	module.exports = exports['default'];

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(122);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _ListOption = __webpack_require__(472);
	
	var _ListOption2 = _interopRequireDefault(_ListOption);
	
	var _propTypes3 = __webpack_require__(243);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _compat = __webpack_require__(251);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(180);
	
	var _3 = _interopRequireDefault(_2);
	
	var _warning = __webpack_require__(527);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _dataHelpers = __webpack_require__(386);
	
	var _widgetHelpers = __webpack_require__(333);
	
	var _interaction = __webpack_require__(382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var optionId = function optionId(id, idx) {
	  return id + '__option__' + idx;
	};
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'List',
	
	  mixins: [__webpack_require__(564), __webpack_require__(344)()],
	
	  propTypes: {
	    data: _propTypes2.default.array,
	    onSelect: _propTypes2.default.func,
	    onMove: _propTypes2.default.func,
	
	    optionComponent: _propTypes4.default.elementType,
	    itemComponent: _propTypes4.default.elementType,
	    groupComponent: _propTypes4.default.elementType,
	
	    selected: _propTypes2.default.any,
	    focused: _propTypes2.default.any,
	
	    valueField: _propTypes4.default.accessor,
	    textField: _propTypes4.default.accessor,
	
	    disabled: _propTypes4.default.disabled.acceptsArray,
	    readOnly: _propTypes4.default.readOnly.acceptsArray,
	
	    groupBy: _propTypes4.default.accessor,
	
	    messages: _propTypes2.default.shape({
	      emptyList: _propTypes4.default.message
	    })
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSelect: function onSelect() {},
	      data: [],
	      optionComponent: _ListOption2.default,
	      ariaActiveDescendantKey: 'groupedList',
	      messages: {
	        emptyList: 'There are no items in this list'
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    var keys = [];
	
	    return {
	      groups: this._group(this.props.groupBy, this.props.data, keys),
	
	      sortedKeys: keys
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var keys = [];
	
	    if (nextProps.data !== this.props.data || nextProps.groupBy !== this.props.groupBy) this.setState({
	      groups: this._group(nextProps.groupBy, nextProps.data, keys),
	      sortedKeys: keys
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.move();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.ariaActiveDescendant(this._currentActiveID);
	    this.move();
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        className = _props.className,
	        role = _props.role,
	        data = _props.data,
	        messages = _props.messages;
	    var _state = this.state,
	        sortedKeys = _state.sortedKeys,
	        groups = _state.groups;
	
	
	    var elementProps = _3.default.omitOwnProps(this);
	
	    var items = [],
	        idx = -1,
	        group = void 0;
	
	    var id = (0, _widgetHelpers.instanceId)(this);
	
	    this._currentActiveID = null;
	
	    if (data.length) {
	      items = sortedKeys.reduce(function (items, key) {
	        group = groups[key];
	        items.push(_this._renderGroupHeader(key));
	
	        for (var itemIdx = 0; itemIdx < group.length; itemIdx++) {
	          items.push(_this._renderItem(key, group[itemIdx], ++idx));
	        }return items;
	      }, []);
	    } else items = _react2.default.createElement(
	      'li',
	      { className: 'rw-list-empty' },
	      _3.default.result(messages.emptyList, this.props)
	    );
	
	    return _react2.default.createElement(
	      'ul',
	      _extends({
	        ref: 'scrollable',
	        id: id,
	        tabIndex: '-1',
	        className: (0, _classnames2.default)(className, 'rw-list', 'rw-list-grouped'),
	        role: role === undefined ? 'listbox' : role
	      }, elementProps),
	      items
	    );
	  },
	  _renderGroupHeader: function _renderGroupHeader(group) {
	    var GroupComponent = this.props.groupComponent,
	        id = (0, _widgetHelpers.instanceId)(this);
	
	    return _react2.default.createElement(
	      'li',
	      {
	        key: 'item_' + group,
	        tabIndex: '-1',
	        role: 'separator',
	        id: id + '_group_' + group,
	        className: 'rw-list-optgroup'
	      },
	      GroupComponent ? _react2.default.createElement(GroupComponent, { item: group }) : group
	    );
	  },
	  _renderItem: function _renderItem(group, item, idx) {
	    var _props2 = this.props,
	        focused = _props2.focused,
	        selected = _props2.selected,
	        onSelect = _props2.onSelect,
	        textField = _props2.textField,
	        valueField = _props2.valueField,
	        ItemComponent = _props2.itemComponent,
	        Option = _props2.optionComponent;
	
	
	    var currentID = optionId((0, _widgetHelpers.instanceId)(this), idx),
	        isDisabled = (0, _interaction.isDisabledItem)(item, this.props),
	        isReadOnly = (0, _interaction.isReadOnlyItem)(item, this.props);
	
	    if (focused === item) this._currentActiveID = currentID;
	
	    return _react2.default.createElement(
	      Option,
	      {
	        key: 'item_' + group + '_' + idx,
	        id: currentID,
	        dataItem: item,
	        focused: focused === item,
	        selected: selected === item,
	        disabled: isDisabled,
	        readOnly: isReadOnly,
	        onClick: isDisabled || isReadOnly ? undefined : onSelect.bind(null, item)
	      },
	      ItemComponent ? _react2.default.createElement(ItemComponent, {
	        item: item,
	        value: (0, _dataHelpers.dataValue)(item, valueField),
	        text: (0, _dataHelpers.dataText)(item, textField),
	        disabled: isDisabled,
	        readOnly: isReadOnly
	      }) : (0, _dataHelpers.dataText)(item, textField)
	    );
	  },
	  _isIndexOf: function _isIndexOf(idx, item) {
	    return this.props.data[idx] === item;
	  },
	  _group: function _group(groupBy, data, keys) {
	    var iter = typeof groupBy === 'function' ? groupBy : function (item) {
	      return item[groupBy];
	    };
	
	    // the keys array ensures that groups are rendered in the order they came in
	    // which means that if you sort the data array it will render sorted,
	    // so long as you also sorted by group
	    keys = keys || [];
	
	    (0, _warning2.default)(typeof groupBy !== 'string' || !data.length || _3.default.has(data[0], groupBy), '[React Widgets] You seem to be trying to group this list by a ' + ('property `' + groupBy + '` that doesn\'t exist in the dataset items, this may be a typo'));
	
	    return data.reduce(function (grps, item) {
	      var group = iter(item);
	
	      _3.default.has(grps, group) ? grps[group].push(item) : (keys.push(group), grps[group] = [item]);
	
	      return grps;
	    }, {});
	  },
	  _data: function _data() {
	    var groups = this.state.groups;
	
	    return this.state.sortedKeys.reduce(function (flat, grp) {
	      return flat.concat(groups[grp]);
	    }, []);
	  },
	  move: function move() {
	    var selected = this.getItemDOMNode(this.props.focused);
	
	    if (!selected) return;
	
	    (0, _widgetHelpers.notify)(this.props.onMove, [selected, _compat2.default.findDOMNode(this), this.props.focused]);
	  },
	  getItemDOMNode: function getItemDOMNode(item) {
	    var list = _compat2.default.findDOMNode(this),
	        groups = this.state.groups,
	        idx = -1,
	        itemIdx,
	        child;
	
	    this.state.sortedKeys.some(function (group) {
	      itemIdx = groups[group].indexOf(item);
	      idx++;
	
	      if (itemIdx !== -1) return !!(child = list.children[idx + itemIdx + 1]);
	
	      idx += groups[group].length;
	    });
	
	    return child;
	  }
	});
	module.exports = exports['default'];

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports.default = validateListComponent;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS = ['next', 'prev', 'first', 'last'];
	
	function validateListComponent(list) {
	  if (process.env.NODE_ENV !== 'production') {
	    METHODS.forEach(function (method) {
	      return (0, _invariant2.default)(typeof list[method] === 'function', 'List components must implement a `' + method + '()` method');
	    });
	  }
	}
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /**
	                    * Copyright 2013-present, Novivia, Inc.
	                    * All rights reserved.
	                    */
	
	var _ShareButton = __webpack_require__(578);
	
	var _ShareButton2 = _interopRequireDefault(_ShareButton);
	
	var _ButtonToolbar = __webpack_require__(155);
	
	var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);
	
	var _Icon = __webpack_require__(30);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Social sharing bar.
	 * @class
	 */
	var ShareBar = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(ShareBar, _Component);
	
	  function ShareBar() {
	    (0, _classCallCheck3.default)(this, ShareBar);
	    return (0, _possibleConstructorReturn3.default)(this, (ShareBar.__proto__ || (0, _getPrototypeOf2.default)(ShareBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ShareBar, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "sharebar" },
	        _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(_Icon2.default, { name: "share-alt" }),
	          _react2.default.createElement(
	            "strong",
	            null,
	            " " + this.props.shared + ": "
	          )
	        ),
	        _react2.default.createElement(
	          _ButtonToolbar2.default,
	          null,
	          this.props.services.map(function (service, index) {
	            return _react2.default.createElement(_ShareButton2.default, {
	              key: index,
	              title: _this2.props.title,
	              type: service
	            });
	          })
	        )
	      );
	    }
	  }]);
	  return ShareBar;
	}(_react.Component), _class.propTypes = {
	  // Services
	  services: _propTypes2.default.arrayOf(_propTypes2.default.string),
	
	  // Sharing label.
	  shared: _propTypes2.default.string.isRequired,
	
	  // Title
	  title: _propTypes2.default.string
	}, _class.defaultProps = {
	  services: ["google-plus", "facebook", "twitter", "pinterest", "linkedin", "reddit", "email"]
	}, _temp);
	exports.default = ShareBar;
	module.exports = exports["default"];

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _keys = __webpack_require__(336);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(462);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _taggedTemplateLiteral2 = __webpack_require__(27);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _class, _temp2;
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n      //www.linkedin.com/shareArticle\n      ?mini=true\n      &url=%url\n      &title=%title\n      &summary=\n      &source=%url\n    "], ["\n      //www.linkedin.com/shareArticle\n      ?mini=true\n      &url=%url\n      &title=%title\n      &summary=\n      &source=%url\n    "]),
	    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n            menubar=no,\n            toolbar=no,\n            resizable=yes,\n            scrollbars=yes,\n            height=", ",\n            width=", "\n          "], ["\n            menubar=no,\n            toolbar=no,\n            resizable=yes,\n            scrollbars=yes,\n            height=", ",\n            width=", "\n          "]); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                            * Copyright 2013-present, Novivia, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                            * All rights reserved.
	                                                                                                                                                                                                                                                                                                                                                                                                                            */
	
	var _Button = __webpack_require__(24);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(30);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _tempura = __webpack_require__(31);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Sharing platforms dictionary
	var sharePlatforms = {
	  email: {
	    icon: "envelope-o",
	    name: function name(_ref) {
	      var __ = _ref.context.__;
	      return __("contact::email");
	    },
	    style: "adn"
	  },
	  facebook: {
	    height: 600,
	    name: "Facebook",
	    url: "//www.facebook.com/sharer/sharer.php?u=%url",
	    width: 600
	  },
	  "google-plus": {
	    height: 600,
	    name: "Google+",
	    url: "//plus.google.com/share?url=%url",
	    width: 600
	  },
	  linkedin: {
	    height: 600,
	    name: "LinkedIn",
	    url: (0, _tempura.noWhitespace)(_templateObject),
	    width: 600
	  },
	  pinterest: {
	    height: 300,
	    name: "Pinterest",
	    style: "google-plus",
	    url: "//pinterest.com/pin/create/button/?url=%url",
	    width: 600
	  },
	  reddit: {
	    height: 800,
	    name: "Reddit",
	    url: "//www.reddit.com/submit?url=%url",
	    width: 1000
	  },
	  twitter: {
	    height: 300,
	    name: "Twitter",
	    url: "//twitter.com/home?status=%url",
	    widht: 600
	  }
	};
	
	/**
	 * Social sharing button
	 * @class
	 */
	var ShareButton = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(ShareButton, _Component);
	
	  function ShareButton() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ShareButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ShareButton.__proto__ || (0, _getPrototypeOf2.default)(ShareButton)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      title: _this.props.title,
	      url: _this.props.url
	    }, _this.handleShareOn = function (platform) {
	      var _this$state = _this.state,
	          title = _this$state.title,
	          url = _this$state.url;
	
	
	      switch (platform) {
	        case "email":
	          document.location.href = "mailto:?body=" + url;
	          break;
	
	        default:
	          {
	            var platformData = sharePlatforms[platform];
	
	            var href = platformData.url.replace("%url", url).replace("%title", title);
	
	            var _platformData$height = platformData.height,
	                height = _platformData$height === undefined ? 800 : _platformData$height,
	                _platformData$width = platformData.width,
	                width = _platformData$width === undefined ? 600 : _platformData$width;
	
	
	            window.open(href, "", (0, _tempura.noWhitespace)(_templateObject2, height, width));
	            break;
	          }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ShareButton, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({
	        title: this.state.title || document.title,
	        url: this.state.url || encodeURIComponent(window.location)
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var type = this.props.type;
	      var _sharePlatforms$type = sharePlatforms[type],
	          _sharePlatforms$type$ = _sharePlatforms$type.icon,
	          icon = _sharePlatforms$type$ === undefined ? type : _sharePlatforms$type$,
	          _sharePlatforms$type$2 = _sharePlatforms$type.name,
	          name = _sharePlatforms$type$2 === undefined ? type : _sharePlatforms$type$2,
	          _sharePlatforms$type$3 = _sharePlatforms$type.style,
	          style = _sharePlatforms$type$3 === undefined ? type : _sharePlatforms$type$3;
	
	
	      var computedName = typeof name === "function" ? name(this) : name;
	
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          "aria-label": computedName,
	          bsSize: "xsmall",
	          className: (0, _classnames2.default)((0, _defineProperty3.default)({
	            "btn-social-icon": true
	          }, "btn-" + style, true)),
	          onClick: function onClick() {
	            return _this2.handleShareOn(_this2.props.type);
	          }
	        },
	        _react2.default.createElement(_Icon2.default, { name: icon })
	      );
	    }
	  }]);
	  return ShareButton;
	}(_react.Component), _class.propTypes = {
	  // Title of the page to share.
	  title: _propTypes2.default.string,
	
	  // Type of the sharing method.
	  type: _propTypes2.default.oneOf((0, _keys2.default)(sharePlatforms)).isRequired,
	
	  // URL of the page to share.
	  url: _propTypes2.default.string
	}, _class.defaultProps = {
	  title: "",
	  url: ""
	}, _class.contextTypes = {
	  // Translation utility.
	  __: _propTypes2.default.func.isRequired
	}, _temp2);
	exports.default = ShareButton;
	module.exports = exports["default"];

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _map = __webpack_require__(257);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2; /**
	                     * Copyright 2013-present, Novivia, Inc.
	                     * All rights reserved.
	                     */
	
	var _configurations = __webpack_require__(21);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AcceptedPaymentMethods = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(AcceptedPaymentMethods, _Component);
	
	  function AcceptedPaymentMethods() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AcceptedPaymentMethods);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AcceptedPaymentMethods.__proto__ || (0, _getPrototypeOf2.default)(AcceptedPaymentMethods)).call.apply(_ref, [this].concat(args))), _this), _this.paymentMethodNames = new _map2.default([[_configurations.AE_PAYMENT_TYPES.AMEX, _this.context.__("paymentMethods::sources.amex")], [_configurations.AE_PAYMENT_TYPES.BANKDRAFT, _this.context.__("paymentMethods::sources.bdft")], [_configurations.AE_PAYMENT_TYPES.CERTIFIED_CHEQUE, _this.context.__("paymentMethods::sources.cchq")], [_configurations.AE_PAYMENT_TYPES.CHEQUE, _this.context.__("paymentMethods::sources.pchq")], [_configurations.AE_PAYMENT_TYPES.MASTERCARD, _this.context.__("paymentMethods::sources.mast")], [_configurations.AE_PAYMENT_TYPES.SPECIE, _this.context.__("paymentMethods::sources.cash")], [_configurations.AE_PAYMENT_TYPES.TRANSFER, _this.context.__("paymentMethods::sources.btra")], [_configurations.AE_PAYMENT_TYPES.VISA, _this.context.__("paymentMethods::sources.visa")]]), _this.renderPaymentMethods = function () {
	      var __ = _this.context.__;
	      var paymentMethods = _this.props.paymentMethods;
	
	      // No methods of payment.
	
	      if (!paymentMethods.length) {
	        return _react2.default.createElement(
	          "em",
	          null,
	          __("organization::noMethodsOfPayment")
	        );
	      }
	
	      // Only one method of payment.
	      if (paymentMethods.length === 1) {
	        return _this.paymentMethodNames.get(paymentMethods[0]);
	      }
	
	      // Two or more methods of payment.
	      return _react2.default.createElement(
	        "ul",
	        null,
	        paymentMethods.map(function (type, index) {
	          return _react2.default.createElement(
	            "li",
	            { key: index },
	            _this.paymentMethodNames.get(type)
	          );
	        })
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AcceptedPaymentMethods, [{
	    key: "render",
	    value: function render() {
	      var __ = this.context.__;
	      var paymentMethods = this.props.paymentMethods;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h6",
	          null,
	          __("organization::methodsOfPayment", { count: paymentMethods.length === 1 ? 1 : 2 })
	        ),
	        this.renderPaymentMethods()
	      );
	    }
	  }]);
	  return AcceptedPaymentMethods;
	}(_react.Component), _class.propTypes = {
	  paymentMethods: _propTypes2.default.array
	}, _class.contextTypes = {
	  __: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	  paymentMethods: []
	}, _temp2);
	exports.default = AcceptedPaymentMethods;
	module.exports = exports["default"];

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(598), __esModule: true };

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(589);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(151);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(226);
	__webpack_require__(219);
	module.exports = __webpack_require__(618);


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(482);
	var ITERATOR = __webpack_require__(245)('iterator');
	var Iterators = __webpack_require__(414);
	module.exports = __webpack_require__(108).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CarouselCaption = __webpack_require__(657);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(508);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(95);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(105);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _ValidComponentChildren = __webpack_require__(87);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _propTypes2.default.bool,
	  indicators: _propTypes2.default.bool,
	  /**
	   * The amount of time to delay between automatically cycling an item.
	   * If `null`, carousel will not automatically cycle.
	   */
	  interval: _propTypes2.default.number,
	  controls: _propTypes2.default.bool,
	  pauseOnHover: _propTypes2.default.bool,
	  wrap: _propTypes2.default.bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes2.default.func,
	  onSlideEnd: _propTypes2.default.func,
	  activeIndex: _propTypes2.default.number,
	  defaultActiveIndex: _propTypes2.default.number,
	  direction: _propTypes2.default.oneOf(['prev', 'next']),
	  prevIcon: _propTypes2.default.node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes2.default.string,
	  nextIcon: _propTypes2.default.node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes2.default.string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2.default.createElement(_Glyphicon2.default, { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2.default.createElement(_Glyphicon2.default, { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3.default)(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3.default)(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	
	    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
	      this.setState({
	        activeIndex: 0,
	        previousActiveIndex: null,
	        direction: null
	      });
	    }
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2.default.count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2.default.count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2.default.count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2.default.createElement(
	      _SafeAnchor2.default,
	      {
	        key: 'prev',
	        className: (0, _classnames2.default)(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2.default.createElement(
	      _SafeAnchor2.default,
	      {
	        key: 'next',
	        className: (0, _classnames2.default)(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2.default.forEach(children, function (child, index) {
	      indicators.push(_react2.default.createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2.default.createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2.default.map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2.default.Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2.default;
	Carousel.Item = _CarouselItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3.default)(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3.default)(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2.default.Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      // eslint-disable-line guard-for-in
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports.default = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _taggedTemplateLiteral2 = __webpack_require__(27);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2; /**
	                     * Copyright 2013-present, Novivia, Inc.
	                     * All rights reserved.
	                     */
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n              ", "\n              ", "\n              ", "\n            "], ["\n              ", "\n              ", "\n              ", "\n            "]);
	
	var _configurations = __webpack_require__(21);
	
	var _FeedbackAlert = __webpack_require__(126);
	
	var _FeedbackAlert2 = _interopRequireDefault(_FeedbackAlert);
	
	var _TimeDifference = __webpack_require__(860);
	
	var _TimeDifference2 = _interopRequireDefault(_TimeDifference);
	
	var _utilities = __webpack_require__(90);
	
	var _utilities2 = _interopRequireDefault(_utilities);
	
	var _Button = __webpack_require__(24);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ButtonGroup = __webpack_require__(790);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _Col = __webpack_require__(22);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Form = __webpack_require__(40);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _HelpBlock = __webpack_require__(455);
	
	var _HelpBlock2 = _interopRequireDefault(_HelpBlock);
	
	var _Panel = __webpack_require__(141);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _Row = __webpack_require__(29);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Table = __webpack_require__(92);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _colorHash = __webpack_require__(1008);
	
	var _colorHash2 = _interopRequireDefault(_colorHash);
	
	var _currency = __webpack_require__(121);
	
	var _datetime = __webpack_require__(143);
	
	var _moment = __webpack_require__(329);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _tempura = __webpack_require__(31);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Combobox = __webpack_require__(2238);
	
	var _Combobox2 = _interopRequireDefault(_Combobox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var computeAskingPrice = _utilities2.default.logic.bidding.computeAskingPrice;
	
	
	var colorHash = new _colorHash2.default();
	
	/**
	 * Absentee bid module.
	 * @class
	 */
	var AbsenteeBidModule = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(AbsenteeBidModule, _Component);
	
	  function AbsenteeBidModule() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AbsenteeBidModule);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AbsenteeBidModule.__proto__ || (0, _getPrototypeOf2.default)(AbsenteeBidModule)).call.apply(_ref, [this].concat(args))), _this), _this.generateBidSuggestions = function () {
	      var bidAmount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      var bidSuggestions = [];
	
	      var currentAmount = Math.max(Number(bidAmount), _this.props.lot.leadingBid && _this.props.lot.leadingBid.amount || 0, _this.props.user.maximumBid + 0.001 || 0, _this.props.user.lastBid + 0.001 || 0);
	      var delta = _this.props.lot.leadingBid && _this.props.lot.leadingBid.amount === currentAmount ? 0 : 0.001;
	      currentAmount = currentAmount ? currentAmount - delta : 0;
	
	      // FIXME: Fix the autocomplete here to allow custom values.
	      for (var i = 0; i < 1000; i++) {
	        currentAmount = computeAskingPrice(currentAmount, _this.props.auction.increments);
	
	        bidSuggestions.push({
	          text: (0, _currency.formatMoney)(currentAmount, _this.props.auction.currency.iso.code),
	          value: currentAmount
	        });
	      }
	
	      return bidSuggestions;
	    }, _this.state = {
	      // Amount of the bid.
	      bidAmount: null,
	
	      // Current number of bids.
	      bidCount: _this.props.lot.bids.length,
	
	      // Alert states.
	      bidErrors: null,
	      bidSuccess: null,
	
	      bidSuggestions: _this.generateBidSuggestions(),
	
	      // Current user has the leading bid.
	      hasLeadingBid: _this.props.lot.leadingBid && _this.props.lot.leadingBid.byCurrentUser,
	
	      // Login modal
	      isLoginModalOpen: false,
	
	      // Are we bidding a maximum? Depends on the bidMode.
	      isMaximumBidding: _this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.STANDARD,
	
	      // Currently leading bid amount.
	      leadingBid: _this.props.lot.leadingBid && _this.props.lot.leadingBid.amount,
	
	      // Relative time difference in seconds.
	      timeUntilStart: (0, _moment2.default)(_this.props.auction.bidEndDate).diff(),
	
	      // User maximum bid
	      userMaximumBid: _this.props.user.maximumBid
	    }, _this.handleInputChange = function (e) {
	      var nextState = {};
	      nextState[e.target.name] = e.target.value;
	      _this.setState(nextState);
	    }, _this.handleMakeBid = function (e) {
	      e.preventDefault();
	
	      var __ = _this.context.__;
	
	
	      if (!_this.state.bidAmount) {
	        return _this.setState({
	          bidErrors: __("errors::bid.invalidAmount"),
	          bidSuccess: null
	        });
	      }
	
	      // Either this is a standard bid or a maximum bid.
	      var makeBid = _this.state.isMaximumBidding ? _this.props.actions.lot.makeMaximumBid : _this.props.actions.lot.makeStandardBid;
	
	      makeBid({
	        auctionId: _this.props.auction.id,
	        bidAmount: _this.state.bidAmount,
	        lotId: _this.props.lot.id
	      }, function (err) {
	        return _this.setState({
	          bidErrors: err || null,
	          bidSuccess: !err
	        });
	      });
	    }, _this.handleToggleMaximumBid = function () {
	      // We can only submit higher maximum bids when we lead.
	      if (_this.state.hasLeadingBid) {
	        return;
	      }
	
	      _this.setState(function (state) {
	        return { isMaximumBidding: !state.isMaximumBidding };
	      });
	    }, _this.nextBid = function (amount) {
	      var incrementLevels = _this.props.auction.increments;
	      var incrementLevel = incrementLevels[0];
	
	      for (var i = 0; i < incrementLevels.length; i++) {
	        if ((i < incrementLevels.length - 1 ? incrementLevels[i + 1].start > amount : true) && incrementLevels[i].start <= amount) {
	          incrementLevel = incrementLevels[i];
	        }
	      }
	
	      return amount + incrementLevel.jump;
	    }, _this.tick = function () {
	      _this.setState({
	        timeUntilStart: (0, _moment2.default)(_this.props.auction.bidEndDate).diff()
	      });
	    }, _this.handleBidAmountChange = function (update) {
	      var bidAmount = Number(typeof update === "string" ? update : update.value) || 0;
	
	      var bidSuggestions = _this.generateBidSuggestions(bidAmount);
	
	      _this.setState({
	        bidAmount: bidAmount || "",
	        bidSuggestions: bidSuggestions
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AbsenteeBidModule, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Show time left with hourly updates unless we're in the last hour.
	      var interval = 60 * 60 * 1000;
	      this.interval = setInterval(this.tick, new Date() - new Date(this.props.auction.bidEndDate) < interval ? 1000 : interval);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearInterval(this.interval);
	    }
	
	    /**
	     * Change the type of bidding (normal bid vs maximum bid)
	     */
	
	
	    /**
	     * Find the next bid with increments for a given amount.
	     */
	
	
	    /**
	     * Relative time with the auction.
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var __ = this.context.__;
	
	      // If bidding is disabled, we simply don't display the bidding component.
	
	      if (this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.NONE) {
	        return null;
	      }
	
	      // The informantion on the bid if we are in standard bid mode.
	      var bidMode = null;
	      var bidInformation = null;
	
	      if (this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.STANDARD) {
	        bidMode = _react2.default.createElement(
	          "span",
	          null,
	          "(",
	          __("auction::bidMode.standard"),
	          ")"
	        );
	        bidInformation = _react2.default.createElement(
	          _Row2.default,
	          null,
	          _react2.default.createElement(
	            _Col2.default,
	            { md: 4 },
	            _react2.default.createElement(
	              "strong",
	              null,
	              this.state.bidCount > 0 ? __("auction::lot.leadingBid") : __("auction::lot.startingBid")
	            )
	          ),
	          _react2.default.createElement(
	            _Col2.default,
	            { md: 8 },
	            _react2.default.createElement(
	              "p",
	              null,
	              (0, _currency.formatMoney)(this.state.bidCount > 0 ? this.state.leadingBid : this.props.lot.startingBid, this.props.auction.currency.iso.code),
	              " ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "(",
	                this.state.bidCount,
	                " ",
	                __("auction::lot.bids"),
	                ")"
	              )
	            )
	          )
	        );
	      } else if (this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.SILENT) {
	        bidMode = _react2.default.createElement(
	          "span",
	          null,
	          "(",
	          __("auction::bidMode.silent"),
	          ")"
	        );
	      }
	
	      var bidding = null;
	      if (this.props.auction.status === _configurations.AE_AUCTION_STATUS.UNPUBLISHED || this.props.auction.status === _configurations.AE_AUCTION_STATUS.PUBLISHED) {
	        bidding = _react2.default.createElement(_FeedbackAlert2.default, {
	          info: __("auction::lot.biddingNotStarted", {
	            startTime: (0, _datetime.localizeDate)({
	              date: this.props.auction.bidStartDate
	            }).date
	          }),
	          permanent: true
	        });
	      } else if (this.props.auction.status === _configurations.AE_AUCTION_STATUS.BIDDING_OVER) {
	        bidding = _react2.default.createElement(_FeedbackAlert2.default, {
	          info: __("auction::lot.biddingOver"),
	          permanent: true
	        });
	      } else if (this.props.auction.status === _configurations.AE_AUCTION_STATUS.ONGOING) {
	        bidding = _react2.default.createElement(_FeedbackAlert2.default, {
	          info: __("auction::ongoing"),
	          permanent: true
	        });
	      } else if (this.props.auction.status === _configurations.AE_AUCTION_STATUS.FINISHED) {
	        bidding = _react2.default.createElement(_FeedbackAlert2.default, {
	          info: __("auction::over"),
	          permanent: true
	        });
	      } else if (this.props.auction.status === _configurations.AE_AUCTION_STATUS.CANCELLED) {
	        bidding = _react2.default.createElement(_FeedbackAlert2.default, {
	          warning: __("auction::cancelled"),
	          permanent: true
	        });
	      } else if (this.state.bidSuccess && this.props.auction.status === _configurations.AE_AUCTION_STATUS.BIDDING) {
	        var registeredBid = (0, _currency.formatMoney)(this.state.bidAmount, this.props.auction.currency.iso.code);
	
	        bidding = _react2.default.createElement(_FeedbackAlert2.default, {
	          success: this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.SILENT ? __("auction::lot.bidRegistered", { amount: registeredBid }) : (0, _tempura.noMultiSpaceAfterLineFeed)(_templateObject, __("auction::lot.bidRegistered", { amount: registeredBid }), " ", __("auction::lot.youHaveLeadingBid")),
	          permanent: true
	        });
	      } else if (this.props.auction.status === _configurations.AE_AUCTION_STATUS.BIDDING) {
	        var maximumBidInformation = this.state.userMaximumBid > 0 ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "strong",
	            null,
	            __("auction::lot.youHaveMaximum") + ": "
	          ),
	          (0, _currency.formatMoney)(this.state.userMaximumBid, this.props.auction.currency.iso.code),
	          _react2.default.createElement("br", null)
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          __("auction::lot.noMaximumSet")
	        );
	
	        var submittedBidInformation = this.props.user.lastBid > 0 ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "strong",
	            null,
	            __("auction::lot.youHaveBidded") + ": "
	          ),
	          (0, _currency.formatMoney)(this.props.user.lastBid, this.props.auction.currency.iso.code),
	          _react2.default.createElement("br", null)
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          __("auction::lot.notBidded")
	        );
	
	        var minimumBid = this.props.lot.minimumBid;
	        if (this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.SILENT) {
	          minimumBid = this.nextBid(this.props.user.lastBid);
	        } else if (this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.STANDARD && this.state.userMaximumBid > 0) {
	          minimumBid = this.nextBid(Math.max(this.state.userMaximumBid, this.state.leadingBid));
	        }
	
	        var bidForm = _react2.default.createElement(
	          _Form2.default,
	          {
	            role: "form",
	            inline: true,
	            onSubmit: this.handleMakeBid
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { marginBottom: 10 } },
	            _react2.default.createElement(
	              _ButtonGroup2.default,
	              { bsSize: "xsmall" },
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  active: !this.state.isMaximumBidding,
	                  bsStyle: !this.state.isMaximumBidding ? "success" : undefined,
	                  disabled: this.state.hasLeadingBid,
	                  onClick: this.handleToggleMaximumBid
	                },
	                __("auction::lot.standardBid")
	              ),
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  active: this.state.isMaximumBidding,
	                  bsStyle: this.state.isMaximumBidding ? "success" : undefined,
	                  onClick: this.handleToggleMaximumBid
	                },
	                __("auction::lot.maximumBid")
	              )
	            )
	          ),
	          _react2.default.createElement(_Combobox2.default, {
	            data: this.state.bidSuggestions,
	            placeholder: this.state.isMaximumBidding ? __("auction::lot.maximumBidAmount") : __("auction::lot.bidAmount"),
	            style: { display: "inline-block" },
	            textField: "text",
	            value: this.state.bidAmount,
	            valueField: "value",
	            onChange: this.handleBidAmountChange
	          }),
	          " ",
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              bsStyle: "success",
	              type: "submit"
	            },
	            __("auction::lot.bid")
	          ),
	          _react2.default.createElement(
	            _HelpBlock2.default,
	            null,
	            "(",
	            __("auction::lot.enterOrMore", {
	              amount: (0, _currency.formatMoney)(minimumBid, this.props.auction.currency.iso.code)
	            }),
	            ")"
	          ),
	          maximumBidInformation || submittedBidInformation || null
	        );
	
	        bidding = _react2.default.createElement(
	          "div",
	          null,
	          bidInformation,
	          _react2.default.createElement(
	            _Row2.default,
	            null,
	            _react2.default.createElement(
	              _Col2.default,
	              { md: 4 },
	              _react2.default.createElement(
	                "strong",
	                null,
	                this.state.isMaximumBidding ? __("auction::lot.makeMaximumBid") : __("auction::lot.makeBid")
	              )
	            ),
	            _react2.default.createElement(
	              _Col2.default,
	              { md: 8 },
	              bidForm
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        _Panel2.default,
	        {
	          header: _react2.default.createElement(
	            "h3",
	            null,
	            __("auction::lot.bidding"),
	            " ",
	            _react2.default.createElement(
	              "small",
	              null,
	              bidMode
	            )
	          )
	        },
	        _react2.default.createElement(
	          _Row2.default,
	          null,
	          _react2.default.createElement(
	            _Col2.default,
	            { md: 12 },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_FeedbackAlert2.default, {
	                errors: this.state.bidErrors,
	                info: this.state.hasLeadingBid ? __("auction::lot.nowLeadingBid") : null,
	                warning: this.props.user.overbidded ? __("auction::lot.overBidded") : null,
	                permanent: true
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Row2.default,
	          null,
	          _react2.default.createElement(
	            _Col2.default,
	            { md: 4 },
	            _react2.default.createElement(
	              "strong",
	              null,
	              __("auction::lot.endTime"),
	              ": "
	            )
	          ),
	          _react2.default.createElement(
	            _Col2.default,
	            { md: 8 },
	            _react2.default.createElement(
	              "p",
	              null,
	              (0, _datetime.localizeDate)({ date: this.props.auction.bidEndDate }).date,
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "small",
	                null,
	                "(",
	                _react2.default.createElement(
	                  _TimeDifference2.default,
	                  { targetDate: this.props.auction.bidEndDate },
	                  _react2.default.createElement(
	                    _TimeDifference2.default.Before,
	                    null,
	                    _react2.default.createElement(_TimeDifference2.default.Display, { noWords: true }),
	                    " ",
	                    __("general::left")
	                  ),
	                  _react2.default.createElement(
	                    _TimeDifference2.default.After,
	                    null,
	                    _react2.default.createElement(_TimeDifference2.default.Display, null)
	                  )
	                ),
	                ")"
	              )
	            )
	          )
	        ),
	        bidding,
	        this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.STANDARD ? _react2.default.createElement(
	          _Panel2.default,
	          {
	            bsStyle: "success",
	            header: __("lot::bidHistory"),
	            style: { marginTop: 10 },
	            collapsible: true
	          },
	          _react2.default.createElement(
	            _Table2.default,
	            { fill: true, striped: true },
	            _react2.default.createElement(
	              "thead",
	              null,
	              _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  __("general::date")
	                ),
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  __("general::bidder")
	                ),
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  __("general::amount")
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "tbody",
	              null,
	              this.props.lot.bids.map(function (_ref2, index) {
	                var amount = _ref2.amount,
	                    byCurrentUser = _ref2.byCurrentUser,
	                    date = _ref2.date,
	                    user = _ref2.user;
	                return _react2.default.createElement(
	                  "tr",
	                  {
	                    className: byCurrentUser ? "info" : undefined,
	                    key: index
	                  },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    (0, _moment2.default)(date).fromNow()
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(
	                      "span",
	                      { style: { color: colorHash.hex(user) } },
	                      __("general::buyer"),
	                      " ",
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        __("general::numberShort"),
	                        user
	                      )
	                    ),
	                    byCurrentUser ? _react2.default.createElement(
	                      "small",
	                      { className: "text-italic" },
	                      " (" + __("general::you") + ")"
	                    ) : null
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    (0, _currency.formatMoney)(amount, _this2.props.auction.currency.iso.code)
	                  )
	                );
	              }).reverse()
	            )
	          )
	        ) : null
	      );
	    }
	  }]);
	  return AbsenteeBidModule;
	}(_react.Component), _class.propTypes = {
	  // Actions
	  actions: _propTypes2.default.object.isRequired,
	
	  // Auction information
	  auction: _propTypes2.default.shape({
	    // Date that bidding ends.
	    bidEndDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,
	
	    // Bid mode of the auction.
	    bidMode: _propTypes2.default.oneOf(_configurations.AE_AUCTION_BID_MODE.getValues()).isRequired,
	
	    // Date that bidding starts.
	    bidStartDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,
	
	    // Currency information for that auction.
	    currency: _propTypes2.default.shape({
	      // ISO 4247 information.
	      iso: _propTypes2.default.shape({
	        code: _propTypes2.default.string.isRequired
	      }).isRequired,
	
	      // Major and minor units of the currency with their symbols.
	      units: _propTypes2.default.shape({
	        major: _propTypes2.default.shape({
	          symbol: _propTypes2.default.string.isRequired
	        }),
	        minor: _propTypes2.default.shape({
	          symbol: _propTypes2.default.string.isRequired
	        })
	      }).isRequired
	    }),
	
	    // Different levels of increments.
	    increments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      jump: _propTypes2.default.number.isRequired,
	      start: _propTypes2.default.number.isRequired
	    }).isRequired).isRequired,
	
	    // Status of the auction.
	    status: _propTypes2.default.oneOf(_configurations.AE_AUCTION_STATUS.getValues()).isRequired
	  }).isRequired,
	
	  lot: _propTypes2.default.shape({
	    // Number of bids on that lot.
	    bidCount: _propTypes2.default.number.isRequired,
	
	    // ID of the current lot.
	    id: _propTypes2.default.string.isRequired,
	
	    // Leading bid information.
	    leadingBid: _propTypes2.default.shape({
	      // Amount of the leading bid.
	      amount: _propTypes2.default.number.isRequired,
	
	      // Whether the current user is the leader.
	      byCurrentUser: _propTypes2.default.string.isRequired,
	
	      // Id of the leading bid.
	      id: _propTypes2.default.string.isRequired
	    }),
	
	    // Minimum bid on that lot.
	    minimumBid: _propTypes2.default.number.isRequired,
	
	    // Starting bid on that lot.
	    startingBid: _propTypes2.default.number.isRequired,
	
	    // Status of the auction.
	    status: _propTypes2.default.oneOf(_configurations.AE_LOT_STATUS.getValues()).isRequired
	  }).isRequired,
	
	  user: _propTypes2.default.shape({
	    // User Id if he's logged in.
	    id: _propTypes2.default.string,
	
	    // Last bid amount of the user
	    lastBid: _propTypes2.default.number,
	
	    // Maximum bid amount of logged in user.
	    maximumBid: _propTypes2.default.number,
	
	    // Are we currently overbidded?
	    overbidded: _propTypes2.default.bool.isRequired
	  }).isRequired
	}, _class.contextTypes = {
	  // Translation utility.
	  __: _propTypes2.default.func.isRequired
	}, _temp2);
	exports.default = AbsenteeBidModule;
	module.exports = exports["default"];

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class2, _temp3; /**
	                      * Copyright 2013-present, Novivia, Inc.
	                      * All rights reserved.
	                      */
	
	var _Carousel = __webpack_require__(656);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _CarouselItem = __webpack_require__(508);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RETRY_INTERVAL = 100;
	var MAX_RETRIES = 5;
	var PLACEHOLDER_URL = ("//s3.amazonaws.com/auctionex-website/assets/img/placeholder_common.jpg") || "//s3.amazonaws.com/auctionex-website/assets/img/placeholder_common.jpg";
	
	var LotImage = function (_Component) {
	  (0, _inherits3.default)(LotImage, _Component);
	
	  function LotImage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, LotImage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LotImage.__proto__ || (0, _getPrototypeOf2.default)(LotImage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      retries: 0
	    }, _this.handleImageError = function (e) {
	      var target = e.target;
	      _this.setState(function (_ref2) {
	        var retries = _ref2.retries;
	        return { retries: retries + 1 };
	      }, function () {
	        var retries = _this.state.retries;
	        var url = _this.props.url;
	
	
	        if (retries > MAX_RETRIES) {
	          target.src = PLACEHOLDER_URL;
	        } else {
	          setTimeout(function () {
	            target.src = _this.getFullUrl(url) + "?retry=" + _this.state.retries;
	          }, RETRY_INTERVAL);
	        }
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	  // FIXME: Add propTypes.
	
	  (0, _createClass3.default)(LotImage, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.url !== this.props.url) {
	        this.setState({ retries: 0 });
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.url !== this.props.url;
	    }
	  }, {
	    key: "getFullUrl",
	    value: function getFullUrl(url) {
	      if (!url) {
	        return PLACEHOLDER_URL;
	      }
	
	      return "//" + url;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          url = _props.url,
	          responsiveHeight = _props.responsiveHeight,
	          onLoad = _props.onLoad;
	
	
	      return _react2.default.createElement("img", {
	        src: this.getFullUrl(url),
	        className: (0, _classnames2.default)({
	          "img-rounded": true,
	          "img-responsive": !responsiveHeight,
	          "lot-picture-img": true,
	          "lot-picture-img-vertical": responsiveHeight
	        }),
	        onLoad: onLoad,
	        onError: this.handleImageError
	        // alt={"Picture #" + index + " of lot " + lotId}
	      });
	    }
	  }]);
	  return LotImage;
	}(_react.Component);
	
	/**
	 * Responsive picture/pictures of a lot.
	 * @class
	 */
	
	
	var LotPicture = (_temp3 = _class2 = function (_Component2) {
	  (0, _inherits3.default)(LotPicture, _Component2);
	
	  function LotPicture() {
	    var _ref3;
	
	    var _temp2, _this2, _ret2;
	
	    (0, _classCallCheck3.default)(this, LotPicture);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = LotPicture.__proto__ || (0, _getPrototypeOf2.default)(LotPicture)).call.apply(_ref3, [this].concat(args))), _this2), _this2.renderPlaceHolder = function () {
	      var responsiveHeight = _this2.props.responsiveHeight;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: responsiveHeight ? "max-height" : "" },
	        _this2.renderImage()
	      );
	    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
	  }
	
	  (0, _createClass3.default)(LotPicture, [{
	    key: "renderImage",
	
	
	    /**
	     * Own methods
	     */
	
	    /**
	     * Generate the markup necessary to render one image.
	     * @param  {string} url   Index of the image to render.
	     * @return {ReactElement} React component of the image markup.
	     */
	    value: function renderImage(url) {
	      var _props2 = this.props,
	          responsiveHeight = _props2.responsiveHeight,
	          onLoad = _props2.onLoad;
	
	      // FIXME: Currently a placeholder image.
	
	      return _react2.default.createElement(LotImage, { responsiveHeight: responsiveHeight, url: url, onLoad: onLoad });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          pictures = _props3.pictures,
	          size = _props3.size,
	          responsiveHeight = _props3.responsiveHeight,
	          props = (0, _objectWithoutProperties3.default)(_props3, ["pictures", "size", "responsiveHeight"]);
	
	      // No picture? Return a placeholder.
	
	      if (!pictures) {
	        return this.renderPlaceHolder();
	      }
	
	      var pictureList = pictures.filter(function (picture) {
	        return !!picture[size];
	      });
	
	      // No medium pictures? Return a placeholder.
	      if (pictureList.length === 0) {
	        return this.renderPlaceHolder();
	      }
	
	      // Only return a simple image if there's only one picture for the lot.
	      if (pictureList.length === 1) {
	        return _react2.default.createElement(
	          "div",
	          { className: responsiveHeight ? "max-height" : "" },
	          this.renderImage(pictureList[0][size])
	        );
	      }
	
	      // Map images to carousel elements if there are many pictures for the lot.
	      return _react2.default.createElement(
	        _Carousel2.default,
	        (0, _extends3.default)({}, props, {
	          className: (0, _classnames2.default)({
	            "lot-pictures": true,
	            "lot-pictures-responsive-height": responsiveHeight
	          })
	        }),
	        pictureList.map(function (picture) {
	          return _react2.default.createElement(
	            _CarouselItem2.default,
	            { className: "lot-pictures-item" },
	            _this3.renderImage(picture[size])
	          );
	        })
	      );
	    }
	  }]);
	  return LotPicture;
	}(_react.Component), _class2.propTypes = {
	  // List of pictures to display for this lot.
	  pictures: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    // URL of medium-sized picture.
	    md: _propTypes2.default.string
	  })).isRequired,
	
	  // If true, the image responsiveness will be applied using the height rather
	  // than the width.
	  responsiveHeight: _propTypes2.default.bool,
	
	  // Size to use for the images.
	  size: _propTypes2.default.string
	}, _class2.defaultProps = {
	  size: "md"
	}, _temp3);
	exports.default = LotPicture;
	module.exports = exports["default"];

/***/ }),

/***/ 860:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.TimeDifferenceBefore = exports.TimeDifferenceAfter = exports.TimeDifferenceString = exports.TimeDifferenceDisplay = undefined;
	
	var _map = __webpack_require__(257);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _getIterator2 = __webpack_require__(151);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _slicedToArray2 = __webpack_require__(591);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp, _class2, _temp2, _class3, _temp3, _class4, _temp4, _class5, _temp6; /**
	                                                                                        * Copyright 2013-present, Novivia, Inc.
	                                                                                        * All rights reserved.
	                                                                                        */
	
	var _moment = __webpack_require__(329);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeDifferenceDisplay = exports.TimeDifferenceDisplay = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(TimeDifferenceDisplay, _Component);
	
	  function TimeDifferenceDisplay() {
	    (0, _classCallCheck3.default)(this, TimeDifferenceDisplay);
	    return (0, _possibleConstructorReturn3.default)(this, (TimeDifferenceDisplay.__proto__ || (0, _getPrototypeOf2.default)(TimeDifferenceDisplay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TimeDifferenceDisplay, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	  return TimeDifferenceDisplay;
	}(_react.Component), _class.__isTimeDifferenceDisplay = true, _temp);
	var TimeDifferenceString = exports.TimeDifferenceString = (_temp2 = _class2 = function (_Component2) {
	  (0, _inherits3.default)(TimeDifferenceString, _Component2);
	
	  function TimeDifferenceString() {
	    (0, _classCallCheck3.default)(this, TimeDifferenceString);
	    return (0, _possibleConstructorReturn3.default)(this, (TimeDifferenceString.__proto__ || (0, _getPrototypeOf2.default)(TimeDifferenceString)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TimeDifferenceString, [{
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.Children.map(this.props.children, function (child) {
	          // TODO: use context in 0.14.
	          if (child && child.type && child.type.__isTimeDifferenceDisplay) {
	            return _this3.props.renderTimeDifference(child.props.noWords);
	          }
	
	          return child;
	        })
	      );
	    }
	  }]);
	  return TimeDifferenceString;
	}(_react.Component), _class2.propTypes = {
	  // Any type of children is accepted, but some will get interpolated based on
	  // the time difference.
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node.isRequired, _propTypes2.default.arrayOf(_propTypes2.default.node.isRequired).isRequired]),
	
	  // Time difference, only for retransmission.
	  renderTimeDifference: _propTypes2.default.func
	}, _temp2);
	var TimeDifferenceAfter = exports.TimeDifferenceAfter = (_temp3 = _class3 = function (_TimeDifferenceString) {
	  (0, _inherits3.default)(TimeDifferenceAfter, _TimeDifferenceString);
	
	  function TimeDifferenceAfter() {
	    (0, _classCallCheck3.default)(this, TimeDifferenceAfter);
	    return (0, _possibleConstructorReturn3.default)(this, (TimeDifferenceAfter.__proto__ || (0, _getPrototypeOf2.default)(TimeDifferenceAfter)).apply(this, arguments));
	  }
	
	  return TimeDifferenceAfter;
	}(TimeDifferenceString), _class3.__isTimeDifferenceAfter = true, _temp3);
	var TimeDifferenceBefore = exports.TimeDifferenceBefore = (_temp4 = _class4 = function (_TimeDifferenceString2) {
	  (0, _inherits3.default)(TimeDifferenceBefore, _TimeDifferenceString2);
	
	  function TimeDifferenceBefore() {
	    (0, _classCallCheck3.default)(this, TimeDifferenceBefore);
	    return (0, _possibleConstructorReturn3.default)(this, (TimeDifferenceBefore.__proto__ || (0, _getPrototypeOf2.default)(TimeDifferenceBefore)).apply(this, arguments));
	  }
	
	  return TimeDifferenceBefore;
	}(TimeDifferenceString), _class4.__isTimeDifferenceBefore = true, _temp4);
	var TimeDifference = (_temp6 = _class5 = function (_Component3) {
	  (0, _inherits3.default)(TimeDifference, _Component3);
	
	  function TimeDifference() {
	    var _ref;
	
	    var _temp5, _this6, _ret;
	
	    (0, _classCallCheck3.default)(this, TimeDifference);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp5 = (_this6 = (0, _possibleConstructorReturn3.default)(this, (_ref = TimeDifference.__proto__ || (0, _getPrototypeOf2.default)(TimeDifference)).call.apply(_ref, [this].concat(args))), _this6), _this6.targetDate = (0, _moment2.default)(new Date(_this6.props.targetDate)), _this6.tick = function (initialRender) {
	      var diff = _this6.targetDate.diff();
	      _this6.setState({ diff: diff });
	
	      if (!initialRender) {
	        setTimeout(_this6.tick, _this6.getNextTimerInterval(diff));
	      }
	    }, _this6.interpolateChild = function (child) {
	      return (0, _react.cloneElement)(child, {
	        renderTimeDifference: _this6.renderTimeDifference
	      });
	    }, _this6.renderTimeDifference = function () {
	      var noWords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this6.props.noWords;
	
	      return _this6.targetDate.fromNow(noWords);
	    }, _temp5), (0, _possibleConstructorReturn3.default)(_this6, _ret);
	  }
	
	  // See: http://momentjs.com/docs/#/displaying/fromnow/
	
	
	  // Utility children components that can be interpolated.
	
	
	  (0, _createClass3.default)(TimeDifference, [{
	    key: "componentWillMount",
	
	
	    /*
	     * Calculate the initial difference with the date. (Both client & server)
	     */
	    value: function componentWillMount() {
	      this.tick(true);
	    }
	
	    /*
	     * Start the refresh difference + schedule timer update sequence.
	     */
	
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.tick();
	    }
	
	    /*
	     * Determines the maximum amount of time (in milliseconds) that we can wait
	     * before the next render, knowing the render wouldn't be different if we did
	     * it again before that moment.
	     */
	
	  }, {
	    key: "getNextTimerInterval",
	    value: function getNextTimerInterval(diff) {
	      var absDiff = Math.abs(diff);
	      var lastGoodInterval = void 0;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(TimeDifference.TIME_INTERVALS), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _ref2 = _step.value;
	
	          var _ref3 = (0, _slicedToArray3.default)(_ref2, 2);
	
	          var interval = _ref3[0];
	          var jump = _ref3[1];
	
	          // Find in-between which intervals we are.
	          if (absDiff <= interval) {
	            // Before first interval.
	            if (!lastGoodInterval) {
	              return jump;
	            }
	
	            // Depending on whether we are going away (up) from a date in the past,
	            // or going towards (down) a date in the future, set the timer such that
	            // the next time it updates should be when the string output by Moment
	            // is different from the current one.
	            return diff > 0 ? jump - absDiff % jump : Math.min(jump, absDiff - lastGoodInterval);
	          }
	
	          lastGoodInterval = interval;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	
	    /*
	     * Updates the diff for the target date and schedules the next tick.
	     */
	
	
	    /*
	     * Takes an existing ReactElement and rerenders it with the
	     * `timeDifferenceString` property.
	     */
	
	
	    /*
	     * Renders the time difference as a human-readable string.
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this7 = this;
	
	      // No children, just render the time difference into a span.
	      if (_react2.default.Children.count(this.props.children) === 0) {
	        return _react2.default.createElement(
	          "span",
	          null,
	          this.renderTimeDifference()
	        );
	      }
	
	      // Replace children we need to (TimeDifferenceAfter/TimeDifferenceBefore),
	      // don't change others.
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.Children.map(this.props.children, function (child) {
	          // TODO: use context in 0.14.
	          if (child && child.type) {
	            if (child.type.__isTimeDifferenceAfter) {
	              if (_this7.state.diff < 0) {
	                return _this7.interpolateChild(child);
	              }
	
	              return null;
	            } else if (child.type.__isTimeDifferenceBefore) {
	              if (_this7.state.diff >= 0) {
	                return _this7.interpolateChild(child);
	              }
	
	              return null;
	            }
	          }
	
	          return child;
	        })
	      );
	    }
	  }]);
	  return TimeDifference;
	}(_react.Component), _class5.propTypes = {
	  // Any type of children is accepted, but some will get interpolated based on
	  // the time difference.
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node.isRequired, _propTypes2.default.arrayOf(_propTypes2.default.node.isRequired).isRequired]),
	
	  // If true, Moment will not render words like "in" or "ago".
	  noWords: _propTypes2.default.bool,
	
	  // Date to calculate difference against.
	  targetDate: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(Date).isRequired, _propTypes2.default.string.isRequired]).isRequired
	}, _class5.TIME_INTERVALS = new _map2.default([
	// Up to 45 seconds, 1 second intervals.
	[45 * 1000, 1 * 1000],
	
	// Up to 45 minutes, 1 minute intervals.
	[45 * 60 * 1000, 60 * 1000],
	
	// Up to 22 hours, 1 hour intervals.
	[22 * 60 * 60 * 1000, 60 * 60 * 1000],
	
	// Up to 25 days, 1 day intervals.
	[25 * 24 * 60 * 60 * 1000, 24 * 60 * 60 * 1000],
	
	// Everything above, 24 day intervals.
	[Infinity, 24 * 24 * 60 * 60 * 1000]]), _class5.Display = TimeDifferenceDisplay, _class5.After = TimeDifferenceAfter, _class5.Before = TimeDifferenceBefore, _temp6);
	exports.default = TimeDifference;

/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _taggedTemplateLiteral2 = __webpack_require__(27);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /**
	                    * Copyright 2013-present, Novivia, Inc.
	                    * All rights reserved.
	                    */
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n                    https://www.google.com/maps/embed/v1/place?key=AIzaSyDY1d5SL506REZ3LnIbs-uDwJrTatajxig\n                    &q=", "\n                    ", "\n                    +", "\n                    +", "\n                    +", "\n                    +", "\n                    &zoom=10\n                  "], ["\n                    https://www.google.com/maps/embed/v1/place?key=AIzaSyDY1d5SL506REZ3LnIbs-uDwJrTatajxig\n                    &q=", "\n                    ", "\n                    +", "\n                    +", "\n                    +", "\n                    +", "\n                    &zoom=10\n                  "]);
	
	var _Col = __webpack_require__(22);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Row = __webpack_require__(29);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Tab = __webpack_require__(399);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _Tabs = __webpack_require__(401);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _reactFlags = __webpack_require__(250);
	
	var _reactFlags2 = _interopRequireDefault(_reactFlags);
	
	var _tempura = __webpack_require__(31);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuctionInformationTabs = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(AuctionInformationTabs, _Component);
	
	  function AuctionInformationTabs() {
	    (0, _classCallCheck3.default)(this, AuctionInformationTabs);
	    return (0, _possibleConstructorReturn3.default)(this, (AuctionInformationTabs.__proto__ || (0, _getPrototypeOf2.default)(AuctionInformationTabs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AuctionInformationTabs, [{
	    key: "render",
	    value: function render() {
	      var __ = this.context.__;
	      var _props = this.props,
	          assetsUrl = _props.assetsUrl,
	          countryCC2 = _props.countryCC2,
	          countryName = _props.countryName,
	          description = _props.description,
	          auctionLocation = _props.auctionLocation,
	          shipping = _props.shipping,
	          taxes = _props.taxes,
	          terms = _props.terms;
	
	
	      return _react2.default.createElement(
	        _Tabs2.default,
	        { defaultActiveKey: "tab-description", id: "auction-information" },
	        _react2.default.createElement(
	          _Tab2.default,
	          {
	            eventKey: "tab-description",
	            title: __("auction::catalog.description")
	          },
	          description ? _react2.default.createElement("div", {
	            dangerouslySetInnerHTML: { __html: description }
	          }) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              __("general::noDescription")
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Tab2.default,
	          {
	            eventKey: "tab-location",
	            title: __("auction::catalog.location")
	          },
	          _react2.default.createElement(
	            _Row2.default,
	            null,
	            _react2.default.createElement(
	              _Col2.default,
	              { md: 4 },
	              _react2.default.createElement(
	                "address",
	                null,
	                auctionLocation.address[0] || null,
	                auctionLocation.address[1] || null,
	                _react2.default.createElement("br", null),
	                auctionLocation.city,
	                ",",
	                _react2.default.createElement("br", null),
	                auctionLocation.region,
	                ",",
	                " " + auctionLocation.postalCode,
	                _react2.default.createElement("br", null),
	                countryName + " ",
	                _react2.default.createElement(_reactFlags2.default, {
	                  country: countryCC2,
	                  pngSize: 16,
	                  shiny: true,
	                  basePath: assetsUrl + "/img/flags"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _Col2.default,
	              { md: 8 },
	              _react2.default.createElement(
	                "div",
	                { className: "flexible-container" },
	                _react2.default.createElement("iframe", {
	                  width: 600,
	                  height: 450,
	                  frameBorder: 0,
	                  style: { border: 0 },
	                  src: (0, _tempura.noWhitespace)(_templateObject, auctionLocation.address[0], auctionLocation.address[1] ? "+" + auctionLocation.address[1] : "", auctionLocation.city, auctionLocation.region, auctionLocation.postalCode, countryName)
	                })
	              )
	            )
	          )
	        ),
	        taxes.length ? _react2.default.createElement(
	          _Tab2.default,
	          {
	            eventKey: "tab-taxes",
	            title: __("general::taxes")
	          },
	          __("general::taxes")
	        ) : null,
	        shipping ? _react2.default.createElement(
	          _Tab2.default,
	          {
	            eventKey: "tab-shipping",
	            title: __("general::shipping")
	          },
	          _react2.default.createElement("div", {
	            dangerouslySetInnerHTML: { __html: shipping }
	          })
	        ) : null,
	        terms ? _react2.default.createElement(
	          _Tab2.default,
	          {
	            eventKey: "tab-terms",
	            title: __("general::terms")
	          },
	          _react2.default.createElement("div", {
	            dangerouslySetInnerHTML: { __html: terms }
	          })
	        ) : null
	      );
	    }
	  }]);
	  return AuctionInformationTabs;
	}(_react.Component), _class.propTypes = {
	  // Base URL for static assets.
	  assetsUrl: _propTypes2.default.string.isRequired,
	
	  // The location of the auction.
	  auctionLocation: _propTypes2.default.shape({
	    address: _propTypes2.default.array.isRequired,
	    city: _propTypes2.default.string.isRequired,
	    country: _propTypes2.default.string.isRequired,
	    postalCode: _propTypes2.default.string.isRequired,
	    region: _propTypes2.default.string.isRequired
	  }),
	
	  // The CC2 code for the country of the organization.
	  countryCC2: _propTypes2.default.string.isRequired,
	
	  // The organisation country.
	  countryName: _propTypes2.default.string.isRequired,
	
	  // The description associated with the auction.
	  description: _propTypes2.default.string.isRequired,
	
	  shipping: _propTypes2.default.string.isRequired,
	
	  // The taxes associated with this auction.
	  taxes: _propTypes2.default.array.isRequired,
	
	  // The terms associated with this auction.
	  terms: _propTypes2.default.string.isRequired
	}, _class.contextTypes = {
	  __: _propTypes2.default.func.isRequired
	}, _temp);
	exports.default = AuctionInformationTabs;
	module.exports = exports["default"];

/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Body = exports.Header = undefined;
	
	var _taggedTemplateLiteral2 = __webpack_require__(27);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp, _class2, _temp2; /**
	                                     * Copyright 2013-present, Novivia, Inc.
	                                     * All rights reserved.
	                                     */
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n              /", "\n              /", "\n              /", "\n              /", "\n              #lot", "\n            "], ["\n              /", "\n              /", "\n              /", "\n              /", "\n              #lot", "\n            "]),
	    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n                  /", "\n                  /", "\n                  /", "\n                  /", "\n                  /", "\n                  /", "\n                "], ["\n                  /", "\n                  /", "\n                  /", "\n                  /", "\n                  /", "\n                  /", "\n                "]);
	
	var _AbsenteeBidModule = __webpack_require__(841);
	
	var _AbsenteeBidModule2 = _interopRequireDefault(_AbsenteeBidModule);
	
	var _AcceptedPaymentMethods = __webpack_require__(581);
	
	var _AcceptedPaymentMethods2 = _interopRequireDefault(_AcceptedPaymentMethods);
	
	var _BidIncrementsEditor = __webpack_require__(477);
	
	var _BidIncrementsEditor2 = _interopRequireDefault(_BidIncrementsEditor);
	
	var _LotPicture = __webpack_require__(853);
	
	var _LotPicture2 = _interopRequireDefault(_LotPicture);
	
	var _LotStatusLabel = __webpack_require__(409);
	
	var _LotStatusLabel2 = _interopRequireDefault(_LotStatusLabel);
	
	var _ShareBar = __webpack_require__(577);
	
	var _ShareBar2 = _interopRequireDefault(_ShareBar);
	
	var _WatchButton = __webpack_require__(410);
	
	var _WatchButton2 = _interopRequireDefault(_WatchButton);
	
	var _AuctionInformationTabs = __webpack_require__(901);
	
	var _AuctionInformationTabs2 = _interopRequireDefault(_AuctionInformationTabs);
	
	var _authentication = __webpack_require__(254);
	
	var _Button = __webpack_require__(24);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ButtonToolbar = __webpack_require__(155);
	
	var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);
	
	var _Col = __webpack_require__(22);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Grid = __webpack_require__(104);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Label = __webpack_require__(97);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _PageHeader = __webpack_require__(25);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Pager = __webpack_require__(2148);
	
	var _Pager2 = _interopRequireDefault(_Pager);
	
	var _Panel = __webpack_require__(141);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _Row = __webpack_require__(29);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Table = __webpack_require__(92);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _security = __webpack_require__(36);
	
	var _reactFa = __webpack_require__(30);
	
	var _reactFa2 = _interopRequireDefault(_reactFa);
	
	var _reactFlags = __webpack_require__(250);
	
	var _reactFlags2 = _interopRequireDefault(_reactFlags);
	
	var _datetime = __webpack_require__(143);
	
	var _tempura = __webpack_require__(31);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lot = __webpack_require__(335);
	
	var _configurations = __webpack_require__(21);
	
	var _utilities = __webpack_require__(90);
	
	var _utilities2 = _interopRequireDefault(_utilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = _utilities2.default.formats.url;
	var Header = exports.Header = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(Header, _Component);
	
	  function Header() {
	    (0, _classCallCheck3.default)(this, Header);
	    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Header, [{
	    key: "render",
	    value: function render() {
	      var __ = this.context.__;
	      var _props = this.props,
	          assetsUrl = _props.assetsUrl,
	          auctionCountryCC2 = _props.auctionCountryCC2,
	          auctionName = _props.auctionName,
	          lotRank = _props.lotRank,
	          orgFriendlyId = _props.orgFriendlyId,
	          orgName = _props.orgName,
	          shortAuctionId = _props.shortAuctionId;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "span",
	          { className: "pull-right" },
	          auctionCountryCC2 ? _react2.default.createElement(_reactFlags2.default, {
	            basePath: assetsUrl + "/img/flags",
	            country: auctionCountryCC2,
	            pngSize: 48,
	            shiny: true
	          }) : null
	        ),
	        _react2.default.createElement(
	          _PageHeader2.default,
	          { className: "auctionHeader" },
	          _react2.default.createElement(
	            "a",
	            { href: (0, _tempura.noWhitespace)(_templateObject, __("routes::seller"), orgFriendlyId, __("routes::catalog"), shortAuctionId, lotRank)
	            },
	            (0, _security.decodeEntities)(auctionName) + " "
	          ),
	          _react2.default.createElement(
	            "small",
	            null,
	            __("general::by") + " ",
	            _react2.default.createElement(
	              "a",
	              { href: "/" + __("routes::seller") + "/" + orgFriendlyId },
	              (0, _security.decodeEntities)(orgName)
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Header;
	}(_react.Component), _class.propTypes = {
	  // Base URL for static assets.
	  assetsUrl: _propTypes2.default.string.isRequired,
	
	  // The CC2 code for the country of the organization.
	  auctionCountryCC2: _propTypes2.default.string.isRequired,
	
	  // The auction name.
	  auctionName: _propTypes2.default.string.isRequired,
	
	  // The rank of the lot in the list.
	  lotRank: _propTypes2.default.number.isRequired,
	
	  // The ID of the seller.
	  orgFriendlyId: _propTypes2.default.string.isRequired,
	
	  // The seller's name output to the screen.
	  orgName: _propTypes2.default.string.isRequired,
	
	  // The auction ID.
	  shortAuctionId: _propTypes2.default.string.isRequired
	}, _class.contextTypes = {
	  __: _propTypes2.default.func.isRequired
	}, _temp);
	var Body = exports.Body = (_temp2 = _class2 = function (_Component2) {
	  (0, _inherits3.default)(Body, _Component2);
	
	  function Body() {
	    (0, _classCallCheck3.default)(this, Body);
	    return (0, _possibleConstructorReturn3.default)(this, (Body.__proto__ || (0, _getPrototypeOf2.default)(Body)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Body, [{
	    key: "render",
	    value: function render() {
	      var __ = this.context.__;
	      var _props2 = this.props,
	          assetsUrl = _props2.assetsUrl,
	          auctionBidEndDate = _props2.auctionBidEndDate,
	          auctionBidMode = _props2.auctionBidMode,
	          auctionBidStartDate = _props2.auctionBidStartDate,
	          auctionCountryCC2 = _props2.auctionCountryCC2,
	          auctionCountryName = _props2.auctionCountryName,
	          auctionCurrency = _props2.auctionCurrency,
	          auctionDescription = _props2.auctionDescription,
	          auctionId = _props2.auctionId,
	          auctionIncrements = _props2.auctionIncrements,
	          auctionLiveOngoing = _props2.auctionLiveOngoing,
	          auctionLocation = _props2.auctionLocation,
	          auctionPaymentMethods = _props2.auctionPaymentMethods,
	          auctionPremium = _props2.auctionPremium,
	          auctionShipping = _props2.auctionShipping,
	          auctionStartDate = _props2.auctionStartDate,
	          auctionStatus = _props2.auctionStatus,
	          auctionTaxes = _props2.auctionTaxes,
	          auctionTerms = _props2.auctionTerms,
	          auctionType = _props2.auctionType,
	          csrfToken = _props2.csrfToken,
	          itemDescription = _props2.itemDescription,
	          itemDetails = _props2.itemDetails,
	          itemName = _props2.itemName,
	          itemPictures = _props2.itemPictures,
	          loggedin = _props2.loggedin,
	          lotBids = _props2.lotBids,
	          lotId = _props2.lotId,
	          lotLeadingBid = _props2.lotLeadingBid,
	          lotMinimumBid = _props2.lotMinimumBid,
	          lotName = _props2.lotName,
	          lotRank = _props2.lotRank,
	          lotStartingBid = _props2.lotStartingBid,
	          lotStatus = _props2.lotStatus,
	          nextLot = _props2.nextLot,
	          orgFriendlyId = _props2.orgFriendlyId,
	          orgUrl = _props2.orgUrl,
	          overbidded = _props2.overbidded,
	          previousLot = _props2.previousLot,
	          shortAuctionId = _props2.shortAuctionId,
	          underApproval = _props2.underApproval,
	          userId = _props2.userId,
	          userLastBid = _props2.userLastBid,
	          userMaximumBid = _props2.userMaximumBid,
	          userWatchesLot = _props2.userWatchesLot;
	
	
	      var localizedAuctionDate = (0, _datetime.localizeDate)({ date: auctionStartDate });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "auctionHeader" },
	          _react2.default.createElement(
	            _Grid2.default,
	            { fluid: true },
	            _react2.default.createElement(
	              _Row2.default,
	              null,
	              _react2.default.createElement(
	                _Col2.default,
	                { md: 6 },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  __("auction::catalog.subheaderInformation") + " ",
	                  localizedAuctionDate.date,
	                  _react2.default.createElement(
	                    "small",
	                    null,
	                    " " + localizedAuctionDate.timezone
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _Col2.default,
	                { className: "text-right", md: 6 },
	                _react2.default.createElement(
	                  _Row2.default,
	                  null,
	                  _react2.default.createElement(
	                    _ButtonToolbar2.default,
	                    { className: "pull-right" },
	                    auctionLiveOngoing ? _react2.default.createElement(
	                      _Button2.default,
	                      {
	                        bsSize: "xs",
	                        bsStyle: "success",
	                        href: url(orgUrl, { auctionId: auctionId, orgFriendlyId: orgFriendlyId })
	                      },
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        _react2.default.createElement(_reactFa2.default, { name: "play" }),
	                        " " + __("auction::catalog.joinLive")
	                      )
	                    ) : null,
	                    _react2.default.createElement(_WatchButton2.default, {
	                      actions: {
	                        lot: {
	                          unwatch: _lot.unwatch,
	                          watch: (0, _authentication.bindIfLoggedIn)(csrfToken, _lot.watch)
	                        }
	                      },
	                      loggedin: loggedin,
	                      lotId: lotId,
	                      type: "lot",
	                      watched: userWatchesLot || false
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { id: "lotPage" },
	          _react2.default.createElement(
	            _Pager2.default,
	            null,
	            previousLot ? _react2.default.createElement(
	              _Pager2.default.Item,
	              {
	                href: (0, _tempura.noWhitespace)(_templateObject2, __("routes::seller"), orgFriendlyId, __("routes::auction"), shortAuctionId, __("routes::lot"), previousLot),
	                previous: true
	              },
	              "\u2190 ",
	              __("auction::lot.previousLot")
	            ) : null,
	            nextLot ? _react2.default.createElement(
	              _Pager2.default.Item,
	              {
	                href: (0, _tempura.noWhitespace)(_templateObject2, __("routes::seller"), orgFriendlyId, __("routes::auction"), shortAuctionId, __("routes::lot"), nextLot),
	                next: true
	              },
	              __("auction::lot.nextLot"),
	              " \u2192"
	            ) : null
	          ),
	          _react2.default.createElement(
	            _Row2.default,
	            null,
	            _react2.default.createElement(
	              _Col2.default,
	              { md: 9 },
	              _react2.default.createElement(
	                "h3",
	                null,
	                __("terminology::terms.lot.term") + " # " + lotRank,
	                " - " + (0, _security.decodeEntities)(itemName) + " ",
	                lotStatus !== _configurations.AE_LOT_STATUS.OPEN ? _react2.default.createElement(_LotStatusLabel2.default, {
	                  status: lotStatus
	                }) : null,
	                underApproval ? _react2.default.createElement(
	                  "small",
	                  { className: "text-warning" },
	                  __("lot::underApproval.name").toUpperCase()
	                ) : null
	              )
	            ),
	            _react2.default.createElement(
	              _Col2.default,
	              { md: 3 },
	              _react2.default.createElement(
	                "div",
	                { className: "pull-right" },
	                _react2.default.createElement(_ShareBar2.default, {
	                  shared: __("lot::shareThis"),
	                  title: lotName
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Row2.default,
	            null,
	            _react2.default.createElement(
	              _Col2.default,
	              { md: 5 },
	              _react2.default.createElement(_LotPicture2.default, {
	                pictures: itemPictures.map(function (_ref) {
	                  var thumbnails = _ref.thumbnails;
	                  return thumbnails;
	                })
	              }),
	              _react2.default.createElement(
	                _Panel2.default,
	                { header: _react2.default.createElement(
	                    "h3",
	                    null,
	                    __("auction::catalog.description")
	                  ) },
	                itemDescription ? _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: itemDescription } }) : _react2.default.createElement(
	                  "p",
	                  null,
	                  __("auction::catalog.noDescription"),
	                  "."
	                )
	              ),
	              _react2.default.createElement(
	                _Panel2.default,
	                {
	                  header: _react2.default.createElement(
	                    "h3",
	                    null,
	                    __("auction::lot.paymentAndPremiums")
	                  )
	                },
	                _react2.default.createElement(
	                  "h6",
	                  null,
	                  __("organization::buyerPremium") + " ",
	                  _react2.default.createElement(
	                    _Label2.default,
	                    {
	                      title: __("terminology::terms.buyerPremium.definition")
	                    },
	                    "?"
	                  )
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  auctionPremium,
	                  "%"
	                ),
	                _react2.default.createElement(_AcceptedPaymentMethods2.default, {
	                  paymentMethods: auctionPaymentMethods
	                }),
	                _react2.default.createElement(
	                  "h6",
	                  null,
	                  __("auction::lot.currency")
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  auctionCurrency.name + " ",
	                  auctionCurrency.units.major.symbol || null
	                )
	              ),
	              _react2.default.createElement(
	                _Panel2.default,
	                {
	                  header: _react2.default.createElement(
	                    "h3",
	                    null,
	                    __("auction::lot.incrementsTable")
	                  )
	                },
	                _react2.default.createElement(_BidIncrementsEditor2.default, {
	                  currencyType: auctionCurrency.iso.code,
	                  highlightCurrentBid: lotLeadingBid && lotLeadingBid.amount,
	                  increments: auctionIncrements,
	                  readOnly: true
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _Col2.default,
	              { md: 7 },
	              auctionBidMode !== _configurations.AE_AUCTION_BID_MODE.NONE ? _react2.default.createElement(_AbsenteeBidModule2.default, {
	                actions: {
	                  lot: {
	                    makeMaximumBid: _lot.makeMaximumBid,
	                    makeStandardBid: _lot.makeStandardBid
	                  }
	                },
	                auction: {
	                  bidEndDate: auctionBidEndDate,
	                  bidMode: auctionBidMode,
	                  bidStartDate: auctionBidStartDate,
	                  currency: auctionCurrency,
	                  id: auctionId,
	                  increments: auctionIncrements,
	                  startDate: auctionStartDate,
	                  status: auctionStatus,
	                  type: auctionType
	                },
	                lot: {
	                  bids: lotBids,
	                  id: lotId,
	                  leadingBid: lotLeadingBid,
	                  minimumBid: lotMinimumBid,
	                  startingBid: lotStartingBid,
	                  status: lotStatus
	                },
	                user: {
	                  id: userId,
	                  lastBid: userLastBid,
	                  maximumBid: userMaximumBid,
	                  overbidded: overbidded
	                }
	              }) : null,
	              itemDetails && itemDetails.length > 0 ? _react2.default.createElement(
	                _Panel2.default,
	                {
	                  className: "offer",
	                  header: _react2.default.createElement(
	                    "h3",
	                    null,
	                    __("auction::lot.lotDetails")
	                  )
	                },
	                _react2.default.createElement(
	                  _Table2.default,
	                  { striped: true },
	                  _react2.default.createElement(
	                    "thead",
	                    null,
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "th",
	                        null,
	                        __("auction::lot.key")
	                      ),
	                      _react2.default.createElement(
	                        "th",
	                        null,
	                        __("auction::lot.value")
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "tbody",
	                    null,
	                    itemDetails.map(function (itemDetail, index) {
	                      return _react2.default.createElement(
	                        "tr",
	                        { key: index },
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          itemDetail.key
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          itemDetail.value
	                        )
	                      );
	                    })
	                  )
	                )
	              ) : null,
	              _react2.default.createElement(
	                _Panel2.default,
	                {
	                  className: "auctionInformation",
	                  header: _react2.default.createElement(
	                    "h3",
	                    null,
	                    __("auction::lot.auctionInformation")
	                  )
	                },
	                _react2.default.createElement(_AuctionInformationTabs2.default, {
	                  assetsUrl: assetsUrl,
	                  auctionLocation: auctionLocation,
	                  countryCC2: auctionCountryCC2,
	                  countryName: auctionCountryName,
	                  description: auctionDescription,
	                  shipping: auctionShipping,
	                  taxes: auctionTaxes,
	                  terms: auctionTerms
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Body;
	}(_react.Component), _class2.propTypes = {
	  // Base URL for static assets.
	  assetsUrl: _propTypes2.default.string.isRequired,
	
	  // The time the bidding period end.
	  auctionBidEndDate: _propTypes2.default.string.isRequired,
	
	  // The number indicating the bid mode.
	  auctionBidMode: _propTypes2.default.number.isRequired,
	
	  // The time the bidding period start.
	  auctionBidStartDate: _propTypes2.default.string.isRequired,
	
	  // The CC2 code for the country of the organization.
	  auctionCountryCC2: _propTypes2.default.string.isRequired,
	
	  // The organisation country.
	  auctionCountryName: _propTypes2.default.string.isRequired,
	
	  // The current currency of the auction.
	  auctionCurrency: _propTypes2.default.shape({
	    iso: _propTypes2.default.shape({
	      code: _propTypes2.default.string.isRequired,
	      number: _propTypes2.default.string.isRequired
	    }).isRequired,
	    name: _propTypes2.default.string.isRequired,
	    units: _propTypes2.default.shape({
	      major: _propTypes2.default.shape({
	        name: _propTypes2.default.string.isRequired,
	        symbol: _propTypes2.default.string.isRequired
	      }).isRequired,
	      minor: _propTypes2.default.shape({
	        majorValue: _propTypes2.default.number.isRequired,
	        name: _propTypes2.default.string.isRequired,
	        symbol: _propTypes2.default.string.isRequired
	      }).isRequired
	    }).isRequired
	  }).isRequired,
	
	  // The description associated with the auction.
	  auctionDescription: _propTypes2.default.string.isRequired,
	
	  // The ID of the auction.
	  auctionId: _propTypes2.default.string.isRequired,
	
	  // List of possible incrementation.
	  auctionIncrements: _propTypes2.default.array.isRequired,
	
	  // Boolean indicating if auction is live or not.
	  auctionLiveOngoing: _propTypes2.default.bool,
	
	  // The location of the auction.
	  auctionLocation: _propTypes2.default.shape({
	    address: _propTypes2.default.array.isRequired,
	    city: _propTypes2.default.string.isRequired,
	    country: _propTypes2.default.string.isRequired,
	    postalCode: _propTypes2.default.string.isRequired,
	    region: _propTypes2.default.string.isRequired
	  }),
	
	  // The different payment methods available for the auction.
	  auctionPaymentMethods: _propTypes2.default.array.isRequired,
	
	  auctionPremium: _propTypes2.default.number.isRequired,
	
	  auctionShipping: _propTypes2.default.string.isRequired,
	
	  // The start date of the auction.
	  auctionStartDate: _propTypes2.default.string.isRequired,
	
	  // The status of the auction.
	  auctionStatus: _propTypes2.default.number.isRequired,
	
	  // The taxes associated with this auction.
	  auctionTaxes: _propTypes2.default.array.isRequired,
	
	  // The terms associated with this auction.
	  auctionTerms: _propTypes2.default.string.isRequired,
	
	  // The auction type.
	  auctionType: _propTypes2.default.number.isRequired,
	
	  // Prevent xss attack.
	  csrfToken: _propTypes2.default.string.isRequired,
	
	  // The raw html auction item description.
	  itemDescription: _propTypes2.default.string.isRequired,
	
	  // The different details of an item.
	  itemDetails: _propTypes2.default.array,
	
	  // The item name.
	  itemName: _propTypes2.default.string.isRequired,
	
	  // The different pictures associated with this item.
	  itemPictures: _propTypes2.default.array.isRequired,
	
	  // The different bids made on this item.
	  lotBids: _propTypes2.default.array.isRequired,
	
	  // The id of the lot.
	  lotId: _propTypes2.default.string.isRequired,
	
	  // The details of the leading bid.
	  lotLeadingBid: _propTypes2.default.shape({
	    amount: _propTypes2.default.number.isRequired,
	    date: _propTypes2.default.string.isRequired,
	    id: _propTypes2.default.string.isRequired,
	    user: _propTypes2.default.string.isRequired
	  }),
	
	  // The minimum amount a buyer has to make to bid on the lot item.
	  lotMinimumBid: _propTypes2.default.number.isRequired,
	
	  // The rank of the lot in the list.
	  lotRank: _propTypes2.default.number.isRequired,
	
	  // The opening bid on an item.
	  lotStartingBid: _propTypes2.default.number.isRequired,
	
	  // The lot status.
	  lotStatus: _propTypes2.default.number.isRequired,
	
	  // The ID of the next lot item.
	  nextLot: _propTypes2.default.string.isRequired,
	
	  // The ID of the seller.
	  orgFriendlyId: _propTypes2.default.string.isRequired,
	
	  // The live auction url.
	  orgUrl: _propTypes2.default.string.isRequired,
	
	  // Bool indicating when this user has been overbidded by another user.
	  overbidded: _propTypes2.default.bool.isRequired,
	
	  // The ID of the previous lot item.
	  previousLot: _propTypes2.default.string.isRequired,
	
	  // The auction ID.
	  shortAuctionId: _propTypes2.default.string.isRequired,
	
	  // Whether the current lot is under approval.
	  underApproval: _propTypes2.default.bool,
	
	  // The current user ID.
	  userId: _propTypes2.default.string,
	
	  // The auth user last bid.
	  userLastBid: _propTypes2.default.number.isRequired,
	
	  userMaximumBid: _propTypes2.default.number.isRequired,
	
	  // Indicating if the user currently watch this lot.
	  userWatchesLot: _propTypes2.default.bool.isRequired
	}, _class2.defaultProps = {
	  auctionLiveOngoing: false
	}, _class2.contextTypes = {
	  __: _propTypes2.default.func.isRequired
	}, _temp2);

/***/ }),

/***/ 1007:
/***/ (function(module, exports) {

	/**
	 * BKDR Hash (modified version)
	 *
	 * @param {String} str string to hash
	 * @returns {Number}
	 */
	var BKDRHash = function(str) {
	    var seed = 131;
	    var seed2 = 137;
	    var hash = 0;
	    // make hash more sensitive for short string like 'a', 'b', 'c'
	    str += 'x';
	    // Note: Number.MAX_SAFE_INTEGER equals 9007199254740991
	    var MAX_SAFE_INTEGER = parseInt(9007199254740991 / seed2);
	    for(var i = 0; i < str.length; i++) {
	        if(hash > MAX_SAFE_INTEGER) {
	            hash = parseInt(hash / seed2);
	        }
	        hash = hash * seed + str.charCodeAt(i);
	    }
	    return hash;
	};
	
	module.exports = BKDRHash;


/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

	var BKDRHash = __webpack_require__(1007);
	
	/**
	 * Convert RGB Array to HEX
	 *
	 * @param {Array} RGBArray - [R, G, B]
	 * @returns {String} 6 digits hex starting with #
	 */
	var RGB2HEX = function(RGBArray) {
	    var hex = '#';
	    RGBArray.forEach(function(value) {
	        if (value < 16) {
	            hex += 0;
	        }
	        hex += value.toString(16);
	    });
	    return hex;
	};
	
	/**
	 * Convert HSL to RGB
	 *
	 * @see {@link http://zh.wikipedia.org/wiki/HSL和HSV色彩空间} for further information.
	 * @param {Number} H Hue ∈ [0, 360)
	 * @param {Number} S Saturation ∈ [0, 1]
	 * @param {Number} L Lightness ∈ [0, 1]
	 * @returns {Array} R, G, B ∈ [0, 255]
	 */
	var HSL2RGB = function(H, S, L) {
	    H /= 360;
	
	    var q = L < 0.5 ? L * (1 + S) : L + S - L * S;
	    var p = 2 * L - q;
	
	    return [H + 1/3, H, H - 1/3].map(function(color) {
	        if(color < 0) {
	            color++;
	        }
	        if(color > 1) {
	            color--;
	        }
	        if(color < 1/6) {
	            color = p + (q - p) * 6 * color;
	        } else if(color < 0.5) {
	            color = q;
	        } else if(color < 2/3) {
	            color = p + (q - p) * 6 * (2/3 - color);
	        } else {
	            color = p;
	        }
	        return Math.round(color * 255);
	    });
	};
	
	/**
	 * Color Hash Class
	 *
	 * @class
	 */
	var ColorHash = function(options) {
	    options = options || {};
	
	    var LS = [options.lightness, options.saturation].map(function(param) {
	        param = param || [0.35, 0.5, 0.65]; // note that 3 is a prime
	        return Object.prototype.toString.call(param) === '[object Array]' ? param.concat() : [param];
	    });
	
	    this.L = LS[0];
	    this.S = LS[1];
	
	    this.hash = options.hash || BKDRHash;
	};
	
	/**
	 * Returns the hash in [h, s, l].
	 * Note that H ∈ [0, 360); S ∈ [0, 1]; L ∈ [0, 1];
	 *
	 * @param {String} str string to hash
	 * @returns {Array} [h, s, l]
	 */
	ColorHash.prototype.hsl = function(str) {
	    var H, S, L;
	    var hash = this.hash(str);
	
	    H = hash % 359; // note that 359 is a prime
	    hash = parseInt(hash / 360);
	    S = this.S[hash % this.S.length];
	    hash = parseInt(hash / this.S.length);
	    L = this.L[hash % this.L.length];
	
	    return [H, S, L];
	};
	
	/**
	 * Returns the hash in [r, g, b].
	 * Note that R, G, B ∈ [0, 255]
	 *
	 * @param {String} str string to hash
	 * @returns {Array} [r, g, b]
	 */
	ColorHash.prototype.rgb = function(str) {
	    var hsl = this.hsl(str);
	    return HSL2RGB.apply(this, hsl);
	};
	
	/**
	 * Returns the hash in hex
	 *
	 * @param {String} str string to hash
	 * @returns {String} hex with #
	 */
	ColorHash.prototype.hex = function(str) {
	    var rgb = this.rgb(str);
	    return RGB2HEX(rgb);
	};
	
	module.exports = ColorHash;


/***/ }),

/***/ 2148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PagerItem = __webpack_require__(2149);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(101);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(87);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onSelect: _propTypes2.default.func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3.default)(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3.default)(this, Pager);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'ul',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2.default.Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ }),

/***/ 2149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(9);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(105);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(101);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  previous: _propTypes2.default.bool,
	  next: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  eventKey: _propTypes2.default.any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3.default)(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3.default)(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2.default.createElement(
	      'li',
	      {
	        className: (0, _classnames2.default)(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2.default.Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports.default = PagerItem;
	module.exports = exports['default'];

/***/ }),

/***/ 2238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _desc, _value, _obj;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(122);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(180);
	
	var _3 = _interopRequireDefault(_2);
	
	var _filter = __webpack_require__(565);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _Widget = __webpack_require__(518);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Popup = __webpack_require__(819);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Select = __webpack_require__(2247);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _ComboboxInput = __webpack_require__(2239);
	
	var _ComboboxInput2 = _interopRequireDefault(_ComboboxInput);
	
	var _compat = __webpack_require__(251);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _propTypes3 = __webpack_require__(243);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _List = __webpack_require__(563);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListGroupable = __webpack_require__(517);
	
	var _ListGroupable2 = _interopRequireDefault(_ListGroupable);
	
	var _validateListInterface = __webpack_require__(523);
	
	var _validateListInterface2 = _interopRequireDefault(_validateListInterface);
	
	var _uncontrollable = __webpack_require__(244);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _dataHelpers = __webpack_require__(386);
	
	var _interaction = __webpack_require__(382);
	
	var _widgetHelpers = __webpack_require__(333);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var defaultSuggest = function defaultSuggest(f) {
	  return f === true ? 'startsWith' : f ? f : 'eq';
	};
	
	var propTypes = _extends({}, _Popup2.default.propTypes, {
	
	  //-- controlled props -----------
	  value: _propTypes2.default.any,
	  onChange: _propTypes2.default.func,
	  open: _propTypes2.default.bool,
	  onToggle: _propTypes2.default.func,
	  //------------------------------------
	
	  itemComponent: _propTypes4.default.elementType,
	  listComponent: _propTypes4.default.elementType,
	
	  groupComponent: _propTypes4.default.elementType,
	  groupBy: _propTypes4.default.accessor,
	
	  data: _propTypes2.default.array,
	  valueField: _propTypes2.default.string,
	  textField: _propTypes4.default.accessor,
	  name: _propTypes2.default.string,
	
	  onSelect: _propTypes2.default.func,
	
	  autoFocus: _propTypes2.default.bool,
	  disabled: _propTypes4.default.disabled.acceptsArray,
	  readOnly: _propTypes4.default.readOnly.acceptsArray,
	
	  suggest: _propTypes4.default.filter,
	  filter: _propTypes4.default.filter,
	
	  busy: _propTypes2.default.bool,
	
	  dropUp: _propTypes2.default.bool,
	  duration: _propTypes2.default.number,
	  delay: _propTypes2.default.number,
	
	  placeholder: _propTypes2.default.string,
	
	  'aria-labelledby': _propTypes2.default.string,
	  'aria-describedby': _propTypes2.default.string,
	
	  messages: _propTypes2.default.shape({
	    open: _propTypes4.default.message,
	    emptyList: _propTypes4.default.message,
	    emptyFilter: _propTypes4.default.message
	  })
	});
	
	var ComboBox = (0, _createReactClass2.default)((_obj = {
	
	  displayName: 'ComboBox',
	
	  mixins: [__webpack_require__(473), __webpack_require__(2252), __webpack_require__(821), __webpack_require__(522), __webpack_require__(344)('input'), __webpack_require__(519)({
	    willHandle: function willHandle(focused) {
	      // not suggesting anymore
	      !focused && this.refs.input.accept();
	    },
	    didHandle: function didHandle(focused) {
	      if (!focused) this.close();
	    }
	  })],
	
	  propTypes: propTypes,
	
	  getInitialState: function getInitialState() {
	    var _props = this.props,
	        value = _props.value,
	        data = _props.data,
	        valueField = _props.valueField,
	        items = this.process(data, value),
	        idx = (0, _dataHelpers.dataIndexOf)(items, value, valueField);
	
	
	    return {
	      selectedItem: items[idx],
	      focusedItem: items[!~idx ? 0 : idx],
	      processedData: items,
	      open: false
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      data: [],
	      value: '',
	      open: false,
	      suggest: false,
	      filter: false,
	      delay: 500,
	
	      messages: msgs(),
	      ariaActiveDescendantKey: 'combobox'
	    };
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.refs.list && (0, _validateListInterface2.default)(this.refs.list);
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    var isSuggesting = this.refs.input && this.refs.input.isSuggesting(),
	        stateChanged = !_3.default.isShallowEqual(nextState, this.state),
	        valueChanged = !_3.default.isShallowEqual(nextProps, this.props);
	
	    return isSuggesting || stateChanged || valueChanged;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var value = nextProps.value,
	        data = nextProps.data,
	        valueField = nextProps.valueField,
	        textField = nextProps.textField;
	
	
	    var rawIdx = (0, _dataHelpers.dataIndexOf)(data, value, valueField),
	        valueItem = rawIdx === -1 ? nextProps.value : nextProps.data[rawIdx],
	        isSuggesting = this.refs.input && this.refs.input.isSuggesting();
	
	    var items = this.process(nextProps.data, nextProps.value, (rawIdx === -1 || isSuggesting) && (0, _dataHelpers.dataText)(valueItem, textField));
	
	    var idx = (0, _dataHelpers.dataIndexOf)(items, value, valueField),
	        focused = this.filterIndexOf(items, (0, _dataHelpers.dataText)(valueItem, textField));
	
	    this._searchTerm = '';
	
	    this.setState({
	      processedData: items,
	      selectedItem: items[idx],
	      focusedItem: items[idx === -1 ? focused !== -1 ? focused : 0 // focus the closest match
	      : idx]
	    });
	  },
	  renderInput: function renderInput(listID) {
	    var _props2 = this.props,
	        suggest = _props2.suggest,
	        filter = _props2.filter,
	        textField = _props2.textField,
	        busy = _props2.busy,
	        name = _props2.name,
	        data = _props2.data,
	        value = _props2.value,
	        valueField = _props2.valueField,
	        autoFocus = _props2.autoFocus,
	        tabIndex = _props2.tabIndex,
	        disabled = _props2.disabled,
	        readOnly = _props2.readOnly,
	        placeholder = _props2.placeholder,
	        open = _props2.open,
	        ariaLabelledby = _props2['aria-labelledby'],
	        ariaDescribedby = _props2['aria-describedby'];
	
	
	    var valueItem = (0, _dataHelpers.dataItem)(data, value, valueField); // take value from the raw data
	
	    var completeType = suggest ? filter ? 'both' : 'inline' : filter ? 'list' : '';
	
	    return _react2.default.createElement(_ComboboxInput2.default, {
	      ref: 'input',
	      id: (0, _widgetHelpers.instanceId)(this, '_input'),
	      autoFocus: autoFocus,
	      tabIndex: tabIndex,
	      suggest: suggest,
	      name: name,
	      role: 'combobox',
	      disabled: disabled,
	      readOnly: readOnly,
	      'aria-owns': listID,
	      'aria-busy': !!busy,
	      'aria-autocomplete': completeType,
	      'aria-expanded': open,
	      'aria-haspopup': true,
	      'aria-describedby': ariaDescribedby,
	      'aria-labelledby': ariaLabelledby,
	      placeholder: placeholder,
	      value: (0, _dataHelpers.dataText)(valueItem, textField),
	      onChange: this.handleInputChange,
	      onKeyDown: this.handleInputKeyDown
	    });
	  },
	  renderList: function renderList(List, id, messages) {
	    var _props3 = this.props,
	        open = _props3.open,
	        data = _props3.data;
	    var _state = this.state,
	        selectedItem = _state.selectedItem,
	        focusedItem = _state.focusedItem;
	
	
	    var listProps = _3.default.pickProps(this.props, List);
	    var items = this._data();
	
	    return _react2.default.createElement(List, _extends({ ref: 'list'
	    }, listProps, {
	      id: id,
	      data: items,
	      selected: selectedItem,
	      focused: focusedItem,
	      'aria-hidden': !open,
	      'aria-labelledby': (0, _widgetHelpers.instanceId)(this),
	      'aria-live': open && 'polite',
	      onSelect: this.handleSelect,
	      onMove: this._scrollTo,
	      messages: {
	        emptyList: data.length ? messages.emptyFilter : messages.emptyList
	      }
	    }));
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props4 = this.props,
	        className = _props4.className,
	        duration = _props4.duration,
	        groupBy = _props4.groupBy,
	        messages = _props4.messages,
	        busy = _props4.busy,
	        dropUp = _props4.dropUp,
	        open = _props4.open,
	        List = _props4.listComponent;
	    var focused = this.state.focused;
	
	
	    var disabled = (0, _interaction.isDisabled)(this.props),
	        readOnly = (0, _interaction.isReadOnly)(this.props),
	        listID = (0, _widgetHelpers.instanceId)(this, '_listbox');
	
	    List = List || groupBy && _ListGroupable2.default || _List2.default;
	
	    var elementProps = _3.default.omitOwnProps(this, List);
	    var shouldRenderPopup = open || (0, _widgetHelpers.isFirstFocusedRender)(this);
	
	    messages = msgs(messages);
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        open: open,
	        dropUp: dropUp,
	        focused: focused,
	        disabled: disabled,
	        readOnly: readOnly,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        className: (0, _classnames2.default)(className, 'rw-combobox')
	      }),
	      _react2.default.createElement(_Select2.default, {
	        onClick: this.toggle,
	        disabled: !!(disabled || readOnly),
	        busy: busy,
	        icon: 'caret-down',
	        label: _3.default.result(messages.open, this.props)
	      }),
	      this.renderInput(listID),
	      shouldRenderPopup && _react2.default.createElement(
	        _Popup2.default,
	        {
	          open: open,
	          dropUp: dropUp,
	          duration: duration,
	          onOpening: function onOpening() {
	            return _this.refs.list.forceUpdate();
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.renderList(List, listID, messages)
	        )
	      )
	    );
	  },
	  handleSelect: function handleSelect(data) {
	    this.close();
	    (0, _widgetHelpers.notify)(this.props.onSelect, data);
	    this.change(data);
	    this.focus();
	  },
	  handleInputKeyDown: function handleInputKeyDown(e) {
	    this._deleting = e.key === 'Backspace' || e.key === 'Delete';
	    this._isTyping = true;
	  },
	  handleInputChange: function handleInputChange(e) {
	    var _props5 = this.props,
	        data = _props5.data,
	        textField = _props5.textField;
	
	
	    var shouldSuggest = !!this.props.suggest,
	        strVal = e.target.value,
	        suggestion;
	
	    suggestion = this._deleting || !shouldSuggest ? strVal : this.suggest(this._data(), strVal);
	
	    suggestion = suggestion || strVal;
	
	    data = _3.default.find(data, function (item) {
	      return (0, _dataHelpers.dataText)(item, textField).toLowerCase() === suggestion.toLowerCase();
	    });
	
	    this.change(!this._deleting && data ? data : strVal, true);
	
	    this.open();
	  },
	  focus: function focus() {
	    this.refs.input && this.refs.input.focus();
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var self = this,
	        key = e.key,
	        alt = e.altKey,
	        list = this.refs.list,
	        focusedItem = this.state.focusedItem,
	        selectedItem = this.state.selectedItem,
	        isOpen = this.props.open;
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	    if (e.defaultPrevented) return;
	
	    if (key === 'End') {
	      if (isOpen) this.setState({ focusedItem: list.last() });else select(list.last(), true);
	    } else if (key === 'Home') {
	      if (isOpen) this.setState({ focusedItem: list.first() });else select(list.first(), true);
	    } else if (key === 'Escape' && isOpen) this.close();else if (key === 'Enter' && isOpen) {
	      e.preventDefault();
	      select(this.state.focusedItem, true);
	    } else if (key === 'ArrowDown') {
	      if (alt) this.open();else {
	        if (isOpen) this.setState({ focusedItem: list.next(focusedItem) });else select(list.next(selectedItem), true);
	      }
	    } else if (key === 'ArrowUp') {
	      if (alt) this.close();else {
	        if (isOpen) this.setState({ focusedItem: list.prev(focusedItem) });else select(list.prev(selectedItem), true);
	      }
	    }
	
	    function select(item, fromList) {
	      if (!item) return self.change(_compat2.default.findDOMNode(self.refs.input).value, false);
	
	      self.refs.input.accept(true); //removes caret
	
	      if (fromList) return self.handleSelect(item);
	
	      self.change(item, false);
	    }
	  },
	  change: function change(data, typing) {
	    this._typedChange = !!typing;
	    (0, _widgetHelpers.notify)(this.props.onChange, data);
	  },
	  open: function open() {
	    if (!this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, true);
	  },
	  close: function close() {
	    if (this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, false);
	  },
	  toggle: function toggle() {
	    this.focus();
	
	    this.props.open ? this.close() : this.open();
	  },
	  suggest: function suggest(data, value) {
	    var _props6 = this.props,
	        textField = _props6.textField,
	        suggest = _props6.suggest,
	        minLength = _props6.minLength;
	
	
	    var word = (0, _dataHelpers.dataText)(value, textField),
	        suggestion;
	
	    suggest = defaultSuggest(suggest);
	
	    if (!(word || '').trim() || word.length < (minLength || 1)) return '';
	
	    suggestion = typeof value === 'string' ? _3.default.find(data, getFilter(suggest, word, textField)) : value;
	
	    if (suggestion && (!this.state || !this.state.deleting)) return (0, _dataHelpers.dataText)(suggestion, textField);
	
	    return '';
	  },
	  _data: function _data() {
	    return this.state.processedData;
	  },
	  process: function process(data, values, searchTerm) {
	    if (this.props.filter && searchTerm) data = this.filter(data, searchTerm);
	
	    return data;
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleSelect', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleSelect'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj), _applyDecoratedDescriptor(_obj, 'toggle', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'toggle'), _obj)), _obj));
	
	exports.default = (0, _uncontrollable2.default)(ComboBox, { open: 'onToggle', value: 'onChange' }, ['focus']);
	
	
	function msgs(msgs) {
	  return _extends({
	    open: 'open combobox',
	    emptyList: 'There are no items in this list',
	    emptyFilter: 'The filter returned no results'
	  }, msgs);
	}
	
	function getFilter(suggest, word, textField) {
	  return typeof suggest === 'string' ? function (item) {
	    return _filter2.default[suggest]((0, _dataHelpers.dataText)(item, textField).toLowerCase(), word.toLowerCase());
	  } : function (item) {
	    return suggest(item, word);
	  };
	}
	module.exports = exports['default'];

/***/ }),

/***/ 2239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(122);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _2 = __webpack_require__(180);
	
	var _3 = _interopRequireDefault(_2);
	
	var _caret = __webpack_require__(2253);
	
	var _caret2 = _interopRequireDefault(_caret);
	
	var _compat = __webpack_require__(251);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _Input = __webpack_require__(818);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'ComboboxInput',
	
	  propTypes: {
	    value: _propTypes2.default.string,
	    suggest: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func.isRequired
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    var input = _compat2.default.findDOMNode(this),
	        val = this.props.value;
	
	    if (this.isSuggesting()) {
	      var start = val.toLowerCase().indexOf(this._last.toLowerCase()) + this._last.length,
	          end = val.length - start;
	
	      if (start >= 0) {
	        (0, _caret2.default)(input, start, start + end);
	      }
	    }
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: ''
	    };
	  },
	  render: function render() {
	    var _props = this.props,
	        onKeyDown = _props.onKeyDown,
	        props = _objectWithoutProperties(_props, ['onKeyDown']);
	
	    delete props.suggest;
	
	    return _react2.default.createElement(_Input2.default, _extends({}, props, {
	      onKeyDown: onKeyDown,
	      onChange: this.handleChange
	    }));
	  },
	  isSuggesting: function isSuggesting() {
	    var val = this.props.value,
	        isSuggestion = this._last != null && val.toLowerCase().indexOf(this._last.toLowerCase()) !== -1;
	
	    return this.props.suggest && isSuggestion;
	  },
	  accept: function accept(removeCaret) {
	    var val = _compat2.default.findDOMNode(this).value || '',
	        end = val.length;
	
	    this._last = null;
	    removeCaret && (0, _caret2.default)(_compat2.default.findDOMNode(this), end, end);
	  },
	  handleChange: function handleChange(e) {
	    var val = e.target.value,
	        pl = !!this.props.placeholder;
	
	    // IE fires input events when setting/unsetting placeholders.
	    // issue #112
	    if (pl && !val && val === (this.props.value || '')) return;
	
	    this._last = val;
	    this.props.onChange(e, val);
	  },
	  focus: function focus() {
	    _compat2.default.findDOMNode(this).focus();
	  }
	});
	module.exports = exports['default'];

/***/ }),

/***/ 2247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(561);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Select = function (_React$Component) {
	  _inherits(Select, _React$Component);
	
	  function Select() {
	    _classCallCheck(this, Select);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Select.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['className']);
	
	    return _react2.default.createElement(_Button2.default, _extends({}, props, {
	      className: (0, _classnames2.default)(className, 'rw-select')
	    }));
	  };
	
	  return Select;
	}(_react2.default.Component);
	
	exports.default = Select;
	module.exports = exports['default'];

/***/ }),

/***/ 2252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _filter = __webpack_require__(565);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _propTypes3 = __webpack_require__(243);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _dataHelpers = __webpack_require__(386);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dflt = function dflt(f) {
	  return f === true ? 'startsWith' : f ? f : 'eq';
	};
	
	module.exports = {
	
	  propTypes: {
	    data: _propTypes2.default.array,
	    value: _propTypes2.default.any,
	    filter: _propTypes4.default.filter,
	    caseSensitive: _propTypes2.default.bool,
	    minLength: _propTypes2.default.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      caseSensitive: false,
	      minLength: 1
	    };
	  },
	  filterIndexOf: function filterIndexOf(items, searchTerm) {
	    var idx = -1,
	        matches = typeof this.props.filter === 'function' ? this.props.filter : getFilter(_filter2.default[dflt(this.props.filter)], searchTerm, this);
	
	    if (!searchTerm || !searchTerm.trim() || this.props.filter && searchTerm.length < (this.props.minLength || 1)) return -1;
	
	    items.every(function (item, i) {
	      if (matches(item, searchTerm, i)) return idx = i, false;
	
	      return true;
	    });
	
	    return idx;
	  },
	  filter: function filter(items, searchTerm) {
	    var matches = typeof this.props.filter === 'string' ? getFilter(_filter2.default[this.props.filter], searchTerm, this) : this.props.filter;
	
	    if (!matches || !searchTerm || !searchTerm.trim() || searchTerm.length < (this.props.minLength || 1)) return items;
	
	    return items.filter(function (item, idx) {
	      return matches(item, searchTerm, idx);
	    });
	  }
	};
	
	function getFilter(matcher, searchTerm, ctx) {
	  searchTerm = !ctx.props.caseSensitive ? searchTerm.toLowerCase() : searchTerm;
	
	  return function (item) {
	    var val = (0, _dataHelpers.dataText)(item, ctx.props.textField);
	
	    if (!ctx.props.caseSensitive) val = val.toLowerCase();
	
	    return matcher(val, searchTerm);
	  };
	}

/***/ }),

/***/ 2253:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = caret;
	/*eslint-disable no-empty */
	function caret(el, start, end) {
	  if (start === undefined) return get(el);
	
	  set(el, start, end);
	}
	
	function get(el) {
	  var start, end, rangeEl, clone;
	
	  if (el.selectionStart !== undefined) {
	    start = el.selectionStart;
	    end = el.selectionEnd;
	  } else {
	    try {
	      el.focus();
	      rangeEl = el.createTextRange();
	      clone = rangeEl.duplicate();
	
	      rangeEl.moveToBookmark(document.selection.createRange().getBookmark());
	      clone.setEndPoint('EndToStart', rangeEl);
	
	      start = clone.text.length;
	      end = start + rangeEl.text.length;
	    } catch (e) {/* not focused or not visible */}
	  }
	
	  return { start: start, end: end };
	}
	
	function set(el, start, end) {
	  var rangeEl;
	
	  try {
	    if (el.selectionStart !== undefined) {
	      el.focus();
	      el.setSelectionRange(start, end);
	    } else {
	      el.focus();
	      rangeEl = el.createTextRange();
	      rangeEl.collapse(true);
	      rangeEl.moveStart('character', start);
	      rangeEl.moveEnd('character', end - start);
	      rangeEl.select();
	    }
	  } catch (e) {/* not focused or not visible */}
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// lot.b40a51c7fc6f664af803.bundle.js